[
  {
    "TITULO": "Aguascalientes",
    "UBICACION_GEOGRAFICA": "01"
  },
  {
    "TITULO": "Aguascalientes, Aguascalientes",
    "UBICACION_GEOGRAFICA": "01001"
  },
  {
    "TITULO": "Asientos",
    "UBICACION_GEOGRAFICA": "01002"
  },
  {
    "TITULO": "Calvillo",
    "UBICACION_GEOGRAFICA": "01003"
  },
  {
    "TITULO": "Cosío",
    "UBICACION_GEOGRAFICA": "01004"
  },
  {
    "TITULO": "Jesús María, Aguascalientes",
    "UBICACION_GEOGRAFICA": "01005"
  },
  {
    "TITULO": "Jesús María",
    "UBICACION_GEOGRAFICA": "01005"
  },
  {
    "TITULO": "Pabellón de Arteaga",
    "UBICACION_GEOGRAFICA": "01006"
  },
  {
    "TITULO": "Rincón de Romos",
    "UBICACION_GEOGRAFICA": "01007"
  },
  {
    "TITULO": "San José de Gracia",
    "UBICACION_GEOGRAFICA": "01008"
  },
  {
    "TITULO": "Tepezalá",
    "UBICACION_GEOGRAFICA": "01009"
  },
  {
    "TITULO": "El Llano",
    "UBICACION_GEOGRAFICA": "01010"
  },
  {
    "TITULO": "San Francisco de los Romo",
    "UBICACION_GEOGRAFICA": "01011"
  },
  {
    "TITULO": "Baja California",
    "UBICACION_GEOGRAFICA": "02"
  },
  {
    "TITULO": "Ensenada",
    "UBICACION_GEOGRAFICA": "02001"
  },
  {
    "TITULO": "Mexicali",
    "UBICACION_GEOGRAFICA": "02002"
  },
  {
    "TITULO": "Tecate",
    "UBICACION_GEOGRAFICA": "02003"
  },
  {
    "TITULO": "Tijuana",
    "UBICACION_GEOGRAFICA": "02004"
  },
  {
    "TITULO": "Playas de Rosarito",
    "UBICACION_GEOGRAFICA": "02005"
  },
  {
    "TITULO": "Baja California Sur",
    "UBICACION_GEOGRAFICA": "03"
  },
  {
    "TITULO": "Comondú",
    "UBICACION_GEOGRAFICA": "03001"
  },
  {
    "TITULO": "Mulegé",
    "UBICACION_GEOGRAFICA": "03002"
  },
  {
    "TITULO": "La Paz, Baja California Sur",
    "UBICACION_GEOGRAFICA": "03003"
  },
  {
    "TITULO": "La Paz",
    "UBICACION_GEOGRAFICA": "03003"
  },
  {
    "TITULO": "Los Cabos",
    "UBICACION_GEOGRAFICA": "03008"
  },
  {
    "TITULO": "Loreto",
    "UBICACION_GEOGRAFICA": "03009"
  },
  {
    "TITULO": "Campeche",
    "UBICACION_GEOGRAFICA": "04"
  },
  {
    "TITULO": "Calkiní",
    "UBICACION_GEOGRAFICA": "04001"
  },
  {
    "TITULO": "Campeche, Campeche",
    "UBICACION_GEOGRAFICA": "04002"
  },
  {
    "TITULO": "Carmen",
    "UBICACION_GEOGRAFICA": "04003"
  },
  {
    "TITULO": "Champotón",
    "UBICACION_GEOGRAFICA": "04004"
  },
  {
    "TITULO": "Hecelchakán",
    "UBICACION_GEOGRAFICA": "04005"
  },
  {
    "TITULO": "Hopelchén",
    "UBICACION_GEOGRAFICA": "04006"
  },
  {
    "TITULO": "Palizada",
    "UBICACION_GEOGRAFICA": "04007"
  },
  {
    "TITULO": "Tenabo",
    "UBICACION_GEOGRAFICA": "04008"
  },
  {
    "TITULO": "Escárcega",
    "UBICACION_GEOGRAFICA": "04009"
  },
  {
    "TITULO": "Calakmul",
    "UBICACION_GEOGRAFICA": "04010"
  },
  {
    "TITULO": "Candelaria",
    "UBICACION_GEOGRAFICA": "04011"
  },
  {
    "TITULO": "Coahuila de Zaragoza",
    "UBICACION_GEOGRAFICA": "05"
  },
  {
    "TITULO": "Coahuila",
    "UBICACION_GEOGRAFICA": "05"
  },
  {
    "TITULO": "Abasolo",
    "UBICACION_GEOGRAFICA": "05001"
  },
  {
    "TITULO": "Acuña",
    "UBICACION_GEOGRAFICA": "05002"
  },
  {
    "TITULO": "Allende",
    "UBICACION_GEOGRAFICA": "05003"
  },
  {
    "TITULO": "Arteaga",
    "UBICACION_GEOGRAFICA": "05004"
  },
  {
    "TITULO": "Candela",
    "UBICACION_GEOGRAFICA": "05005"
  },
  {
    "TITULO": "Castaños",
    "UBICACION_GEOGRAFICA": "05006"
  },
  {
    "TITULO": "Cuatro Ciénegas",
    "UBICACION_GEOGRAFICA": "05007"
  },
  {
    "TITULO": "Escobedo",
    "UBICACION_GEOGRAFICA": "05008"
  },
  {
    "TITULO": "Francisco I. Madero",
    "UBICACION_GEOGRAFICA": "05009"
  },
  {
    "TITULO": "Frontera",
    "UBICACION_GEOGRAFICA": "05010"
  },
  {
    "TITULO": "General Cepeda",
    "UBICACION_GEOGRAFICA": "05011"
  },
  {
    "TITULO": "Guerrero",
    "UBICACION_GEOGRAFICA": "05012"
  },
  {
    "TITULO": "Hidalgo",
    "UBICACION_GEOGRAFICA": "05013"
  },
  {
    "TITULO": "Jiménez",
    "UBICACION_GEOGRAFICA": "05014"
  },
  {
    "TITULO": "Juárez",
    "UBICACION_GEOGRAFICA": "05015"
  },
  {
    "TITULO": "Lamadrid",
    "UBICACION_GEOGRAFICA": "05016"
  },
  {
    "TITULO": "Matamoros",
    "UBICACION_GEOGRAFICA": "05017"
  },
  {
    "TITULO": "Monclova",
    "UBICACION_GEOGRAFICA": "05018"
  },
  {
    "TITULO": "Morelos",
    "UBICACION_GEOGRAFICA": "05019"
  },
  {
    "TITULO": "Múzquiz",
    "UBICACION_GEOGRAFICA": "05020"
  },
  {
    "TITULO": "Nadadores",
    "UBICACION_GEOGRAFICA": "05021"
  },
  {
    "TITULO": "Nava",
    "UBICACION_GEOGRAFICA": "05022"
  },
  {
    "TITULO": "Ocampo",
    "UBICACION_GEOGRAFICA": "05023"
  },
  {
    "TITULO": "Parras",
    "UBICACION_GEOGRAFICA": "05024"
  },
  {
    "TITULO": "Piedras Negras",
    "UBICACION_GEOGRAFICA": "05025"
  },
  {
    "TITULO": "Progreso",
    "UBICACION_GEOGRAFICA": "05026"
  },
  {
    "TITULO": "Ramos Arizpe",
    "UBICACION_GEOGRAFICA": "05027"
  },
  {
    "TITULO": "Sabinas",
    "UBICACION_GEOGRAFICA": "05028"
  },
  {
    "TITULO": "Sacramento",
    "UBICACION_GEOGRAFICA": "05029"
  },
  {
    "TITULO": "Saltillo",
    "UBICACION_GEOGRAFICA": "05030"
  },
  {
    "TITULO": "San Buenaventura",
    "UBICACION_GEOGRAFICA": "05031"
  },
  {
    "TITULO": "San Juan de Sabinas",
    "UBICACION_GEOGRAFICA": "05032"
  },
  {
    "TITULO": "San Pedro",
    "UBICACION_GEOGRAFICA": "05033"
  },
  {
    "TITULO": "Sierra Mojada",
    "UBICACION_GEOGRAFICA": "05034"
  },
  {
    "TITULO": "Torreón",
    "UBICACION_GEOGRAFICA": "05035"
  },
  {
    "TITULO": "Viesca",
    "UBICACION_GEOGRAFICA": "05036"
  },
  {
    "TITULO": "Villa Unión",
    "UBICACION_GEOGRAFICA": "05037"
  },
  {
    "TITULO": "Zaragoza",
    "UBICACION_GEOGRAFICA": "05038"
  },
  {
    "TITULO": "Colima",
    "UBICACION_GEOGRAFICA": "06"
  },
  {
    "TITULO": "Armería",
    "UBICACION_GEOGRAFICA": "06001"
  },
  {
    "TITULO": "Colima, Colima",
    "UBICACION_GEOGRAFICA": "06002"
  },
  {
    "TITULO": "Comala",
    "UBICACION_GEOGRAFICA": "06003"
  },
  {
    "TITULO": "Coquimatlán,",
    "UBICACION_GEOGRAFICA": "06004"
  },
  {
    "TITULO": "Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "06005"
  },
  {
    "TITULO": "Ixtlahuacán",
    "UBICACION_GEOGRAFICA": "06006"
  },
  {
    "TITULO": "Manzanillo",
    "UBICACION_GEOGRAFICA": "06007"
  },
  {
    "TITULO": "Minatitlán",
    "UBICACION_GEOGRAFICA": "06008"
  },
  {
    "TITULO": "Tecomán",
    "UBICACION_GEOGRAFICA": "06009"
  },
  {
    "TITULO": "Villa de Álvarez",
    "UBICACION_GEOGRAFICA": "06010"
  },
  {
    "TITULO": "Chiapas",
    "UBICACION_GEOGRAFICA": "07"
  },
  {
    "TITULO": "Acacoyagua",
    "UBICACION_GEOGRAFICA": "07001"
  },
  {
    "TITULO": "Acala",
    "UBICACION_GEOGRAFICA": "07002"
  },
  {
    "TITULO": "Acapetahua",
    "UBICACION_GEOGRAFICA": "07003"
  },
  {
    "TITULO": "Altamirano",
    "UBICACION_GEOGRAFICA": "07004"
  },
  {
    "TITULO": "Amatán",
    "UBICACION_GEOGRAFICA": "07005"
  },
  {
    "TITULO": "Amatenango de la Frontera",
    "UBICACION_GEOGRAFICA": "07006"
  },
  {
    "TITULO": "Amatenango del Valle",
    "UBICACION_GEOGRAFICA": "07007"
  },
  {
    "TITULO": "Angel Albino Corzo",
    "UBICACION_GEOGRAFICA": "07008"
  },
  {
    "TITULO": "Arriaga",
    "UBICACION_GEOGRAFICA": "07009"
  },
  {
    "TITULO": "Bejucal de Ocampo",
    "UBICACION_GEOGRAFICA": "07010"
  },
  {
    "TITULO": "Bella Vista",
    "UBICACION_GEOGRAFICA": "07011"
  },
  {
    "TITULO": "Berriozábal",
    "UBICACION_GEOGRAFICA": "07012"
  },
  {
    "TITULO": "Bochil",
    "UBICACION_GEOGRAFICA": "07013"
  },
  {
    "TITULO": "El Bosque",
    "UBICACION_GEOGRAFICA": "07014"
  },
  {
    "TITULO": "Cacahoatán",
    "UBICACION_GEOGRAFICA": "07015"
  },
  {
    "TITULO": "Catazajá",
    "UBICACION_GEOGRAFICA": "07016"
  },
  {
    "TITULO": "Cintalapa",
    "UBICACION_GEOGRAFICA": "07017"
  },
  {
    "TITULO": "Coapilla",
    "UBICACION_GEOGRAFICA": "07018"
  },
  {
    "TITULO": "Comitán de Domínguez",
    "UBICACION_GEOGRAFICA": "07019"
  },
  {
    "TITULO": "La Concordia",
    "UBICACION_GEOGRAFICA": "07020"
  },
  {
    "TITULO": "Copainalá",
    "UBICACION_GEOGRAFICA": "07021"
  },
  {
    "TITULO": "Chalchihuitán",
    "UBICACION_GEOGRAFICA": "07022"
  },
  {
    "TITULO": "Chamula",
    "UBICACION_GEOGRAFICA": "07023"
  },
  {
    "TITULO": "Chanal",
    "UBICACION_GEOGRAFICA": "07024"
  },
  {
    "TITULO": "Chapultenango",
    "UBICACION_GEOGRAFICA": "07025"
  },
  {
    "TITULO": "Chenalhó",
    "UBICACION_GEOGRAFICA": "07026"
  },
  {
    "TITULO": "Chiapa de Corzo",
    "UBICACION_GEOGRAFICA": "07027"
  },
  {
    "TITULO": "Chiapilla",
    "UBICACION_GEOGRAFICA": "07028"
  },
  {
    "TITULO": "Chicoasén",
    "UBICACION_GEOGRAFICA": "07029"
  },
  {
    "TITULO": "Chicomuselo",
    "UBICACION_GEOGRAFICA": "07030"
  },
  {
    "TITULO": "Chilón",
    "UBICACION_GEOGRAFICA": "07031"
  },
  {
    "TITULO": "Escuintla",
    "UBICACION_GEOGRAFICA": "07032"
  },
  {
    "TITULO": "Francisco León",
    "UBICACION_GEOGRAFICA": "07033"
  },
  {
    "TITULO": "Frontera Comalapa",
    "UBICACION_GEOGRAFICA": "07034"
  },
  {
    "TITULO": "Frontera Hidalgo",
    "UBICACION_GEOGRAFICA": "07035"
  },
  {
    "TITULO": "La Grandeza",
    "UBICACION_GEOGRAFICA": "07036"
  },
  {
    "TITULO": "Huehuetán",
    "UBICACION_GEOGRAFICA": "07037"
  },
  {
    "TITULO": "Huixtán",
    "UBICACION_GEOGRAFICA": "07038"
  },
  {
    "TITULO": "Huitiupán",
    "UBICACION_GEOGRAFICA": "07039"
  },
  {
    "TITULO": "Huixtla",
    "UBICACION_GEOGRAFICA": "07040"
  },
  {
    "TITULO": "La Independencia",
    "UBICACION_GEOGRAFICA": "07041"
  },
  {
    "TITULO": "Ixhuatán",
    "UBICACION_GEOGRAFICA": "07042"
  },
  {
    "TITULO": "Ixtacomitán",
    "UBICACION_GEOGRAFICA": "07043"
  },
  {
    "TITULO": "Ixtapa",
    "UBICACION_GEOGRAFICA": "07044"
  },
  {
    "TITULO": "Ixtapangajoya",
    "UBICACION_GEOGRAFICA": "07045"
  },
  {
    "TITULO": "Jiquipilas",
    "UBICACION_GEOGRAFICA": "07046"
  },
  {
    "TITULO": "Jitotol",
    "UBICACION_GEOGRAFICA": "07047"
  },
  {
    "TITULO": "Juárez",
    "UBICACION_GEOGRAFICA": "07048"
  },
  {
    "TITULO": "Larráinzar",
    "UBICACION_GEOGRAFICA": "07049"
  },
  {
    "TITULO": "La Libertad",
    "UBICACION_GEOGRAFICA": "07050"
  },
  {
    "TITULO": "Mapastepec",
    "UBICACION_GEOGRAFICA": "07051"
  },
  {
    "TITULO": "Las Margaritas",
    "UBICACION_GEOGRAFICA": "07052"
  },
  {
    "TITULO": "Mazapa de Madero",
    "UBICACION_GEOGRAFICA": "07053"
  },
  {
    "TITULO": "Mazatán",
    "UBICACION_GEOGRAFICA": "07054"
  },
  {
    "TITULO": "Metapa",
    "UBICACION_GEOGRAFICA": "07055"
  },
  {
    "TITULO": "Mitontic",
    "UBICACION_GEOGRAFICA": "07056"
  },
  {
    "TITULO": "Motozintla",
    "UBICACION_GEOGRAFICA": "07057"
  },
  {
    "TITULO": "Nicolás Ruíz",
    "UBICACION_GEOGRAFICA": "07058"
  },
  {
    "TITULO": "Ocosingo",
    "UBICACION_GEOGRAFICA": "07059"
  },
  {
    "TITULO": "Ocotepec",
    "UBICACION_GEOGRAFICA": "07060"
  },
  {
    "TITULO": "Ocozocoautla de Espinosa",
    "UBICACION_GEOGRAFICA": "07061"
  },
  {
    "TITULO": "Ostuacán",
    "UBICACION_GEOGRAFICA": "07062"
  },
  {
    "TITULO": "Osumacinta",
    "UBICACION_GEOGRAFICA": "07063"
  },
  {
    "TITULO": "Oxchuc",
    "UBICACION_GEOGRAFICA": "07064"
  },
  {
    "TITULO": "Palenque",
    "UBICACION_GEOGRAFICA": "07065"
  },
  {
    "TITULO": "Pantelhó",
    "UBICACION_GEOGRAFICA": "07066"
  },
  {
    "TITULO": "Pantepec",
    "UBICACION_GEOGRAFICA": "07067"
  },
  {
    "TITULO": "Pichucalco",
    "UBICACION_GEOGRAFICA": "07068"
  },
  {
    "TITULO": "Pijijiapan",
    "UBICACION_GEOGRAFICA": "07069"
  },
  {
    "TITULO": "El Porvenir",
    "UBICACION_GEOGRAFICA": "07070"
  },
  {
    "TITULO": "Villa Comaltitlán",
    "UBICACION_GEOGRAFICA": "07071"
  },
  {
    "TITULO": "Pueblo Nuevo Solistahuacán",
    "UBICACION_GEOGRAFICA": "07072"
  },
  {
    "TITULO": "Rayón",
    "UBICACION_GEOGRAFICA": "07073"
  },
  {
    "TITULO": "Reforma",
    "UBICACION_GEOGRAFICA": "07074"
  },
  {
    "TITULO": "Las Rosas",
    "UBICACION_GEOGRAFICA": "07075"
  },
  {
    "TITULO": "Sabanilla",
    "UBICACION_GEOGRAFICA": "07076"
  },
  {
    "TITULO": "Salto de Agua",
    "UBICACION_GEOGRAFICA": "07077"
  },
  {
    "TITULO": "San Cristóbal de las Casas",
    "UBICACION_GEOGRAFICA": "07078"
  },
  {
    "TITULO": "San Fernando",
    "UBICACION_GEOGRAFICA": "07079"
  },
  {
    "TITULO": "Siltepec",
    "UBICACION_GEOGRAFICA": "07080"
  },
  {
    "TITULO": "Simojovel",
    "UBICACION_GEOGRAFICA": "07081"
  },
  {
    "TITULO": "Sitalá",
    "UBICACION_GEOGRAFICA": "07082"
  },
  {
    "TITULO": "Socoltenango",
    "UBICACION_GEOGRAFICA": "07083"
  },
  {
    "TITULO": "Solosuchiapa",
    "UBICACION_GEOGRAFICA": "07084"
  },
  {
    "TITULO": "Soyaló",
    "UBICACION_GEOGRAFICA": "07085"
  },
  {
    "TITULO": "Suchiapa",
    "UBICACION_GEOGRAFICA": "07086"
  },
  {
    "TITULO": "Suchiate",
    "UBICACION_GEOGRAFICA": "07087"
  },
  {
    "TITULO": "Sunuapa",
    "UBICACION_GEOGRAFICA": "07088"
  },
  {
    "TITULO": "Tapachula",
    "UBICACION_GEOGRAFICA": "07089"
  },
  {
    "TITULO": "Tapalapa",
    "UBICACION_GEOGRAFICA": "07090"
  },
  {
    "TITULO": "Tapilula",
    "UBICACION_GEOGRAFICA": "07091"
  },
  {
    "TITULO": "Tecpatán",
    "UBICACION_GEOGRAFICA": "07092"
  },
  {
    "TITULO": "Tenejapa",
    "UBICACION_GEOGRAFICA": "07093"
  },
  {
    "TITULO": "Teopisca",
    "UBICACION_GEOGRAFICA": "07094"
  },
  {
    "TITULO": "Tila",
    "UBICACION_GEOGRAFICA": "07096"
  },
  {
    "TITULO": "Tonalá",
    "UBICACION_GEOGRAFICA": "07097"
  },
  {
    "TITULO": "Totolapa",
    "UBICACION_GEOGRAFICA": "07098"
  },
  {
    "TITULO": "La Trinitaria",
    "UBICACION_GEOGRAFICA": "07099"
  },
  {
    "TITULO": "Tumbalá",
    "UBICACION_GEOGRAFICA": "07100"
  },
  {
    "TITULO": "Tuxtla Gutiérrez",
    "UBICACION_GEOGRAFICA": "07101"
  },
  {
    "TITULO": "Tuxtla Chico",
    "UBICACION_GEOGRAFICA": "07102"
  },
  {
    "TITULO": "Tuzantán",
    "UBICACION_GEOGRAFICA": "07103"
  },
  {
    "TITULO": "Tzimol",
    "UBICACION_GEOGRAFICA": "07104"
  },
  {
    "TITULO": "Unión Juárez",
    "UBICACION_GEOGRAFICA": "07105"
  },
  {
    "TITULO": "Venustiano Carranza",
    "UBICACION_GEOGRAFICA": "07106"
  },
  {
    "TITULO": "Villa Corzo",
    "UBICACION_GEOGRAFICA": "07107"
  },
  {
    "TITULO": "Villaflores",
    "UBICACION_GEOGRAFICA": "07108"
  },
  {
    "TITULO": "Yajalón",
    "UBICACION_GEOGRAFICA": "07109"
  },
  {
    "TITULO": "San Lucas",
    "UBICACION_GEOGRAFICA": "07110"
  },
  {
    "TITULO": "Zinacantán",
    "UBICACION_GEOGRAFICA": "07111"
  },
  {
    "TITULO": "San Juan Cancuc",
    "UBICACION_GEOGRAFICA": "07112"
  },
  {
    "TITULO": "Aldama",
    "UBICACION_GEOGRAFICA": "07113"
  },
  {
    "TITULO": "Benemérito de las Américas",
    "UBICACION_GEOGRAFICA": "07114"
  },
  {
    "TITULO": "Maravilla Tenejapa",
    "UBICACION_GEOGRAFICA": "07115"
  },
  {
    "TITULO": "Marqués de Comillas",
    "UBICACION_GEOGRAFICA": "07116"
  },
  {
    "TITULO": "Montecristo de Guerrero",
    "UBICACION_GEOGRAFICA": "07117"
  },
  {
    "TITULO": "San Andrés Duraznal",
    "UBICACION_GEOGRAFICA": "07118"
  },
  {
    "TITULO": "Santiago el Pinar",
    "UBICACION_GEOGRAFICA": "07119"
  },
  {
    "TITULO": "Chihuahua",
    "UBICACION_GEOGRAFICA": "08"
  },
  {
    "TITULO": "Ahumada",
    "UBICACION_GEOGRAFICA": "08001"
  },
  {
    "TITULO": "Aldama",
    "UBICACION_GEOGRAFICA": "08002"
  },
  {
    "TITULO": "Allende",
    "UBICACION_GEOGRAFICA": "08003"
  },
  {
    "TITULO": "Aquiles Serdán",
    "UBICACION_GEOGRAFICA": "08004"
  },
  {
    "TITULO": "Ascensión",
    "UBICACION_GEOGRAFICA": "08005"
  },
  {
    "TITULO": "Bachíniva",
    "UBICACION_GEOGRAFICA": "08006"
  },
  {
    "TITULO": "Balleza",
    "UBICACION_GEOGRAFICA": "08007"
  },
  {
    "TITULO": "Batopilas",
    "UBICACION_GEOGRAFICA": "08008"
  },
  {
    "TITULO": "Bocoyna",
    "UBICACION_GEOGRAFICA": "08009"
  },
  {
    "TITULO": "Buenaventura",
    "UBICACION_GEOGRAFICA": "08010"
  },
  {
    "TITULO": "Camargo",
    "UBICACION_GEOGRAFICA": "08011"
  },
  {
    "TITULO": "Carichí",
    "UBICACION_GEOGRAFICA": "08012"
  },
  {
    "TITULO": "Casas Grandes",
    "UBICACION_GEOGRAFICA": "08013"
  },
  {
    "TITULO": "Coronado",
    "UBICACION_GEOGRAFICA": "08014"
  },
  {
    "TITULO": "Coyame del Sotol",
    "UBICACION_GEOGRAFICA": "08015"
  },
  {
    "TITULO": "La Cruz",
    "UBICACION_GEOGRAFICA": "08016"
  },
  {
    "TITULO": "Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "08017"
  },
  {
    "TITULO": "Cusihuiriachi",
    "UBICACION_GEOGRAFICA": "08018"
  },
  {
    "TITULO": "Chihuahua, Chihuahua",
    "UBICACION_GEOGRAFICA": "08019"
  },
  {
    "TITULO": "Chínipas",
    "UBICACION_GEOGRAFICA": "08020"
  },
  {
    "TITULO": "Delicias",
    "UBICACION_GEOGRAFICA": "08021"
  },
  {
    "TITULO": "Dr. Belisario Domínguez",
    "UBICACION_GEOGRAFICA": "08022"
  },
  {
    "TITULO": "Galeana",
    "UBICACION_GEOGRAFICA": "08023"
  },
  {
    "TITULO": "Santa Isabel",
    "UBICACION_GEOGRAFICA": "08024"
  },
  {
    "TITULO": "Gómez Farías",
    "UBICACION_GEOGRAFICA": "08025"
  },
  {
    "TITULO": "Gran Morelos",
    "UBICACION_GEOGRAFICA": "08026"
  },
  {
    "TITULO": "Guachochi",
    "UBICACION_GEOGRAFICA": "08027"
  },
  {
    "TITULO": "Guadalupe, Chihuahua",
    "UBICACION_GEOGRAFICA": "08028"
  },
  {
    "TITULO": "Guadalupe y Calvo",
    "UBICACION_GEOGRAFICA": "08029"
  },
  {
    "TITULO": "Guazapares",
    "UBICACION_GEOGRAFICA": "08030"
  },
  {
    "TITULO": "Guerrero",
    "UBICACION_GEOGRAFICA": "08031"
  },
  {
    "TITULO": "Hidalgo del Parral",
    "UBICACION_GEOGRAFICA": "08032"
  },
  {
    "TITULO": "Huejotitán",
    "UBICACION_GEOGRAFICA": "08033"
  },
  {
    "TITULO": "Ignacio Zaragoza",
    "UBICACION_GEOGRAFICA": "08034"
  },
  {
    "TITULO": "Janos",
    "UBICACION_GEOGRAFICA": "08035"
  },
  {
    "TITULO": "Jiménez",
    "UBICACION_GEOGRAFICA": "08036"
  },
  {
    "TITULO": "Juárez",
    "UBICACION_GEOGRAFICA": "08037"
  },
  {
    "TITULO": "Julimes",
    "UBICACION_GEOGRAFICA": "08038"
  },
  {
    "TITULO": "López",
    "UBICACION_GEOGRAFICA": "08039"
  },
  {
    "TITULO": "Madera",
    "UBICACION_GEOGRAFICA": "08040"
  },
  {
    "TITULO": "Maguarichi",
    "UBICACION_GEOGRAFICA": "08041"
  },
  {
    "TITULO": "Manuel Benavides",
    "UBICACION_GEOGRAFICA": "08042"
  },
  {
    "TITULO": "Matachí",
    "UBICACION_GEOGRAFICA": "08043"
  },
  {
    "TITULO": "Matamoros",
    "UBICACION_GEOGRAFICA": "08044"
  },
  {
    "TITULO": "Meoqui",
    "UBICACION_GEOGRAFICA": "08045"
  },
  {
    "TITULO": "Morelos",
    "UBICACION_GEOGRAFICA": "08046"
  },
  {
    "TITULO": "Moris",
    "UBICACION_GEOGRAFICA": "08047"
  },
  {
    "TITULO": "Namiquipa",
    "UBICACION_GEOGRAFICA": "08048"
  },
  {
    "TITULO": "Nonoava",
    "UBICACION_GEOGRAFICA": "08049"
  },
  {
    "TITULO": "Nuevo Casas Grandes",
    "UBICACION_GEOGRAFICA": "08050"
  },
  {
    "TITULO": "Ocampo",
    "UBICACION_GEOGRAFICA": "08051"
  },
  {
    "TITULO": "Ojinaga",
    "UBICACION_GEOGRAFICA": "08052"
  },
  {
    "TITULO": "Praxedis G. Guerrero",
    "UBICACION_GEOGRAFICA": "08053"
  },
  {
    "TITULO": "Riva Palacio",
    "UBICACION_GEOGRAFICA": "08054"
  },
  {
    "TITULO": "Rosales",
    "UBICACION_GEOGRAFICA": "08055"
  },
  {
    "TITULO": "Rosario",
    "UBICACION_GEOGRAFICA": "08056"
  },
  {
    "TITULO": "San Francisco de Borja",
    "UBICACION_GEOGRAFICA": "08057"
  },
  {
    "TITULO": "San Francisco de Conchos",
    "UBICACION_GEOGRAFICA": "08058"
  },
  {
    "TITULO": "San Francisco del Oro",
    "UBICACION_GEOGRAFICA": "08059"
  },
  {
    "TITULO": "Santa Bárbara",
    "UBICACION_GEOGRAFICA": "08060"
  },
  {
    "TITULO": "Satevó",
    "UBICACION_GEOGRAFICA": "08061"
  },
  {
    "TITULO": "Saucillo",
    "UBICACION_GEOGRAFICA": "08062"
  },
  {
    "TITULO": "Temósachic",
    "UBICACION_GEOGRAFICA": "08063"
  },
  {
    "TITULO": "El Tule",
    "UBICACION_GEOGRAFICA": "08064"
  },
  {
    "TITULO": "Urique",
    "UBICACION_GEOGRAFICA": "08065"
  },
  {
    "TITULO": "Uruachi",
    "UBICACION_GEOGRAFICA": "08066"
  },
  {
    "TITULO": "Valle de Zaragoza",
    "UBICACION_GEOGRAFICA": "08067"
  },
  {
    "TITULO": "Ciudad de México",
    "UBICACION_GEOGRAFICA": "09"
  },
  {
    "TITULO": "Azcapotzalco",
    "UBICACION_GEOGRAFICA": "09002"
  },
  {
    "TITULO": "Coyoacán",
    "UBICACION_GEOGRAFICA": "09003"
  },
  {
    "TITULO": "Cuajimalpa de Morelos",
    "UBICACION_GEOGRAFICA": "09004"
  },
  {
    "TITULO": "Gustavo A. Madero",
    "UBICACION_GEOGRAFICA": "09005"
  },
  {
    "TITULO": "Iztacalco",
    "UBICACION_GEOGRAFICA": "09006"
  },
  {
    "TITULO": "Iztapalapa",
    "UBICACION_GEOGRAFICA": "09007"
  },
  {
    "TITULO": "La Magdalena Contreras",
    "UBICACION_GEOGRAFICA": "09008"
  },
  {
    "TITULO": "Milpa Alta",
    "UBICACION_GEOGRAFICA": "09009"
  },
  {
    "TITULO": "Álvaro Obregón",
    "UBICACION_GEOGRAFICA": "09010"
  },
  {
    "TITULO": "Tláhuac",
    "UBICACION_GEOGRAFICA": "09011"
  },
  {
    "TITULO": "Tlalpan",
    "UBICACION_GEOGRAFICA": "09012"
  },
  {
    "TITULO": "Xochimilco",
    "UBICACION_GEOGRAFICA": "09013"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "09014"
  },
  {
    "TITULO": "Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "09015"
  },
  {
    "TITULO": "Miguel Hidalgo",
    "UBICACION_GEOGRAFICA": "09016"
  },
  {
    "TITULO": "Venustiano Carranza",
    "UBICACION_GEOGRAFICA": "09017"
  },
  {
    "TITULO": "Durango",
    "UBICACION_GEOGRAFICA": "10"
  },
  {
    "TITULO": "Canatlán",
    "UBICACION_GEOGRAFICA": "10001"
  },
  {
    "TITULO": "Canelas",
    "UBICACION_GEOGRAFICA": "10002"
  },
  {
    "TITULO": "Coneto de Comonfort",
    "UBICACION_GEOGRAFICA": "10003"
  },
  {
    "TITULO": "Cuencamé",
    "UBICACION_GEOGRAFICA": "10004"
  },
  {
    "TITULO": "Durango, Durango",
    "UBICACION_GEOGRAFICA": "10005"
  },
  {
    "TITULO": "General Simón Bolívar",
    "UBICACION_GEOGRAFICA": "10006"
  },
  {
    "TITULO": "Gómez Palacio",
    "UBICACION_GEOGRAFICA": "10007"
  },
  {
    "TITULO": "Guadalupe Victoria",
    "UBICACION_GEOGRAFICA": "10008"
  },
  {
    "TITULO": "Guanaceví",
    "UBICACION_GEOGRAFICA": "10009"
  },
  {
    "TITULO": "Hidalgo",
    "UBICACION_GEOGRAFICA": "10010"
  },
  {
    "TITULO": "Indé",
    "UBICACION_GEOGRAFICA": "10011"
  },
  {
    "TITULO": "Lerdo",
    "UBICACION_GEOGRAFICA": "10012"
  },
  {
    "TITULO": "Mapimí",
    "UBICACION_GEOGRAFICA": "10013"
  },
  {
    "TITULO": "Mezquital",
    "UBICACION_GEOGRAFICA": "10014"
  },
  {
    "TITULO": "Nazas",
    "UBICACION_GEOGRAFICA": "10015"
  },
  {
    "TITULO": "Nombre de Dios",
    "UBICACION_GEOGRAFICA": "10016"
  },
  {
    "TITULO": "Ocampo",
    "UBICACION_GEOGRAFICA": "10017"
  },
  {
    "TITULO": "El Oro",
    "UBICACION_GEOGRAFICA": "10018"
  },
  {
    "TITULO": "Otáez",
    "UBICACION_GEOGRAFICA": "10019"
  },
  {
    "TITULO": "Pánuco de Coronado",
    "UBICACION_GEOGRAFICA": "10020"
  },
  {
    "TITULO": "Peñón Blanco",
    "UBICACION_GEOGRAFICA": "10021"
  },
  {
    "TITULO": "Poanas",
    "UBICACION_GEOGRAFICA": "10022"
  },
  {
    "TITULO": "Pueblo Nuevo",
    "UBICACION_GEOGRAFICA": "10023"
  },
  {
    "TITULO": "Rodeo",
    "UBICACION_GEOGRAFICA": "10024"
  },
  {
    "TITULO": "San Bernardo",
    "UBICACION_GEOGRAFICA": "10025"
  },
  {
    "TITULO": "San Dimas",
    "UBICACION_GEOGRAFICA": "10026"
  },
  {
    "TITULO": "San Juan de Guadalupe",
    "UBICACION_GEOGRAFICA": "10027"
  },
  {
    "TITULO": "San Juan del Río",
    "UBICACION_GEOGRAFICA": "10028"
  },
  {
    "TITULO": "San Luis del Cordero",
    "UBICACION_GEOGRAFICA": "10029"
  },
  {
    "TITULO": "San Pedro del Gallo",
    "UBICACION_GEOGRAFICA": "10030"
  },
  {
    "TITULO": "Santa Clara",
    "UBICACION_GEOGRAFICA": "10031"
  },
  {
    "TITULO": "Santiago Papasquiaro",
    "UBICACION_GEOGRAFICA": "10032"
  },
  {
    "TITULO": "Súchil",
    "UBICACION_GEOGRAFICA": "10033"
  },
  {
    "TITULO": "Tamazula",
    "UBICACION_GEOGRAFICA": "10034"
  },
  {
    "TITULO": "Tepehuanes",
    "UBICACION_GEOGRAFICA": "10035"
  },
  {
    "TITULO": "Tlahualilo",
    "UBICACION_GEOGRAFICA": "10036"
  },
  {
    "TITULO": "Topia",
    "UBICACION_GEOGRAFICA": "10037"
  },
  {
    "TITULO": "Vicente Guerrero",
    "UBICACION_GEOGRAFICA": "10038"
  },
  {
    "TITULO": "Nuevo Ideal",
    "UBICACION_GEOGRAFICA": "10039"
  },
  {
    "TITULO": "Guanajuato",
    "UBICACION_GEOGRAFICA": "11"
  },
  {
    "TITULO": "Abasolo",
    "UBICACION_GEOGRAFICA": "11001"
  },
  {
    "TITULO": "Acámbaro",
    "UBICACION_GEOGRAFICA": "11002"
  },
  {
    "TITULO": "San Miguel de Allende",
    "UBICACION_GEOGRAFICA": "11003"
  },
  {
    "TITULO": "Apaseo el Alto",
    "UBICACION_GEOGRAFICA": "11004"
  },
  {
    "TITULO": "Apaseo el Grande",
    "UBICACION_GEOGRAFICA": "11005"
  },
  {
    "TITULO": "Atarjea",
    "UBICACION_GEOGRAFICA": "11006"
  },
  {
    "TITULO": "Celaya",
    "UBICACION_GEOGRAFICA": "11007"
  },
  {
    "TITULO": "Manuel Doblado",
    "UBICACION_GEOGRAFICA": "11008"
  },
  {
    "TITULO": "Comonfort",
    "UBICACION_GEOGRAFICA": "11009"
  },
  {
    "TITULO": "Coroneo",
    "UBICACION_GEOGRAFICA": "11010"
  },
  {
    "TITULO": "Cortazar",
    "UBICACION_GEOGRAFICA": "11011"
  },
  {
    "TITULO": "Cuerámaro",
    "UBICACION_GEOGRAFICA": "11012"
  },
  {
    "TITULO": "Doctor Mora",
    "UBICACION_GEOGRAFICA": "11013"
  },
  {
    "TITULO": "Dolores Hidalgo",
    "UBICACION_GEOGRAFICA": "11014"
  },
  {
    "TITULO": "Guanajuato, Guanajuato",
    "UBICACION_GEOGRAFICA": "11015"
  },
  {
    "TITULO": "Huanímaro",
    "UBICACION_GEOGRAFICA": "11016"
  },
  {
    "TITULO": "Irapuato",
    "UBICACION_GEOGRAFICA": "11017"
  },
  {
    "TITULO": "Jaral del Progreso",
    "UBICACION_GEOGRAFICA": "11018"
  },
  {
    "TITULO": "Jerécuaro",
    "UBICACION_GEOGRAFICA": "11019"
  },
  {
    "TITULO": "León",
    "UBICACION_GEOGRAFICA": "11020"
  },
  {
    "TITULO": "Moroleón",
    "UBICACION_GEOGRAFICA": "11021"
  },
  {
    "TITULO": "Ocampo",
    "UBICACION_GEOGRAFICA": "11022"
  },
  {
    "TITULO": "Pénjamo",
    "UBICACION_GEOGRAFICA": "11023"
  },
  {
    "TITULO": "Pueblo Nuevo",
    "UBICACION_GEOGRAFICA": "11024"
  },
  {
    "TITULO": "Purísima del Rincón",
    "UBICACION_GEOGRAFICA": "11025"
  },
  {
    "TITULO": "Romita",
    "UBICACION_GEOGRAFICA": "11026"
  },
  {
    "TITULO": "Salamanca, Guanajuato",
    "UBICACION_GEOGRAFICA": "11027"
  },
  {
    "TITULO": "Salvatierra, Guanajuato",
    "UBICACION_GEOGRAFICA": "11028"
  },
  {
    "TITULO": "San Diego de la Unión",
    "UBICACION_GEOGRAFICA": "11029"
  },
  {
    "TITULO": "San Felipe",
    "UBICACION_GEOGRAFICA": "11030"
  },
  {
    "TITULO": "San Francisco del Rincón",
    "UBICACION_GEOGRAFICA": "11031"
  },
  {
    "TITULO": "San José Iturbide",
    "UBICACION_GEOGRAFICA": "11032"
  },
  {
    "TITULO": "San Luis de la Paz",
    "UBICACION_GEOGRAFICA": "11033"
  },
  {
    "TITULO": "Santa Catarina",
    "UBICACION_GEOGRAFICA": "11034"
  },
  {
    "TITULO": "Santa Cruz de Juventino Rosas",
    "UBICACION_GEOGRAFICA": "11035"
  },
  {
    "TITULO": "Santiago Maravatío",
    "UBICACION_GEOGRAFICA": "11036"
  },
  {
    "TITULO": "Silao",
    "UBICACION_GEOGRAFICA": "11037"
  },
  {
    "TITULO": "Tarandacuao",
    "UBICACION_GEOGRAFICA": "11038"
  },
  {
    "TITULO": "Tarimoro",
    "UBICACION_GEOGRAFICA": "11039"
  },
  {
    "TITULO": "Tierra Blanca",
    "UBICACION_GEOGRAFICA": "11040"
  },
  {
    "TITULO": "Uriangato",
    "UBICACION_GEOGRAFICA": "11041"
  },
  {
    "TITULO": "Valle de Santiago",
    "UBICACION_GEOGRAFICA": "11042"
  },
  {
    "TITULO": "Victoria",
    "UBICACION_GEOGRAFICA": "11043"
  },
  {
    "TITULO": "Villagrán",
    "UBICACION_GEOGRAFICA": "11044"
  },
  {
    "TITULO": "Xichú",
    "UBICACION_GEOGRAFICA": "11045"
  },
  {
    "TITULO": "Yuriria",
    "UBICACION_GEOGRAFICA": "11046"
  },
  {
    "TITULO": "Guerrero",
    "UBICACION_GEOGRAFICA": "12"
  },
  {
    "TITULO": "Acapulco de Juárez",
    "UBICACION_GEOGRAFICA": "12001"
  },
  {
    "TITULO": "Ahuacuotzingo",
    "UBICACION_GEOGRAFICA": "12002"
  },
  {
    "TITULO": "Ajuchitlán del Progreso",
    "UBICACION_GEOGRAFICA": "12003"
  },
  {
    "TITULO": "Alcozauca de Guerrero",
    "UBICACION_GEOGRAFICA": "12004"
  },
  {
    "TITULO": "Alpoyeca",
    "UBICACION_GEOGRAFICA": "12005"
  },
  {
    "TITULO": "Apaxtla",
    "UBICACION_GEOGRAFICA": "12006"
  },
  {
    "TITULO": "Arcelia",
    "UBICACION_GEOGRAFICA": "12007"
  },
  {
    "TITULO": "Atenango del Río",
    "UBICACION_GEOGRAFICA": "12008"
  },
  {
    "TITULO": "Atlamajalcingo del Monte",
    "UBICACION_GEOGRAFICA": "12009"
  },
  {
    "TITULO": "Atlixtac",
    "UBICACION_GEOGRAFICA": "12010"
  },
  {
    "TITULO": "Atoyac de Álvarez",
    "UBICACION_GEOGRAFICA": "12011"
  },
  {
    "TITULO": "Ayutla de los Libres",
    "UBICACION_GEOGRAFICA": "12012"
  },
  {
    "TITULO": "Azoyú",
    "UBICACION_GEOGRAFICA": "12013"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "12014"
  },
  {
    "TITULO": "Buenavista de Cuéllar",
    "UBICACION_GEOGRAFICA": "12015"
  },
  {
    "TITULO": "Coahuayutla",
    "UBICACION_GEOGRAFICA": "12016"
  },
  {
    "TITULO": "Cocula",
    "UBICACION_GEOGRAFICA": "12017"
  },
  {
    "TITULO": "Copala",
    "UBICACION_GEOGRAFICA": "12018"
  },
  {
    "TITULO": "Copalillo",
    "UBICACION_GEOGRAFICA": "12019"
  },
  {
    "TITULO": "Copanatoyac",
    "UBICACION_GEOGRAFICA": "12020"
  },
  {
    "TITULO": "Coyuca de Benítez",
    "UBICACION_GEOGRAFICA": "12021"
  },
  {
    "TITULO": "Coyuca de Catalán",
    "UBICACION_GEOGRAFICA": "12022"
  },
  {
    "TITULO": "Cuajinicuilapa",
    "UBICACION_GEOGRAFICA": "12023"
  },
  {
    "TITULO": "Cualác",
    "UBICACION_GEOGRAFICA": "12024"
  },
  {
    "TITULO": "Cuautepec",
    "UBICACION_GEOGRAFICA": "12025"
  },
  {
    "TITULO": "Cuetzala del Progreso",
    "UBICACION_GEOGRAFICA": "12026"
  },
  {
    "TITULO": "Cutzamala de Pinzón",
    "UBICACION_GEOGRAFICA": "12027"
  },
  {
    "TITULO": "Chilapa de Álvarez",
    "UBICACION_GEOGRAFICA": "12028"
  },
  {
    "TITULO": "Chilpancingo de los Bravo",
    "UBICACION_GEOGRAFICA": "12029"
  },
  {
    "TITULO": "Florencio Villarreal",
    "UBICACION_GEOGRAFICA": "12030"
  },
  {
    "TITULO": "General Canuto A. Neri",
    "UBICACION_GEOGRAFICA": "12031"
  },
  {
    "TITULO": "General Heliodoro Castillo",
    "UBICACION_GEOGRAFICA": "12032"
  },
  {
    "TITULO": "Huamuxtitlán",
    "UBICACION_GEOGRAFICA": "12033"
  },
  {
    "TITULO": "Huitzuco de los Figueroa",
    "UBICACION_GEOGRAFICA": "12034"
  },
  {
    "TITULO": "Iguala de la Independencia",
    "UBICACION_GEOGRAFICA": "12035"
  },
  {
    "TITULO": "Igualapa",
    "UBICACION_GEOGRAFICA": "12036"
  },
  {
    "TITULO": "Ixcateopan de Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "12037"
  },
  {
    "TITULO": "Zihuatanejo de Azueta",
    "UBICACION_GEOGRAFICA": "12038"
  },
  {
    "TITULO": "Juan R. Escudero",
    "UBICACION_GEOGRAFICA": "12039"
  },
  {
    "TITULO": "Leonardo Bravo",
    "UBICACION_GEOGRAFICA": "12040"
  },
  {
    "TITULO": "Malinaltepec",
    "UBICACION_GEOGRAFICA": "12041"
  },
  {
    "TITULO": "Mártir de Cuilapan",
    "UBICACION_GEOGRAFICA": "12042"
  },
  {
    "TITULO": "Metlatónoc",
    "UBICACION_GEOGRAFICA": "12043"
  },
  {
    "TITULO": "Mochitlán",
    "UBICACION_GEOGRAFICA": "12044"
  },
  {
    "TITULO": "Olinalá",
    "UBICACION_GEOGRAFICA": "12045"
  },
  {
    "TITULO": "Ometepec",
    "UBICACION_GEOGRAFICA": "12046"
  },
  {
    "TITULO": "Pedro Ascencio Alquisiras",
    "UBICACION_GEOGRAFICA": "12047"
  },
  {
    "TITULO": "Petatlán",
    "UBICACION_GEOGRAFICA": "12048"
  },
  {
    "TITULO": "Pilcaya",
    "UBICACION_GEOGRAFICA": "12049"
  },
  {
    "TITULO": "Pungarabato",
    "UBICACION_GEOGRAFICA": "12050"
  },
  {
    "TITULO": "Quechultenango",
    "UBICACION_GEOGRAFICA": "12051"
  },
  {
    "TITULO": "San Luis Acatlán",
    "UBICACION_GEOGRAFICA": "12052"
  },
  {
    "TITULO": "San Marcos",
    "UBICACION_GEOGRAFICA": "12053"
  },
  {
    "TITULO": "San Miguel Totolapan",
    "UBICACION_GEOGRAFICA": "12054"
  },
  {
    "TITULO": "Taxco de Alarcón",
    "UBICACION_GEOGRAFICA": "12055"
  },
  {
    "TITULO": "Tecoanapa",
    "UBICACION_GEOGRAFICA": "12056"
  },
  {
    "TITULO": "Técpan de Galeana",
    "UBICACION_GEOGRAFICA": "12057"
  },
  {
    "TITULO": "Teloloapan",
    "UBICACION_GEOGRAFICA": "12058"
  },
  {
    "TITULO": "Tepecoacuilco de Trujano",
    "UBICACION_GEOGRAFICA": "12059"
  },
  {
    "TITULO": "Tetipac",
    "UBICACION_GEOGRAFICA": "12060"
  },
  {
    "TITULO": "Tixtla de Guerrero",
    "UBICACION_GEOGRAFICA": "12061"
  },
  {
    "TITULO": "Tlacoachistlahuaca",
    "UBICACION_GEOGRAFICA": "12062"
  },
  {
    "TITULO": "Tlacoapa",
    "UBICACION_GEOGRAFICA": "12063"
  },
  {
    "TITULO": "Tlalchapa",
    "UBICACION_GEOGRAFICA": "12064"
  },
  {
    "TITULO": "Tlalixtaquilla de Maldonado",
    "UBICACION_GEOGRAFICA": "12065"
  },
  {
    "TITULO": "Tlapa de Comonfort",
    "UBICACION_GEOGRAFICA": "12066"
  },
  {
    "TITULO": "Tlapehuala",
    "UBICACION_GEOGRAFICA": "12067"
  },
  {
    "TITULO": "La Unión de Isidoro Montes de Oca",
    "UBICACION_GEOGRAFICA": "12068"
  },
  {
    "TITULO": "Xalpatláhuac",
    "UBICACION_GEOGRAFICA": "12069"
  },
  {
    "TITULO": "Xochihuehuetlán",
    "UBICACION_GEOGRAFICA": "12070"
  },
  {
    "TITULO": "Xochistlahuaca",
    "UBICACION_GEOGRAFICA": "12071"
  },
  {
    "TITULO": "Zapotitlán Tablas",
    "UBICACION_GEOGRAFICA": "12072"
  },
  {
    "TITULO": "Zirándaro",
    "UBICACION_GEOGRAFICA": "12073"
  },
  {
    "TITULO": "Zitlala",
    "UBICACION_GEOGRAFICA": "12074"
  },
  {
    "TITULO": "Eduardo Neri",
    "UBICACION_GEOGRAFICA": "12075"
  },
  {
    "TITULO": "Acatepec",
    "UBICACION_GEOGRAFICA": "12076"
  },
  {
    "TITULO": "Marquelia",
    "UBICACION_GEOGRAFICA": "12077"
  },
  {
    "TITULO": "Cochoapa el grande",
    "UBICACION_GEOGRAFICA": "12078"
  },
  {
    "TITULO": "José Joaquin de Herrera",
    "UBICACION_GEOGRAFICA": "12079"
  },
  {
    "TITULO": "Juchitán",
    "UBICACION_GEOGRAFICA": "12080"
  },
  {
    "TITULO": "Iliatenco",
    "UBICACION_GEOGRAFICA": "12081"
  },
  {
    "TITULO": "Hidalgo",
    "UBICACION_GEOGRAFICA": "13"
  },
  {
    "TITULO": "Acatlán",
    "UBICACION_GEOGRAFICA": "13001"
  },
  {
    "TITULO": "Acaxochitlán",
    "UBICACION_GEOGRAFICA": "13002"
  },
  {
    "TITULO": "Actopan",
    "UBICACION_GEOGRAFICA": "13003"
  },
  {
    "TITULO": "Agua Blanca de Iturbide",
    "UBICACION_GEOGRAFICA": "13004"
  },
  {
    "TITULO": "Ajacuba",
    "UBICACION_GEOGRAFICA": "13005"
  },
  {
    "TITULO": "Alfajayucan",
    "UBICACION_GEOGRAFICA": "13006"
  },
  {
    "TITULO": "Almoloya",
    "UBICACION_GEOGRAFICA": "13007"
  },
  {
    "TITULO": "Apan",
    "UBICACION_GEOGRAFICA": "13008"
  },
  {
    "TITULO": "El Arenal",
    "UBICACION_GEOGRAFICA": "13009"
  },
  {
    "TITULO": "Atitalaquia",
    "UBICACION_GEOGRAFICA": "13010"
  },
  {
    "TITULO": "Atlapexco",
    "UBICACION_GEOGRAFICA": "13011"
  },
  {
    "TITULO": "Atotonilco el Grande",
    "UBICACION_GEOGRAFICA": "13012"
  },
  {
    "TITULO": "Atotonilco de Tula",
    "UBICACION_GEOGRAFICA": "13013"
  },
  {
    "TITULO": "Calnali",
    "UBICACION_GEOGRAFICA": "13014"
  },
  {
    "TITULO": "Cardonal",
    "UBICACION_GEOGRAFICA": "13015"
  },
  {
    "TITULO": "Cuautepec de Hinojosa",
    "UBICACION_GEOGRAFICA": "13016"
  },
  {
    "TITULO": "Chapantongo",
    "UBICACION_GEOGRAFICA": "13017"
  },
  {
    "TITULO": "Chapulhuacán",
    "UBICACION_GEOGRAFICA": "13018"
  },
  {
    "TITULO": "Chilcuautla",
    "UBICACION_GEOGRAFICA": "13019"
  },
  {
    "TITULO": "Eloxochitlán",
    "UBICACION_GEOGRAFICA": "13020"
  },
  {
    "TITULO": "Emiliano Zapata",
    "UBICACION_GEOGRAFICA": "13021"
  },
  {
    "TITULO": "Epazoyucan",
    "UBICACION_GEOGRAFICA": "13022"
  },
  {
    "TITULO": "Francisco I. Madero",
    "UBICACION_GEOGRAFICA": "13023"
  },
  {
    "TITULO": "Huasca de Ocampo",
    "UBICACION_GEOGRAFICA": "13024"
  },
  {
    "TITULO": "Huautla",
    "UBICACION_GEOGRAFICA": "13025"
  },
  {
    "TITULO": "Huazalingo",
    "UBICACION_GEOGRAFICA": "13026"
  },
  {
    "TITULO": "Huehuetla",
    "UBICACION_GEOGRAFICA": "13027"
  },
  {
    "TITULO": "Huejutla de Reyes",
    "UBICACION_GEOGRAFICA": "13028"
  },
  {
    "TITULO": "Huichapan",
    "UBICACION_GEOGRAFICA": "13029"
  },
  {
    "TITULO": "Ixmiquilpan",
    "UBICACION_GEOGRAFICA": "13030"
  },
  {
    "TITULO": "Jacala de Ledezma",
    "UBICACION_GEOGRAFICA": "13031"
  },
  {
    "TITULO": "Jaltocán",
    "UBICACION_GEOGRAFICA": "13032"
  },
  {
    "TITULO": "Juárez Hidalgo",
    "UBICACION_GEOGRAFICA": "13033"
  },
  {
    "TITULO": "Lolotla",
    "UBICACION_GEOGRAFICA": "13034"
  },
  {
    "TITULO": "Metepec",
    "UBICACION_GEOGRAFICA": "13035"
  },
  {
    "TITULO": "San Agustín Metzquititlán",
    "UBICACION_GEOGRAFICA": "13036"
  },
  {
    "TITULO": "Metztitlán",
    "UBICACION_GEOGRAFICA": "13037"
  },
  {
    "TITULO": "Mineral del Chico",
    "UBICACION_GEOGRAFICA": "13038"
  },
  {
    "TITULO": "Mineral del Monte",
    "UBICACION_GEOGRAFICA": "13039"
  },
  {
    "TITULO": "La Misión, Hidalgo",
    "UBICACION_GEOGRAFICA": "13040"
  },
  {
    "TITULO": "Mixquiahuala de Juárez",
    "UBICACION_GEOGRAFICA": "13041"
  },
  {
    "TITULO": "Molango de Escamilla",
    "UBICACION_GEOGRAFICA": "13042"
  },
  {
    "TITULO": "Nicolás Flores",
    "UBICACION_GEOGRAFICA": "13043"
  },
  {
    "TITULO": "Nopala de Villagrán",
    "UBICACION_GEOGRAFICA": "13044"
  },
  {
    "TITULO": "Omitlán de Juárez",
    "UBICACION_GEOGRAFICA": "13045"
  },
  {
    "TITULO": "San Felipe Orizatlán",
    "UBICACION_GEOGRAFICA": "13046"
  },
  {
    "TITULO": "Pacula",
    "UBICACION_GEOGRAFICA": "13047"
  },
  {
    "TITULO": "Pachuca de Soto",
    "UBICACION_GEOGRAFICA": "13048"
  },
  {
    "TITULO": "Pisaflores, Hidalgo",
    "UBICACION_GEOGRAFICA": "13049"
  },
  {
    "TITULO": "Progreso de Obregón",
    "UBICACION_GEOGRAFICA": "13050"
  },
  {
    "TITULO": "Mineral de la Reforma",
    "UBICACION_GEOGRAFICA": "13051"
  },
  {
    "TITULO": "San Agustín Tlaxiaca",
    "UBICACION_GEOGRAFICA": "13052"
  },
  {
    "TITULO": "San Bartolo Tutotepec",
    "UBICACION_GEOGRAFICA": "13053"
  },
  {
    "TITULO": "San Salvador",
    "UBICACION_GEOGRAFICA": "13054"
  },
  {
    "TITULO": "Santiago de Anaya",
    "UBICACION_GEOGRAFICA": "13055"
  },
  {
    "TITULO": "Santiago Tulantepec de Lugo Guerrero",
    "UBICACION_GEOGRAFICA": "13056"
  },
  {
    "TITULO": "Singuilucan",
    "UBICACION_GEOGRAFICA": "13057"
  },
  {
    "TITULO": "Tasquillo",
    "UBICACION_GEOGRAFICA": "13058"
  },
  {
    "TITULO": "Tecozautla",
    "UBICACION_GEOGRAFICA": "13059"
  },
  {
    "TITULO": "Tenango de Doria",
    "UBICACION_GEOGRAFICA": "13060"
  },
  {
    "TITULO": "Tepeapulco",
    "UBICACION_GEOGRAFICA": "13061"
  },
  {
    "TITULO": "Tepehuacán de Guerrero",
    "UBICACION_GEOGRAFICA": "13062"
  },
  {
    "TITULO": "Tepeji del Río de Ocampo",
    "UBICACION_GEOGRAFICA": "13063"
  },
  {
    "TITULO": "Tepetitlán",
    "UBICACION_GEOGRAFICA": "13064"
  },
  {
    "TITULO": "Tetepango",
    "UBICACION_GEOGRAFICA": "13065"
  },
  {
    "TITULO": "Villa de Tezontepec",
    "UBICACION_GEOGRAFICA": "13066"
  },
  {
    "TITULO": "Tezontepec de Aldama",
    "UBICACION_GEOGRAFICA": "13067"
  },
  {
    "TITULO": "Tianguistengo",
    "UBICACION_GEOGRAFICA": "13068"
  },
  {
    "TITULO": "Tizayuca",
    "UBICACION_GEOGRAFICA": "13069"
  },
  {
    "TITULO": "Tlahuelilpan",
    "UBICACION_GEOGRAFICA": "13070"
  },
  {
    "TITULO": "Tlahuiltepa",
    "UBICACION_GEOGRAFICA": "13071"
  },
  {
    "TITULO": "Tlanalapa",
    "UBICACION_GEOGRAFICA": "13072"
  },
  {
    "TITULO": "Tlanchinol",
    "UBICACION_GEOGRAFICA": "13073"
  },
  {
    "TITULO": "Tlaxcoapan",
    "UBICACION_GEOGRAFICA": "13074"
  },
  {
    "TITULO": "Tolcayuca",
    "UBICACION_GEOGRAFICA": "13075"
  },
  {
    "TITULO": "Tula de Allende",
    "UBICACION_GEOGRAFICA": "13076"
  },
  {
    "TITULO": "Tulancingo de Bravo",
    "UBICACION_GEOGRAFICA": "13077"
  },
  {
    "TITULO": "Xochiatipan",
    "UBICACION_GEOGRAFICA": "13078"
  },
  {
    "TITULO": "Xochicoatlán",
    "UBICACION_GEOGRAFICA": "13079"
  },
  {
    "TITULO": "Yahualica",
    "UBICACION_GEOGRAFICA": "13080"
  },
  {
    "TITULO": "Zacualtipán de Ángeles",
    "UBICACION_GEOGRAFICA": "13081"
  },
  {
    "TITULO": "Zapotlán de Juárez",
    "UBICACION_GEOGRAFICA": "13082"
  },
  {
    "TITULO": "Zempoala",
    "UBICACION_GEOGRAFICA": "13083"
  },
  {
    "TITULO": "Zimapán",
    "UBICACION_GEOGRAFICA": "13084"
  },
  {
    "TITULO": "Jalisco",
    "UBICACION_GEOGRAFICA": "14"
  },
  {
    "TITULO": "Acatic",
    "UBICACION_GEOGRAFICA": "14001"
  },
  {
    "TITULO": "Acatlán de Juárez",
    "UBICACION_GEOGRAFICA": "14002"
  },
  {
    "TITULO": "Ahualulco de Mercado",
    "UBICACION_GEOGRAFICA": "14003"
  },
  {
    "TITULO": "Amacueca",
    "UBICACION_GEOGRAFICA": "14004"
  },
  {
    "TITULO": "Amatitán",
    "UBICACION_GEOGRAFICA": "14005"
  },
  {
    "TITULO": "Ameca",
    "UBICACION_GEOGRAFICA": "14006"
  },
  {
    "TITULO": "San Juanito de Escobedo",
    "UBICACION_GEOGRAFICA": "14007"
  },
  {
    "TITULO": "Arandas",
    "UBICACION_GEOGRAFICA": "14008"
  },
  {
    "TITULO": "EL Arenal",
    "UBICACION_GEOGRAFICA": "14009"
  },
  {
    "TITULO": "Atemajac de Brizuela",
    "UBICACION_GEOGRAFICA": "14010"
  },
  {
    "TITULO": "Atengo",
    "UBICACION_GEOGRAFICA": "14011"
  },
  {
    "TITULO": "Atenguillo",
    "UBICACION_GEOGRAFICA": "14012"
  },
  {
    "TITULO": "Atotonilco el Alto",
    "UBICACION_GEOGRAFICA": "14013"
  },
  {
    "TITULO": "Atoyac, Jalisco",
    "UBICACION_GEOGRAFICA": "14014"
  },
  {
    "TITULO": "Autlán de Navarro",
    "UBICACION_GEOGRAFICA": "14015"
  },
  {
    "TITULO": "Ayotlán",
    "UBICACION_GEOGRAFICA": "14016"
  },
  {
    "TITULO": "Ayutla",
    "UBICACION_GEOGRAFICA": "14017"
  },
  {
    "TITULO": "La Barca",
    "UBICACION_GEOGRAFICA": "14018"
  },
  {
    "TITULO": "Bolaños",
    "UBICACION_GEOGRAFICA": "14019"
  },
  {
    "TITULO": "Cabo Corrientes",
    "UBICACION_GEOGRAFICA": "14020"
  },
  {
    "TITULO": "Casimiro Castillo",
    "UBICACION_GEOGRAFICA": "14021"
  },
  {
    "TITULO": "Cihuatlán",
    "UBICACION_GEOGRAFICA": "14022"
  },
  {
    "TITULO": "Zapotlán el Grande",
    "UBICACION_GEOGRAFICA": "14023"
  },
  {
    "TITULO": "Cocula",
    "UBICACION_GEOGRAFICA": "14024"
  },
  {
    "TITULO": "Colotlán",
    "UBICACION_GEOGRAFICA": "14025"
  },
  {
    "TITULO": "Concepción de Buenos Aires",
    "UBICACION_GEOGRAFICA": "14026"
  },
  {
    "TITULO": "Cuautitlán de García Barragán",
    "UBICACION_GEOGRAFICA": "14027"
  },
  {
    "TITULO": "Cuautla",
    "UBICACION_GEOGRAFICA": "14028"
  },
  {
    "TITULO": "Cuquío",
    "UBICACION_GEOGRAFICA": "14029"
  },
  {
    "TITULO": "Chapala",
    "UBICACION_GEOGRAFICA": "14030"
  },
  {
    "TITULO": "Chimaltitán",
    "UBICACION_GEOGRAFICA": "14031"
  },
  {
    "TITULO": "Chiquilistlán",
    "UBICACION_GEOGRAFICA": "14032"
  },
  {
    "TITULO": "Degollado",
    "UBICACION_GEOGRAFICA": "14033"
  },
  {
    "TITULO": "Ejutla",
    "UBICACION_GEOGRAFICA": "14034"
  },
  {
    "TITULO": "Encarnación de Díaz",
    "UBICACION_GEOGRAFICA": "14035"
  },
  {
    "TITULO": "Etzatlán",
    "UBICACION_GEOGRAFICA": "14036"
  },
  {
    "TITULO": "El Grullo",
    "UBICACION_GEOGRAFICA": "14037"
  },
  {
    "TITULO": "Guachinango",
    "UBICACION_GEOGRAFICA": "14038"
  },
  {
    "TITULO": "Guadalajara",
    "UBICACION_GEOGRAFICA": "14039"
  },
  {
    "TITULO": "Hostotipaquillo",
    "UBICACION_GEOGRAFICA": "14040"
  },
  {
    "TITULO": "Huejúcar",
    "UBICACION_GEOGRAFICA": "14041"
  },
  {
    "TITULO": "Huejuquilla el Alto",
    "UBICACION_GEOGRAFICA": "14042"
  },
  {
    "TITULO": "La Huerta",
    "UBICACION_GEOGRAFICA": "14043"
  },
  {
    "TITULO": "Ixtlahuacán de los Membrillos",
    "UBICACION_GEOGRAFICA": "14044"
  },
  {
    "TITULO": "Ixtlahuacán del Río",
    "UBICACION_GEOGRAFICA": "14045"
  },
  {
    "TITULO": "Jalostotitlán",
    "UBICACION_GEOGRAFICA": "14046"
  },
  {
    "TITULO": "Jamay",
    "UBICACION_GEOGRAFICA": "14047"
  },
  {
    "TITULO": "Jesús María, Jalisco",
    "UBICACION_GEOGRAFICA": "14048"
  },
  {
    "TITULO": "Jilotlán de los Dolores",
    "UBICACION_GEOGRAFICA": "14049"
  },
  {
    "TITULO": "Jocotepec",
    "UBICACION_GEOGRAFICA": "14050"
  },
  {
    "TITULO": "Juanacatlán",
    "UBICACION_GEOGRAFICA": "14051"
  },
  {
    "TITULO": "Juchitlán",
    "UBICACION_GEOGRAFICA": "14052"
  },
  {
    "TITULO": "Lagos de Moreno",
    "UBICACION_GEOGRAFICA": "14053"
  },
  {
    "TITULO": "El Limón",
    "UBICACION_GEOGRAFICA": "14054"
  },
  {
    "TITULO": "Magdalena",
    "UBICACION_GEOGRAFICA": "14055"
  },
  {
    "TITULO": "Santa María del Oro",
    "UBICACION_GEOGRAFICA": "14056"
  },
  {
    "TITULO": "La Manzanilla de la Paz",
    "UBICACION_GEOGRAFICA": "14057"
  },
  {
    "TITULO": "Mascota",
    "UBICACION_GEOGRAFICA": "14058"
  },
  {
    "TITULO": "Mazamitla",
    "UBICACION_GEOGRAFICA": "14059"
  },
  {
    "TITULO": "Mexticacán",
    "UBICACION_GEOGRAFICA": "14060"
  },
  {
    "TITULO": "Mezquitic",
    "UBICACION_GEOGRAFICA": "14061"
  },
  {
    "TITULO": "Mixtlán",
    "UBICACION_GEOGRAFICA": "14062"
  },
  {
    "TITULO": "Ocotlán",
    "UBICACION_GEOGRAFICA": "14063"
  },
  {
    "TITULO": "Ojuelos de Jalisco",
    "UBICACION_GEOGRAFICA": "14064"
  },
  {
    "TITULO": "Pihuamo",
    "UBICACION_GEOGRAFICA": "14065"
  },
  {
    "TITULO": "Poncitlán",
    "UBICACION_GEOGRAFICA": "14066"
  },
  {
    "TITULO": "Puerto Vallarta",
    "UBICACION_GEOGRAFICA": "14067"
  },
  {
    "TITULO": "Villa Purificación",
    "UBICACION_GEOGRAFICA": "14068"
  },
  {
    "TITULO": "Quitupan",
    "UBICACION_GEOGRAFICA": "14069"
  },
  {
    "TITULO": "El Salto",
    "UBICACION_GEOGRAFICA": "14070"
  },
  {
    "TITULO": "San Cristóbal de la Barranca",
    "UBICACION_GEOGRAFICA": "14071"
  },
  {
    "TITULO": "San Diego de Alejandría",
    "UBICACION_GEOGRAFICA": "14072"
  },
  {
    "TITULO": "San Juan de los Lagos",
    "UBICACION_GEOGRAFICA": "14073"
  },
  {
    "TITULO": "San Julián",
    "UBICACION_GEOGRAFICA": "14074"
  },
  {
    "TITULO": "San Marcos",
    "UBICACION_GEOGRAFICA": "14075"
  },
  {
    "TITULO": "San Martín de Bolaños",
    "UBICACION_GEOGRAFICA": "14076"
  },
  {
    "TITULO": "San Martín Hidalgo",
    "UBICACION_GEOGRAFICA": "14077"
  },
  {
    "TITULO": "San Miguel el Alto",
    "UBICACION_GEOGRAFICA": "14078"
  },
  {
    "TITULO": "Gómez Farías",
    "UBICACION_GEOGRAFICA": "14079"
  },
  {
    "TITULO": "San Sebastián del Oeste",
    "UBICACION_GEOGRAFICA": "14080"
  },
  {
    "TITULO": "Santa María de los Ángeles",
    "UBICACION_GEOGRAFICA": "14081"
  },
  {
    "TITULO": "Sayula",
    "UBICACION_GEOGRAFICA": "14082"
  },
  {
    "TITULO": "Tala",
    "UBICACION_GEOGRAFICA": "14083"
  },
  {
    "TITULO": "Talpa de Allende",
    "UBICACION_GEOGRAFICA": "14084"
  },
  {
    "TITULO": "Tamazula de Gordiano",
    "UBICACION_GEOGRAFICA": "14085"
  },
  {
    "TITULO": "Tapalpa",
    "UBICACION_GEOGRAFICA": "14086"
  },
  {
    "TITULO": "Tecalitlán",
    "UBICACION_GEOGRAFICA": "14087"
  },
  {
    "TITULO": "Tecolotlán",
    "UBICACION_GEOGRAFICA": "14088"
  },
  {
    "TITULO": "Techaluta de Montenegro",
    "UBICACION_GEOGRAFICA": "14089"
  },
  {
    "TITULO": "Tenamaxtlán",
    "UBICACION_GEOGRAFICA": "14090"
  },
  {
    "TITULO": "Teocaltiche",
    "UBICACION_GEOGRAFICA": "14091"
  },
  {
    "TITULO": "Teocuitatlán de Corona",
    "UBICACION_GEOGRAFICA": "14092"
  },
  {
    "TITULO": "Tepatitlán de Morelos",
    "UBICACION_GEOGRAFICA": "14093"
  },
  {
    "TITULO": "Tequila",
    "UBICACION_GEOGRAFICA": "14094"
  },
  {
    "TITULO": "Teuchitlán",
    "UBICACION_GEOGRAFICA": "14095"
  },
  {
    "TITULO": "Tizapán el Alto",
    "UBICACION_GEOGRAFICA": "14096"
  },
  {
    "TITULO": "Tlajomulco de Zúñiga",
    "UBICACION_GEOGRAFICA": "14097"
  },
  {
    "TITULO": "Tlaquepaque",
    "UBICACION_GEOGRAFICA": "14098"
  },
  {
    "TITULO": "Tolimán",
    "UBICACION_GEOGRAFICA": "14099"
  },
  {
    "TITULO": "Tomatlán",
    "UBICACION_GEOGRAFICA": "14100"
  },
  {
    "TITULO": "Tonalá",
    "UBICACION_GEOGRAFICA": "14101"
  },
  {
    "TITULO": "Tonaya",
    "UBICACION_GEOGRAFICA": "14102"
  },
  {
    "TITULO": "Tonila",
    "UBICACION_GEOGRAFICA": "14103"
  },
  {
    "TITULO": "Totatiche",
    "UBICACION_GEOGRAFICA": "14104"
  },
  {
    "TITULO": "Tototlán",
    "UBICACION_GEOGRAFICA": "14105"
  },
  {
    "TITULO": "Tuxcacuesco",
    "UBICACION_GEOGRAFICA": "14106"
  },
  {
    "TITULO": "Tuxcueca",
    "UBICACION_GEOGRAFICA": "14107"
  },
  {
    "TITULO": "Tuxpan",
    "UBICACION_GEOGRAFICA": "14108"
  },
  {
    "TITULO": "Unión de San Antonio",
    "UBICACION_GEOGRAFICA": "14109"
  },
  {
    "TITULO": "Unión de Tula",
    "UBICACION_GEOGRAFICA": "14110"
  },
  {
    "TITULO": "Valle de Guadalupe",
    "UBICACION_GEOGRAFICA": "14111"
  },
  {
    "TITULO": "Valle de Juárez",
    "UBICACION_GEOGRAFICA": "14112"
  },
  {
    "TITULO": "San Gabriel",
    "UBICACION_GEOGRAFICA": "14113"
  },
  {
    "TITULO": "Villa Corona",
    "UBICACION_GEOGRAFICA": "14114"
  },
  {
    "TITULO": "Villa Guerrero",
    "UBICACION_GEOGRAFICA": "14115"
  },
  {
    "TITULO": "Villa Hidalgo",
    "UBICACION_GEOGRAFICA": "14116"
  },
  {
    "TITULO": "Cañadas de Obregón",
    "UBICACION_GEOGRAFICA": "14117"
  },
  {
    "TITULO": "Yahualica de González Gallo",
    "UBICACION_GEOGRAFICA": "14118"
  },
  {
    "TITULO": "Zacoalco de Torres",
    "UBICACION_GEOGRAFICA": "14119"
  },
  {
    "TITULO": "Zapopan",
    "UBICACION_GEOGRAFICA": "14120"
  },
  {
    "TITULO": "Zapotiltic",
    "UBICACION_GEOGRAFICA": "14121"
  },
  {
    "TITULO": "Zapotitlán de Vadillo",
    "UBICACION_GEOGRAFICA": "14122"
  },
  {
    "TITULO": "Zapotlán del Rey",
    "UBICACION_GEOGRAFICA": "14123"
  },
  {
    "TITULO": "Zapotlanejo",
    "UBICACION_GEOGRAFICA": "14124"
  },
  {
    "TITULO": "San Ignacio Cerro Gordo",
    "UBICACION_GEOGRAFICA": "14125"
  },
  {
    "TITULO": "México",
    "UBICACION_GEOGRAFICA": "15"
  },
  {
    "TITULO": "Acambay",
    "UBICACION_GEOGRAFICA": "15001"
  },
  {
    "TITULO": "Acolman",
    "UBICACION_GEOGRAFICA": "15002"
  },
  {
    "TITULO": "Aculco",
    "UBICACION_GEOGRAFICA": "15003"
  },
  {
    "TITULO": "Almoloya de Alquisiras",
    "UBICACION_GEOGRAFICA": "15004"
  },
  {
    "TITULO": "Almoloya de Juárez",
    "UBICACION_GEOGRAFICA": "15005"
  },
  {
    "TITULO": "Almoloya del Río",
    "UBICACION_GEOGRAFICA": "15006"
  },
  {
    "TITULO": "Amanalco",
    "UBICACION_GEOGRAFICA": "15007"
  },
  {
    "TITULO": "Amatepec",
    "UBICACION_GEOGRAFICA": "15008"
  },
  {
    "TITULO": "Amecameca",
    "UBICACION_GEOGRAFICA": "15009"
  },
  {
    "TITULO": "Apaxco",
    "UBICACION_GEOGRAFICA": "15010"
  },
  {
    "TITULO": "Atenco",
    "UBICACION_GEOGRAFICA": "15011"
  },
  {
    "TITULO": "Atizapán",
    "UBICACION_GEOGRAFICA": "15012"
  },
  {
    "TITULO": "Atizapán de Zaragoza",
    "UBICACION_GEOGRAFICA": "15013"
  },
  {
    "TITULO": "Atlacomulco",
    "UBICACION_GEOGRAFICA": "15014"
  },
  {
    "TITULO": "Atlautla",
    "UBICACION_GEOGRAFICA": "15015"
  },
  {
    "TITULO": "Axapusco",
    "UBICACION_GEOGRAFICA": "15016"
  },
  {
    "TITULO": "Ayapango",
    "UBICACION_GEOGRAFICA": "15017"
  },
  {
    "TITULO": "Calimaya",
    "UBICACION_GEOGRAFICA": "15018"
  },
  {
    "TITULO": "Capulhuac",
    "UBICACION_GEOGRAFICA": "15019"
  },
  {
    "TITULO": "Coacalco de Berriozábal",
    "UBICACION_GEOGRAFICA": "15020"
  },
  {
    "TITULO": "Coatepec Harinas",
    "UBICACION_GEOGRAFICA": "15021"
  },
  {
    "TITULO": "Cocotitlán",
    "UBICACION_GEOGRAFICA": "15022"
  },
  {
    "TITULO": "Coyotepec",
    "UBICACION_GEOGRAFICA": "15023"
  },
  {
    "TITULO": "Cuautitlán",
    "UBICACION_GEOGRAFICA": "15024"
  },
  {
    "TITULO": "Chalco",
    "UBICACION_GEOGRAFICA": "15025"
  },
  {
    "TITULO": "Chapa de Mota",
    "UBICACION_GEOGRAFICA": "15026"
  },
  {
    "TITULO": "Chapultepec",
    "UBICACION_GEOGRAFICA": "15027"
  },
  {
    "TITULO": "Chiautla",
    "UBICACION_GEOGRAFICA": "15028"
  },
  {
    "TITULO": "Chicoloapan",
    "UBICACION_GEOGRAFICA": "15029"
  },
  {
    "TITULO": "Chiconcuac",
    "UBICACION_GEOGRAFICA": "15030"
  },
  {
    "TITULO": "Chimalhuacán",
    "UBICACION_GEOGRAFICA": "15031"
  },
  {
    "TITULO": "Donato Guerra",
    "UBICACION_GEOGRAFICA": "15032"
  },
  {
    "TITULO": "Ecatepec de Morelos",
    "UBICACION_GEOGRAFICA": "15033"
  },
  {
    "TITULO": "Ecatzingo",
    "UBICACION_GEOGRAFICA": "15034"
  },
  {
    "TITULO": "Huehuetoca",
    "UBICACION_GEOGRAFICA": "15035"
  },
  {
    "TITULO": "Hueypoxtla",
    "UBICACION_GEOGRAFICA": "15036"
  },
  {
    "TITULO": "Huixquilucan",
    "UBICACION_GEOGRAFICA": "15037"
  },
  {
    "TITULO": "Isidro Fabela",
    "UBICACION_GEOGRAFICA": "15038"
  },
  {
    "TITULO": "Ixtapaluca",
    "UBICACION_GEOGRAFICA": "15039"
  },
  {
    "TITULO": "Ixtapan de la Sal",
    "UBICACION_GEOGRAFICA": "15040"
  },
  {
    "TITULO": "Ixtapan del Oro",
    "UBICACION_GEOGRAFICA": "15041"
  },
  {
    "TITULO": "Ixtlahuaca",
    "UBICACION_GEOGRAFICA": "15042"
  },
  {
    "TITULO": "Xalatlaco",
    "UBICACION_GEOGRAFICA": "15043"
  },
  {
    "TITULO": "Jaltenco",
    "UBICACION_GEOGRAFICA": "15044"
  },
  {
    "TITULO": "Jilotepec",
    "UBICACION_GEOGRAFICA": "15045"
  },
  {
    "TITULO": "Jilotzingo",
    "UBICACION_GEOGRAFICA": "15046"
  },
  {
    "TITULO": "Jiquipilco",
    "UBICACION_GEOGRAFICA": "15047"
  },
  {
    "TITULO": "Jocotitlán",
    "UBICACION_GEOGRAFICA": "15048"
  },
  {
    "TITULO": "Joquicingo",
    "UBICACION_GEOGRAFICA": "15049"
  },
  {
    "TITULO": "Juchitepec",
    "UBICACION_GEOGRAFICA": "15050"
  },
  {
    "TITULO": "Lerma",
    "UBICACION_GEOGRAFICA": "15051"
  },
  {
    "TITULO": "Malinalco",
    "UBICACION_GEOGRAFICA": "15052"
  },
  {
    "TITULO": "Melchor Ocampo",
    "UBICACION_GEOGRAFICA": "15053"
  },
  {
    "TITULO": "Metepec",
    "UBICACION_GEOGRAFICA": "15054"
  },
  {
    "TITULO": "Mexicaltzingo",
    "UBICACION_GEOGRAFICA": "15055"
  },
  {
    "TITULO": "Morelos",
    "UBICACION_GEOGRAFICA": "15056"
  },
  {
    "TITULO": "Naucalpan de Juárez",
    "UBICACION_GEOGRAFICA": "15057"
  },
  {
    "TITULO": "Nezahualcóyotl",
    "UBICACION_GEOGRAFICA": "15058"
  },
  {
    "TITULO": "Nextlalpan",
    "UBICACION_GEOGRAFICA": "15059"
  },
  {
    "TITULO": "Nicolás Romero",
    "UBICACION_GEOGRAFICA": "15060"
  },
  {
    "TITULO": "Nopaltepec",
    "UBICACION_GEOGRAFICA": "15061"
  },
  {
    "TITULO": "Ocoyoacac",
    "UBICACION_GEOGRAFICA": "15062"
  },
  {
    "TITULO": "Ocuilan",
    "UBICACION_GEOGRAFICA": "15063"
  },
  {
    "TITULO": "El Oro",
    "UBICACION_GEOGRAFICA": "15064"
  },
  {
    "TITULO": "Otumba",
    "UBICACION_GEOGRAFICA": "15065"
  },
  {
    "TITULO": "Otzoloapan",
    "UBICACION_GEOGRAFICA": "15066"
  },
  {
    "TITULO": "Otzolotepec",
    "UBICACION_GEOGRAFICA": "15067"
  },
  {
    "TITULO": "Ozumba",
    "UBICACION_GEOGRAFICA": "15068"
  },
  {
    "TITULO": "Papalotla",
    "UBICACION_GEOGRAFICA": "15069"
  },
  {
    "TITULO": "La Paz, México",
    "UBICACION_GEOGRAFICA": "15070"
  },
  {
    "TITULO": "Polotitlán",
    "UBICACION_GEOGRAFICA": "15071"
  },
  {
    "TITULO": "Rayón",
    "UBICACION_GEOGRAFICA": "15072"
  },
  {
    "TITULO": "San Antonio la Isla",
    "UBICACION_GEOGRAFICA": "15073"
  },
  {
    "TITULO": "San Felipe del Progreso",
    "UBICACION_GEOGRAFICA": "15074"
  },
  {
    "TITULO": "San Martín de las Pirámides",
    "UBICACION_GEOGRAFICA": "15075"
  },
  {
    "TITULO": "San Mateo Atenco",
    "UBICACION_GEOGRAFICA": "15076"
  },
  {
    "TITULO": "San Simón de Guerrero",
    "UBICACION_GEOGRAFICA": "15077"
  },
  {
    "TITULO": "Santo Tomás",
    "UBICACION_GEOGRAFICA": "15078"
  },
  {
    "TITULO": "Soyaniquilpan de Juárez",
    "UBICACION_GEOGRAFICA": "15079"
  },
  {
    "TITULO": "Sultepec",
    "UBICACION_GEOGRAFICA": "15080"
  },
  {
    "TITULO": "Tecámac",
    "UBICACION_GEOGRAFICA": "15081"
  },
  {
    "TITULO": "Tejupilco",
    "UBICACION_GEOGRAFICA": "15082"
  },
  {
    "TITULO": "Temamatla",
    "UBICACION_GEOGRAFICA": "15083"
  },
  {
    "TITULO": "Temascalapa",
    "UBICACION_GEOGRAFICA": "15084"
  },
  {
    "TITULO": "Temascalcingo",
    "UBICACION_GEOGRAFICA": "15085"
  },
  {
    "TITULO": "Temascaltepec",
    "UBICACION_GEOGRAFICA": "15086"
  },
  {
    "TITULO": "Temoaya",
    "UBICACION_GEOGRAFICA": "15087"
  },
  {
    "TITULO": "Tenancingo",
    "UBICACION_GEOGRAFICA": "15088"
  },
  {
    "TITULO": "Tenango del Aire",
    "UBICACION_GEOGRAFICA": "15089"
  },
  {
    "TITULO": "Tenango del Valle",
    "UBICACION_GEOGRAFICA": "15090"
  },
  {
    "TITULO": "Teoloyucán",
    "UBICACION_GEOGRAFICA": "15091"
  },
  {
    "TITULO": "Teotihuacán",
    "UBICACION_GEOGRAFICA": "15092"
  },
  {
    "TITULO": "Tepetlaoxtoc",
    "UBICACION_GEOGRAFICA": "15093"
  },
  {
    "TITULO": "Tepetlixpa",
    "UBICACION_GEOGRAFICA": "15094"
  },
  {
    "TITULO": "Tepotzotlán",
    "UBICACION_GEOGRAFICA": "15095"
  },
  {
    "TITULO": "Tequixquiac",
    "UBICACION_GEOGRAFICA": "15096"
  },
  {
    "TITULO": "Texcaltitlán",
    "UBICACION_GEOGRAFICA": "15097"
  },
  {
    "TITULO": "Texcalyacac",
    "UBICACION_GEOGRAFICA": "15098"
  },
  {
    "TITULO": "Texcoco",
    "UBICACION_GEOGRAFICA": "15099"
  },
  {
    "TITULO": "Tezoyuca",
    "UBICACION_GEOGRAFICA": "15100"
  },
  {
    "TITULO": "Tianguistenco",
    "UBICACION_GEOGRAFICA": "15101"
  },
  {
    "TITULO": "Timilpan",
    "UBICACION_GEOGRAFICA": "15102"
  },
  {
    "TITULO": "Tlalmanalco",
    "UBICACION_GEOGRAFICA": "15103"
  },
  {
    "TITULO": "Tlalnepantla de Baz",
    "UBICACION_GEOGRAFICA": "15104"
  },
  {
    "TITULO": "Tlatlaya",
    "UBICACION_GEOGRAFICA": "15105"
  },
  {
    "TITULO": "Toluca",
    "UBICACION_GEOGRAFICA": "15106"
  },
  {
    "TITULO": "Tonatico",
    "UBICACION_GEOGRAFICA": "15107"
  },
  {
    "TITULO": "Tultepec",
    "UBICACION_GEOGRAFICA": "15108"
  },
  {
    "TITULO": "Tultitlán",
    "UBICACION_GEOGRAFICA": "15109"
  },
  {
    "TITULO": "Valle de Bravo",
    "UBICACION_GEOGRAFICA": "15110"
  },
  {
    "TITULO": "Villa de Allende",
    "UBICACION_GEOGRAFICA": "15111"
  },
  {
    "TITULO": "Villa del Carbón",
    "UBICACION_GEOGRAFICA": "15112"
  },
  {
    "TITULO": "Villa Guerrero",
    "UBICACION_GEOGRAFICA": "15113"
  },
  {
    "TITULO": "Villa Victoria",
    "UBICACION_GEOGRAFICA": "15114"
  },
  {
    "TITULO": "Xonacatlán",
    "UBICACION_GEOGRAFICA": "15115"
  },
  {
    "TITULO": "Zacazonapan",
    "UBICACION_GEOGRAFICA": "15116"
  },
  {
    "TITULO": "Zacualpan",
    "UBICACION_GEOGRAFICA": "15117"
  },
  {
    "TITULO": "Zinacantepec",
    "UBICACION_GEOGRAFICA": "15118"
  },
  {
    "TITULO": "Zumpahuacán",
    "UBICACION_GEOGRAFICA": "15119"
  },
  {
    "TITULO": "Zumpango",
    "UBICACION_GEOGRAFICA": "15120"
  },
  {
    "TITULO": "Cuautitlán Izcalli",
    "UBICACION_GEOGRAFICA": "15121"
  },
  {
    "TITULO": "Valle de Chalco Solidaridad",
    "UBICACION_GEOGRAFICA": "15122"
  },
  {
    "TITULO": "Luvianos",
    "UBICACION_GEOGRAFICA": "15123"
  },
  {
    "TITULO": "San José del Rincón",
    "UBICACION_GEOGRAFICA": "15124"
  },
  {
    "TITULO": "Tonanitla",
    "UBICACION_GEOGRAFICA": "15125"
  },
  {
    "TITULO": "Michoacán de Ocampo",
    "UBICACION_GEOGRAFICA": "16"
  },
  {
    "TITULO": "Michoacán",
    "UBICACION_GEOGRAFICA": "16"
  },
  {
    "TITULO": "Acuitzio",
    "UBICACION_GEOGRAFICA": "16001"
  },
  {
    "TITULO": "Aguililla",
    "UBICACION_GEOGRAFICA": "16002"
  },
  {
    "TITULO": "Álvaro Obregón",
    "UBICACION_GEOGRAFICA": "16003"
  },
  {
    "TITULO": "Angamacutiro",
    "UBICACION_GEOGRAFICA": "16004"
  },
  {
    "TITULO": "Angangueo",
    "UBICACION_GEOGRAFICA": "16005"
  },
  {
    "TITULO": "Apatzingán",
    "UBICACION_GEOGRAFICA": "16006"
  },
  {
    "TITULO": "Aporo",
    "UBICACION_GEOGRAFICA": "16007"
  },
  {
    "TITULO": "Aquila",
    "UBICACION_GEOGRAFICA": "16008"
  },
  {
    "TITULO": "Ario",
    "UBICACION_GEOGRAFICA": "16009"
  },
  {
    "TITULO": "Arteaga",
    "UBICACION_GEOGRAFICA": "16010"
  },
  {
    "TITULO": "Briseñas",
    "UBICACION_GEOGRAFICA": "16011"
  },
  {
    "TITULO": "Buenavista",
    "UBICACION_GEOGRAFICA": "16012"
  },
  {
    "TITULO": "Carácuaro",
    "UBICACION_GEOGRAFICA": "16013"
  },
  {
    "TITULO": "Coahuayana",
    "UBICACION_GEOGRAFICA": "16014"
  },
  {
    "TITULO": "Coalcomán de Vázquez Pallares",
    "UBICACION_GEOGRAFICA": "16015"
  },
  {
    "TITULO": "Coeneo",
    "UBICACION_GEOGRAFICA": "16016"
  },
  {
    "TITULO": "Contepec",
    "UBICACION_GEOGRAFICA": "16017"
  },
  {
    "TITULO": "Copándaro",
    "UBICACION_GEOGRAFICA": "16018"
  },
  {
    "TITULO": "Cotija",
    "UBICACION_GEOGRAFICA": "16019"
  },
  {
    "TITULO": "Cuitzeo",
    "UBICACION_GEOGRAFICA": "16020"
  },
  {
    "TITULO": "Charapan",
    "UBICACION_GEOGRAFICA": "16021"
  },
  {
    "TITULO": "Charo",
    "UBICACION_GEOGRAFICA": "16022"
  },
  {
    "TITULO": "Chavinda",
    "UBICACION_GEOGRAFICA": "16023"
  },
  {
    "TITULO": "Cherán",
    "UBICACION_GEOGRAFICA": "16024"
  },
  {
    "TITULO": "Chilchota",
    "UBICACION_GEOGRAFICA": "16025"
  },
  {
    "TITULO": "Chinicuila",
    "UBICACION_GEOGRAFICA": "16026"
  },
  {
    "TITULO": "Chucándiro",
    "UBICACION_GEOGRAFICA": "16027"
  },
  {
    "TITULO": "Churintzio",
    "UBICACION_GEOGRAFICA": "16028"
  },
  {
    "TITULO": "Churumuco",
    "UBICACION_GEOGRAFICA": "16029"
  },
  {
    "TITULO": "Ecuandureo",
    "UBICACION_GEOGRAFICA": "16030"
  },
  {
    "TITULO": "Epitacio Huerta",
    "UBICACION_GEOGRAFICA": "16031"
  },
  {
    "TITULO": "Erongarícuaro",
    "UBICACION_GEOGRAFICA": "16032"
  },
  {
    "TITULO": "Gabriel Zamora",
    "UBICACION_GEOGRAFICA": "16033"
  },
  {
    "TITULO": "Hidalgo",
    "UBICACION_GEOGRAFICA": "16034"
  },
  {
    "TITULO": "La Huacana",
    "UBICACION_GEOGRAFICA": "16035"
  },
  {
    "TITULO": "Huandacareo",
    "UBICACION_GEOGRAFICA": "16036"
  },
  {
    "TITULO": "Huaniqueo",
    "UBICACION_GEOGRAFICA": "16037"
  },
  {
    "TITULO": "Huetamo",
    "UBICACION_GEOGRAFICA": "16038"
  },
  {
    "TITULO": "Huiramba",
    "UBICACION_GEOGRAFICA": "16039"
  },
  {
    "TITULO": "Indaparapeo",
    "UBICACION_GEOGRAFICA": "16040"
  },
  {
    "TITULO": "Irimbo",
    "UBICACION_GEOGRAFICA": "16041"
  },
  {
    "TITULO": "Ixtlán",
    "UBICACION_GEOGRAFICA": "16042"
  },
  {
    "TITULO": "Jacona",
    "UBICACION_GEOGRAFICA": "16043"
  },
  {
    "TITULO": "Jiménez",
    "UBICACION_GEOGRAFICA": "16044"
  },
  {
    "TITULO": "Jiquilpan",
    "UBICACION_GEOGRAFICA": "16045"
  },
  {
    "TITULO": "Juárez",
    "UBICACION_GEOGRAFICA": "16046"
  },
  {
    "TITULO": "Jungapeo",
    "UBICACION_GEOGRAFICA": "16047"
  },
  {
    "TITULO": "Lagunillas",
    "UBICACION_GEOGRAFICA": "16048"
  },
  {
    "TITULO": "Madero",
    "UBICACION_GEOGRAFICA": "16049"
  },
  {
    "TITULO": "Maravatío",
    "UBICACION_GEOGRAFICA": "16050"
  },
  {
    "TITULO": "Marcos Castellanos",
    "UBICACION_GEOGRAFICA": "16051"
  },
  {
    "TITULO": "Lázaro Cárdenas",
    "UBICACION_GEOGRAFICA": "16052"
  },
  {
    "TITULO": "Morelia",
    "UBICACION_GEOGRAFICA": "16053"
  },
  {
    "TITULO": "Morelos, Morelos",
    "UBICACION_GEOGRAFICA": "16054"
  },
  {
    "TITULO": "Múgica",
    "UBICACION_GEOGRAFICA": "16055"
  },
  {
    "TITULO": "Nahuatzen",
    "UBICACION_GEOGRAFICA": "16056"
  },
  {
    "TITULO": "Nocupétaro",
    "UBICACION_GEOGRAFICA": "16057"
  },
  {
    "TITULO": "Nuevo Parangaricutiro",
    "UBICACION_GEOGRAFICA": "16058"
  },
  {
    "TITULO": "Nuevo Urecho",
    "UBICACION_GEOGRAFICA": "16059"
  },
  {
    "TITULO": "Numarán",
    "UBICACION_GEOGRAFICA": "16060"
  },
  {
    "TITULO": "Ocampo",
    "UBICACION_GEOGRAFICA": "16061"
  },
  {
    "TITULO": "Pajacuarán",
    "UBICACION_GEOGRAFICA": "16062"
  },
  {
    "TITULO": "Panindícuaro",
    "UBICACION_GEOGRAFICA": "16063"
  },
  {
    "TITULO": "Parácuaro",
    "UBICACION_GEOGRAFICA": "16064"
  },
  {
    "TITULO": "Paracho",
    "UBICACION_GEOGRAFICA": "16065"
  },
  {
    "TITULO": "Pátzcuaro",
    "UBICACION_GEOGRAFICA": "16066"
  },
  {
    "TITULO": "Penjamillo",
    "UBICACION_GEOGRAFICA": "16067"
  },
  {
    "TITULO": "Peribán",
    "UBICACION_GEOGRAFICA": "16068"
  },
  {
    "TITULO": "La Piedad",
    "UBICACION_GEOGRAFICA": "16069"
  },
  {
    "TITULO": "Purépero",
    "UBICACION_GEOGRAFICA": "16070"
  },
  {
    "TITULO": "Puruándiro",
    "UBICACION_GEOGRAFICA": "16071"
  },
  {
    "TITULO": "Queréndaro",
    "UBICACION_GEOGRAFICA": "16072"
  },
  {
    "TITULO": "Quiroga",
    "UBICACION_GEOGRAFICA": "16073"
  },
  {
    "TITULO": "Cojumatlán de Régules",
    "UBICACION_GEOGRAFICA": "16074"
  },
  {
    "TITULO": "Los Reyes",
    "UBICACION_GEOGRAFICA": "16075"
  },
  {
    "TITULO": "Sahuayo",
    "UBICACION_GEOGRAFICA": "16076"
  },
  {
    "TITULO": "San Lucas",
    "UBICACION_GEOGRAFICA": "16077"
  },
  {
    "TITULO": "Santa Ana Maya",
    "UBICACION_GEOGRAFICA": "16078"
  },
  {
    "TITULO": "Salvador Escalante",
    "UBICACION_GEOGRAFICA": "16079"
  },
  {
    "TITULO": "Senguio",
    "UBICACION_GEOGRAFICA": "16080"
  },
  {
    "TITULO": "Susupuato",
    "UBICACION_GEOGRAFICA": "16081"
  },
  {
    "TITULO": "Tacámbaro",
    "UBICACION_GEOGRAFICA": "16082"
  },
  {
    "TITULO": "Tancítaro",
    "UBICACION_GEOGRAFICA": "16083"
  },
  {
    "TITULO": "Tangamandapio",
    "UBICACION_GEOGRAFICA": "16084"
  },
  {
    "TITULO": "Tangancícuaro",
    "UBICACION_GEOGRAFICA": "16085"
  },
  {
    "TITULO": "Tanhuato",
    "UBICACION_GEOGRAFICA": "16086"
  },
  {
    "TITULO": "Taretan",
    "UBICACION_GEOGRAFICA": "16087"
  },
  {
    "TITULO": "Tarímbaro",
    "UBICACION_GEOGRAFICA": "16088"
  },
  {
    "TITULO": "Tepalcatepec",
    "UBICACION_GEOGRAFICA": "16089"
  },
  {
    "TITULO": "Tingambato",
    "UBICACION_GEOGRAFICA": "16090"
  },
  {
    "TITULO": "Tingüindín",
    "UBICACION_GEOGRAFICA": "16091"
  },
  {
    "TITULO": "Tiquicheo de Nicolás Romero",
    "UBICACION_GEOGRAFICA": "16092"
  },
  {
    "TITULO": "Tlalpujahua",
    "UBICACION_GEOGRAFICA": "16093"
  },
  {
    "TITULO": "Tlazazalca",
    "UBICACION_GEOGRAFICA": "16094"
  },
  {
    "TITULO": "Tocumbo",
    "UBICACION_GEOGRAFICA": "16095"
  },
  {
    "TITULO": "Tumbiscatío",
    "UBICACION_GEOGRAFICA": "16096"
  },
  {
    "TITULO": "Turicato",
    "UBICACION_GEOGRAFICA": "16097"
  },
  {
    "TITULO": "Tuxpan",
    "UBICACION_GEOGRAFICA": "16098"
  },
  {
    "TITULO": "Tuzantla",
    "UBICACION_GEOGRAFICA": "16099"
  },
  {
    "TITULO": "Tzintzuntzan",
    "UBICACION_GEOGRAFICA": "16100"
  },
  {
    "TITULO": "Tzitzio",
    "UBICACION_GEOGRAFICA": "16101"
  },
  {
    "TITULO": "Uruapan",
    "UBICACION_GEOGRAFICA": "16102"
  },
  {
    "TITULO": "Venustiano Carranza",
    "UBICACION_GEOGRAFICA": "16103"
  },
  {
    "TITULO": "Villamar",
    "UBICACION_GEOGRAFICA": "16104"
  },
  {
    "TITULO": "Vista Hermosa",
    "UBICACION_GEOGRAFICA": "16105"
  },
  {
    "TITULO": "Yurécuaro",
    "UBICACION_GEOGRAFICA": "16106"
  },
  {
    "TITULO": "Zacapu",
    "UBICACION_GEOGRAFICA": "16107"
  },
  {
    "TITULO": "Zamora",
    "UBICACION_GEOGRAFICA": "16108"
  },
  {
    "TITULO": "Zináparo",
    "UBICACION_GEOGRAFICA": "16109"
  },
  {
    "TITULO": "Zinapécuaro",
    "UBICACION_GEOGRAFICA": "16110"
  },
  {
    "TITULO": "Ziracuaretiro",
    "UBICACION_GEOGRAFICA": "16111"
  },
  {
    "TITULO": "Zitácuaro",
    "UBICACION_GEOGRAFICA": "16112"
  },
  {
    "TITULO": "José Sixto Verduzco",
    "UBICACION_GEOGRAFICA": "16113"
  },
  {
    "TITULO": "Morelos",
    "UBICACION_GEOGRAFICA": "17"
  },
  {
    "TITULO": "Amacuzac",
    "UBICACION_GEOGRAFICA": "17001"
  },
  {
    "TITULO": "Atlatlahucan",
    "UBICACION_GEOGRAFICA": "17002"
  },
  {
    "TITULO": "Axochiapan",
    "UBICACION_GEOGRAFICA": "17003"
  },
  {
    "TITULO": "Ayala",
    "UBICACION_GEOGRAFICA": "17004"
  },
  {
    "TITULO": "Coatlán del Río",
    "UBICACION_GEOGRAFICA": "17005"
  },
  {
    "TITULO": "Cuautla",
    "UBICACION_GEOGRAFICA": "17006"
  },
  {
    "TITULO": "Cuernavaca",
    "UBICACION_GEOGRAFICA": "17007"
  },
  {
    "TITULO": "Emiliano Zapata",
    "UBICACION_GEOGRAFICA": "17008"
  },
  {
    "TITULO": "Huitzilac",
    "UBICACION_GEOGRAFICA": "17009"
  },
  {
    "TITULO": "Jantetelco",
    "UBICACION_GEOGRAFICA": "17010"
  },
  {
    "TITULO": "Jiutepec",
    "UBICACION_GEOGRAFICA": "17011"
  },
  {
    "TITULO": "Jojutla",
    "UBICACION_GEOGRAFICA": "17012"
  },
  {
    "TITULO": "Jonacatepec",
    "UBICACION_GEOGRAFICA": "17013"
  },
  {
    "TITULO": "Mazatepec",
    "UBICACION_GEOGRAFICA": "17014"
  },
  {
    "TITULO": "Miacatlán",
    "UBICACION_GEOGRAFICA": "17015"
  },
  {
    "TITULO": "Ocuituco",
    "UBICACION_GEOGRAFICA": "17016"
  },
  {
    "TITULO": "Puente de Ixtla",
    "UBICACION_GEOGRAFICA": "17017"
  },
  {
    "TITULO": "Temixco",
    "UBICACION_GEOGRAFICA": "17018"
  },
  {
    "TITULO": "Tepalcingo",
    "UBICACION_GEOGRAFICA": "17019"
  },
  {
    "TITULO": "Tepoztlán",
    "UBICACION_GEOGRAFICA": "17020"
  },
  {
    "TITULO": "Tetecala",
    "UBICACION_GEOGRAFICA": "17021"
  },
  {
    "TITULO": "Tetela del Volcán",
    "UBICACION_GEOGRAFICA": "17022"
  },
  {
    "TITULO": "Tlalnepantla",
    "UBICACION_GEOGRAFICA": "17023"
  },
  {
    "TITULO": "Tlaltizapán",
    "UBICACION_GEOGRAFICA": "17024"
  },
  {
    "TITULO": "Tlaquiltenango",
    "UBICACION_GEOGRAFICA": "17025"
  },
  {
    "TITULO": "Tlayacapan",
    "UBICACION_GEOGRAFICA": "17026"
  },
  {
    "TITULO": "Totolapan",
    "UBICACION_GEOGRAFICA": "17027"
  },
  {
    "TITULO": "Xochitepec",
    "UBICACION_GEOGRAFICA": "17028"
  },
  {
    "TITULO": "Yautepec",
    "UBICACION_GEOGRAFICA": "17029"
  },
  {
    "TITULO": "Yecapixtla",
    "UBICACION_GEOGRAFICA": "17030"
  },
  {
    "TITULO": "Zacatepec",
    "UBICACION_GEOGRAFICA": "17031"
  },
  {
    "TITULO": "Zacualpan",
    "UBICACION_GEOGRAFICA": "17032"
  },
  {
    "TITULO": "Temoac",
    "UBICACION_GEOGRAFICA": "17033"
  },
  {
    "TITULO": "Nayarit",
    "UBICACION_GEOGRAFICA": "18"
  },
  {
    "TITULO": "Acaponeta",
    "UBICACION_GEOGRAFICA": "18001"
  },
  {
    "TITULO": "Ahuacatlán",
    "UBICACION_GEOGRAFICA": "18002"
  },
  {
    "TITULO": "Amatlán de Cañas",
    "UBICACION_GEOGRAFICA": "18003"
  },
  {
    "TITULO": "Compostela",
    "UBICACION_GEOGRAFICA": "18004"
  },
  {
    "TITULO": "Huajicori",
    "UBICACION_GEOGRAFICA": "18005"
  },
  {
    "TITULO": "Ixtlán del Río",
    "UBICACION_GEOGRAFICA": "18006"
  },
  {
    "TITULO": "Jala",
    "UBICACION_GEOGRAFICA": "18007"
  },
  {
    "TITULO": "Xalisco",
    "UBICACION_GEOGRAFICA": "18008"
  },
  {
    "TITULO": "Del Nayar",
    "UBICACION_GEOGRAFICA": "18009"
  },
  {
    "TITULO": "Rosamorada",
    "UBICACION_GEOGRAFICA": "18010"
  },
  {
    "TITULO": "Ruíz",
    "UBICACION_GEOGRAFICA": "18011"
  },
  {
    "TITULO": "San Blas",
    "UBICACION_GEOGRAFICA": "18012"
  },
  {
    "TITULO": "San Pedro Lagunillas",
    "UBICACION_GEOGRAFICA": "18013"
  },
  {
    "TITULO": "Santa María del Oro",
    "UBICACION_GEOGRAFICA": "18014"
  },
  {
    "TITULO": "Santiago Ixcuintla",
    "UBICACION_GEOGRAFICA": "18015"
  },
  {
    "TITULO": "Tecuala",
    "UBICACION_GEOGRAFICA": "18016"
  },
  {
    "TITULO": "Tepic",
    "UBICACION_GEOGRAFICA": "18017"
  },
  {
    "TITULO": "Tuxpan",
    "UBICACION_GEOGRAFICA": "18018"
  },
  {
    "TITULO": "La Yesca",
    "UBICACION_GEOGRAFICA": "18019"
  },
  {
    "TITULO": "Bahía de Banderas",
    "UBICACION_GEOGRAFICA": "18020"
  },
  {
    "TITULO": "Nuevo León",
    "UBICACION_GEOGRAFICA": "19"
  },
  {
    "TITULO": "Abasolo",
    "UBICACION_GEOGRAFICA": "19001"
  },
  {
    "TITULO": "Agualeguas",
    "UBICACION_GEOGRAFICA": "19002"
  },
  {
    "TITULO": "Los Aldamas",
    "UBICACION_GEOGRAFICA": "19003"
  },
  {
    "TITULO": "Allende",
    "UBICACION_GEOGRAFICA": "19004"
  },
  {
    "TITULO": "Anáhuac",
    "UBICACION_GEOGRAFICA": "19005"
  },
  {
    "TITULO": "Apodaca",
    "UBICACION_GEOGRAFICA": "19006"
  },
  {
    "TITULO": "Aramberri",
    "UBICACION_GEOGRAFICA": "19007"
  },
  {
    "TITULO": "Bustamante",
    "UBICACION_GEOGRAFICA": "19008"
  },
  {
    "TITULO": "Cadereyta Jiménez",
    "UBICACION_GEOGRAFICA": "19009"
  },
  {
    "TITULO": "Carmen",
    "UBICACION_GEOGRAFICA": "19010"
  },
  {
    "TITULO": "Cerralvo",
    "UBICACION_GEOGRAFICA": "19011"
  },
  {
    "TITULO": "Ciénega de Flores",
    "UBICACION_GEOGRAFICA": "19012"
  },
  {
    "TITULO": "China",
    "UBICACION_GEOGRAFICA": "19013"
  },
  {
    "TITULO": "Dr. Arroyo",
    "UBICACION_GEOGRAFICA": "19014"
  },
  {
    "TITULO": "Dr. Coss",
    "UBICACION_GEOGRAFICA": "19015"
  },
  {
    "TITULO": "Dr. González",
    "UBICACION_GEOGRAFICA": "19016"
  },
  {
    "TITULO": "Galeana",
    "UBICACION_GEOGRAFICA": "19017"
  },
  {
    "TITULO": "García",
    "UBICACION_GEOGRAFICA": "19018"
  },
  {
    "TITULO": "San Pedro Garza García",
    "UBICACION_GEOGRAFICA": "19019"
  },
  {
    "TITULO": "Gral. Bravo",
    "UBICACION_GEOGRAFICA": "19020"
  },
  {
    "TITULO": "Gral. Escobedo",
    "UBICACION_GEOGRAFICA": "19021"
  },
  {
    "TITULO": "Gral. Terán",
    "UBICACION_GEOGRAFICA": "19022"
  },
  {
    "TITULO": "Gral. Treviño",
    "UBICACION_GEOGRAFICA": "19023"
  },
  {
    "TITULO": "Gral. Zaragoza",
    "UBICACION_GEOGRAFICA": "19024"
  },
  {
    "TITULO": "Gral. Zuazua",
    "UBICACION_GEOGRAFICA": "19025"
  },
  {
    "TITULO": "Guadalupe",
    "UBICACION_GEOGRAFICA": "19026"
  },
  {
    "TITULO": "Los Herreras",
    "UBICACION_GEOGRAFICA": "19027"
  },
  {
    "TITULO": "Higueras",
    "UBICACION_GEOGRAFICA": "19028"
  },
  {
    "TITULO": "Hualahuises",
    "UBICACION_GEOGRAFICA": "19029"
  },
  {
    "TITULO": "Iturbide",
    "UBICACION_GEOGRAFICA": "19030"
  },
  {
    "TITULO": "Juárez",
    "UBICACION_GEOGRAFICA": "19031"
  },
  {
    "TITULO": "Lampazos de Naranjo",
    "UBICACION_GEOGRAFICA": "19032"
  },
  {
    "TITULO": "Linares",
    "UBICACION_GEOGRAFICA": "19033"
  },
  {
    "TITULO": "Marín",
    "UBICACION_GEOGRAFICA": "19034"
  },
  {
    "TITULO": "Melchor Ocampo",
    "UBICACION_GEOGRAFICA": "19035"
  },
  {
    "TITULO": "Mier y Noriega",
    "UBICACION_GEOGRAFICA": "19036"
  },
  {
    "TITULO": "Mina",
    "UBICACION_GEOGRAFICA": "19037"
  },
  {
    "TITULO": "Montemorelos",
    "UBICACION_GEOGRAFICA": "19038"
  },
  {
    "TITULO": "Monterrey",
    "UBICACION_GEOGRAFICA": "19039"
  },
  {
    "TITULO": "Parás",
    "UBICACION_GEOGRAFICA": "19040"
  },
  {
    "TITULO": "Pesquería",
    "UBICACION_GEOGRAFICA": "19041"
  },
  {
    "TITULO": "Los Ramones",
    "UBICACION_GEOGRAFICA": "19042"
  },
  {
    "TITULO": "Rayones",
    "UBICACION_GEOGRAFICA": "19043"
  },
  {
    "TITULO": "Sabinas Hidalgo",
    "UBICACION_GEOGRAFICA": "19044"
  },
  {
    "TITULO": "Salinas Victoria",
    "UBICACION_GEOGRAFICA": "19045"
  },
  {
    "TITULO": "San Nicolás de los Garza",
    "UBICACION_GEOGRAFICA": "19046"
  },
  {
    "TITULO": "Hidalgo",
    "UBICACION_GEOGRAFICA": "19047"
  },
  {
    "TITULO": "Santa Catarina",
    "UBICACION_GEOGRAFICA": "19048"
  },
  {
    "TITULO": "Santiago",
    "UBICACION_GEOGRAFICA": "19049"
  },
  {
    "TITULO": "Vallecillo",
    "UBICACION_GEOGRAFICA": "19050"
  },
  {
    "TITULO": "Villaldama",
    "UBICACION_GEOGRAFICA": "19051"
  },
  {
    "TITULO": "Oaxaca",
    "UBICACION_GEOGRAFICA": "20"
  },
  {
    "TITULO": "Abejones",
    "UBICACION_GEOGRAFICA": "20001"
  },
  {
    "TITULO": "Acatlán de Pérez Figueroa",
    "UBICACION_GEOGRAFICA": "20002"
  },
  {
    "TITULO": "Asunción Cacalotepec",
    "UBICACION_GEOGRAFICA": "20003"
  },
  {
    "TITULO": "Asunción Cuyotepeji",
    "UBICACION_GEOGRAFICA": "20004"
  },
  {
    "TITULO": "Asunción Ixtaltepec",
    "UBICACION_GEOGRAFICA": "20005"
  },
  {
    "TITULO": "Asunción Nochixtlán",
    "UBICACION_GEOGRAFICA": "20006"
  },
  {
    "TITULO": "Asunción Ocotlán",
    "UBICACION_GEOGRAFICA": "20007"
  },
  {
    "TITULO": "Asunción Tlacolulita",
    "UBICACION_GEOGRAFICA": "20008"
  },
  {
    "TITULO": "Ayotzintepec",
    "UBICACION_GEOGRAFICA": "20009"
  },
  {
    "TITULO": "El Barrio de la Soledad",
    "UBICACION_GEOGRAFICA": "20010"
  },
  {
    "TITULO": "Calihualá",
    "UBICACION_GEOGRAFICA": "20011"
  },
  {
    "TITULO": "Candelaria Loxicha",
    "UBICACION_GEOGRAFICA": "20012"
  },
  {
    "TITULO": "Ciénega de Zimatlán",
    "UBICACION_GEOGRAFICA": "20013"
  },
  {
    "TITULO": "Ciudad Ixtepec",
    "UBICACION_GEOGRAFICA": "20014"
  },
  {
    "TITULO": "Coatecas Altas",
    "UBICACION_GEOGRAFICA": "20015"
  },
  {
    "TITULO": "Coicoyán de las Flores",
    "UBICACION_GEOGRAFICA": "20016"
  },
  {
    "TITULO": "La Compañía",
    "UBICACION_GEOGRAFICA": "20017"
  },
  {
    "TITULO": "Concepción Buenavista",
    "UBICACION_GEOGRAFICA": "20018"
  },
  {
    "TITULO": "Concepción Pápalo",
    "UBICACION_GEOGRAFICA": "20019"
  },
  {
    "TITULO": "Constancia del Rosario",
    "UBICACION_GEOGRAFICA": "20020"
  },
  {
    "TITULO": "Cosolapa",
    "UBICACION_GEOGRAFICA": "20021"
  },
  {
    "TITULO": "Cosoltepec",
    "UBICACION_GEOGRAFICA": "20022"
  },
  {
    "TITULO": "Cuilápam de Guerrero",
    "UBICACION_GEOGRAFICA": "20023"
  },
  {
    "TITULO": "Cuyamecalco Villa de Zaragoza",
    "UBICACION_GEOGRAFICA": "20024"
  },
  {
    "TITULO": "Chahuites",
    "UBICACION_GEOGRAFICA": "20025"
  },
  {
    "TITULO": "Chalcatongo de Hidalgo",
    "UBICACION_GEOGRAFICA": "20026"
  },
  {
    "TITULO": "Chiquihuitlán de Benito Juárez",
    "UBICACION_GEOGRAFICA": "20027"
  },
  {
    "TITULO": "Heroica Ciudad de Ejutla de Crespo",
    "UBICACION_GEOGRAFICA": "20028"
  },
  {
    "TITULO": "Eloxochitlán de Flores Magón",
    "UBICACION_GEOGRAFICA": "20029"
  },
  {
    "TITULO": "El Espinal",
    "UBICACION_GEOGRAFICA": "20030"
  },
  {
    "TITULO": "Tamazulápam del Espíritu Santo",
    "UBICACION_GEOGRAFICA": "20031"
  },
  {
    "TITULO": "Fresnillo de Trujano",
    "UBICACION_GEOGRAFICA": "20032"
  },
  {
    "TITULO": "Guadalupe Etla",
    "UBICACION_GEOGRAFICA": "20033"
  },
  {
    "TITULO": "Guadalupe de Ramírez",
    "UBICACION_GEOGRAFICA": "20034"
  },
  {
    "TITULO": "Guelatao de Juárez",
    "UBICACION_GEOGRAFICA": "20035"
  },
  {
    "TITULO": "Guevea de Humboldt",
    "UBICACION_GEOGRAFICA": "20036"
  },
  {
    "TITULO": "Mesones Hidalgo",
    "UBICACION_GEOGRAFICA": "20037"
  },
  {
    "TITULO": "Villa Hidalgo",
    "UBICACION_GEOGRAFICA": "20038"
  },
  {
    "TITULO": "Heroica Ciudad de Huajuapan de León",
    "UBICACION_GEOGRAFICA": "20039"
  },
  {
    "TITULO": "Huautepec",
    "UBICACION_GEOGRAFICA": "20040"
  },
  {
    "TITULO": "Huautla de Jiménez",
    "UBICACION_GEOGRAFICA": "20041"
  },
  {
    "TITULO": "Ixtlán de Juárez",
    "UBICACION_GEOGRAFICA": "20042"
  },
  {
    "TITULO": "Heroica Ciudad de Juchitán de Zaragoza",
    "UBICACION_GEOGRAFICA": "20043"
  },
  {
    "TITULO": "Loma Bonita",
    "UBICACION_GEOGRAFICA": "20044"
  },
  {
    "TITULO": "Magdalena Apasco",
    "UBICACION_GEOGRAFICA": "20045"
  },
  {
    "TITULO": "Magdalena Jaltepec",
    "UBICACION_GEOGRAFICA": "20046"
  },
  {
    "TITULO": "Santa Magdalena Jicotlán",
    "UBICACION_GEOGRAFICA": "20047"
  },
  {
    "TITULO": "Magdalena Mixtepec",
    "UBICACION_GEOGRAFICA": "20048"
  },
  {
    "TITULO": "Magdalena Ocotlán",
    "UBICACION_GEOGRAFICA": "20049"
  },
  {
    "TITULO": "Magdalena Peñasco",
    "UBICACION_GEOGRAFICA": "20050"
  },
  {
    "TITULO": "Magdalena Teitipac",
    "UBICACION_GEOGRAFICA": "20051"
  },
  {
    "TITULO": "Magdalena Tequisistlán",
    "UBICACION_GEOGRAFICA": "20052"
  },
  {
    "TITULO": "Magdalena Tlacotepec",
    "UBICACION_GEOGRAFICA": "20053"
  },
  {
    "TITULO": "Magdalena Zahuatlán",
    "UBICACION_GEOGRAFICA": "20054"
  },
  {
    "TITULO": "Mariscala de Juárez",
    "UBICACION_GEOGRAFICA": "20055"
  },
  {
    "TITULO": "Mártires de Tacubaya",
    "UBICACION_GEOGRAFICA": "20056"
  },
  {
    "TITULO": "Matías Romero Avendaño",
    "UBICACION_GEOGRAFICA": "20057"
  },
  {
    "TITULO": "Mazatlán Villa de Flores",
    "UBICACION_GEOGRAFICA": "20058"
  },
  {
    "TITULO": "Miahuatlán de Porfirio Díaz",
    "UBICACION_GEOGRAFICA": "20059"
  },
  {
    "TITULO": "Mixistlán de la Reforma",
    "UBICACION_GEOGRAFICA": "20060"
  },
  {
    "TITULO": "Monjas",
    "UBICACION_GEOGRAFICA": "20061"
  },
  {
    "TITULO": "Natividad",
    "UBICACION_GEOGRAFICA": "20062"
  },
  {
    "TITULO": "Nazareno Etla",
    "UBICACION_GEOGRAFICA": "20063"
  },
  {
    "TITULO": "Nejapa de Madero",
    "UBICACION_GEOGRAFICA": "20064"
  },
  {
    "TITULO": "Ixpantepec Nieves",
    "UBICACION_GEOGRAFICA": "20065"
  },
  {
    "TITULO": "Santiago Niltepec",
    "UBICACION_GEOGRAFICA": "20066"
  },
  {
    "TITULO": "Oaxaca de Juárez",
    "UBICACION_GEOGRAFICA": "20067"
  },
  {
    "TITULO": "Oaxaca, Oaxaca",
    "UBICACION_GEOGRAFICA": "20067"
  },
  {
    "TITULO": "Ocotlán de Morelos",
    "UBICACION_GEOGRAFICA": "20068"
  },
  {
    "TITULO": "La Pe",
    "UBICACION_GEOGRAFICA": "20069"
  },
  {
    "TITULO": "Pinotepa de Don Luis",
    "UBICACION_GEOGRAFICA": "20070"
  },
  {
    "TITULO": "Pluma Hidalgo",
    "UBICACION_GEOGRAFICA": "20071"
  },
  {
    "TITULO": "San José del Progreso",
    "UBICACION_GEOGRAFICA": "20072"
  },
  {
    "TITULO": "Putla Villa de Guerrero",
    "UBICACION_GEOGRAFICA": "20073"
  },
  {
    "TITULO": "Santa Catarina Quioquitani",
    "UBICACION_GEOGRAFICA": "20074"
  },
  {
    "TITULO": "Reforma de Pineda",
    "UBICACION_GEOGRAFICA": "20075"
  },
  {
    "TITULO": "La Reforma",
    "UBICACION_GEOGRAFICA": "20076"
  },
  {
    "TITULO": "Reyes Etla",
    "UBICACION_GEOGRAFICA": "20077"
  },
  {
    "TITULO": "Rojas de Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "20078"
  },
  {
    "TITULO": "Salina Cruz",
    "UBICACION_GEOGRAFICA": "20079"
  },
  {
    "TITULO": "San Agustín Amatengo",
    "UBICACION_GEOGRAFICA": "20080"
  },
  {
    "TITULO": "San Agustín Atenango",
    "UBICACION_GEOGRAFICA": "20081"
  },
  {
    "TITULO": "San Agustín Chayuco",
    "UBICACION_GEOGRAFICA": "20082"
  },
  {
    "TITULO": "San Agustín de las Juntas",
    "UBICACION_GEOGRAFICA": "20083"
  },
  {
    "TITULO": "San Agustín Etla",
    "UBICACION_GEOGRAFICA": "20084"
  },
  {
    "TITULO": "San Agustín Loxicha",
    "UBICACION_GEOGRAFICA": "20085"
  },
  {
    "TITULO": "San Agustín Tlacotepec",
    "UBICACION_GEOGRAFICA": "20086"
  },
  {
    "TITULO": "San Agustín Yatareni",
    "UBICACION_GEOGRAFICA": "20087"
  },
  {
    "TITULO": "San Andrés Cabecera Nueva",
    "UBICACION_GEOGRAFICA": "20088"
  },
  {
    "TITULO": "San Andrés Dinicuiti",
    "UBICACION_GEOGRAFICA": "20089"
  },
  {
    "TITULO": "San Andrés Huaxpaltepec",
    "UBICACION_GEOGRAFICA": "20090"
  },
  {
    "TITULO": "San Andrés Huayápam",
    "UBICACION_GEOGRAFICA": "20091"
  },
  {
    "TITULO": "San Andrés Ixtlahuaca",
    "UBICACION_GEOGRAFICA": "20092"
  },
  {
    "TITULO": "San Andrés Lagunas",
    "UBICACION_GEOGRAFICA": "20093"
  },
  {
    "TITULO": "San Andrés Nuxiño",
    "UBICACION_GEOGRAFICA": "20094"
  },
  {
    "TITULO": "San Andrés Paxtlán",
    "UBICACION_GEOGRAFICA": "20095"
  },
  {
    "TITULO": "San Andrés Sinaxtla",
    "UBICACION_GEOGRAFICA": "20096"
  },
  {
    "TITULO": "San Andrés Solaga",
    "UBICACION_GEOGRAFICA": "20097"
  },
  {
    "TITULO": "San Andrés Teotilálpam",
    "UBICACION_GEOGRAFICA": "20098"
  },
  {
    "TITULO": "San Andrés Tepetlapa",
    "UBICACION_GEOGRAFICA": "20099"
  },
  {
    "TITULO": "San Andrés Yaá",
    "UBICACION_GEOGRAFICA": "20100"
  },
  {
    "TITULO": "San Andrés Zabache",
    "UBICACION_GEOGRAFICA": "20101"
  },
  {
    "TITULO": "San Andrés Zautla",
    "UBICACION_GEOGRAFICA": "20102"
  },
  {
    "TITULO": "San Antonino Castillo Velasco",
    "UBICACION_GEOGRAFICA": "20103"
  },
  {
    "TITULO": "San Antonino el Alto",
    "UBICACION_GEOGRAFICA": "20104"
  },
  {
    "TITULO": "San Antonino Monte Verde",
    "UBICACION_GEOGRAFICA": "20105"
  },
  {
    "TITULO": "San Antonio Acutla",
    "UBICACION_GEOGRAFICA": "20106"
  },
  {
    "TITULO": "San Antonio de la Cal",
    "UBICACION_GEOGRAFICA": "20107"
  },
  {
    "TITULO": "San Antonio Huitepec",
    "UBICACION_GEOGRAFICA": "20108"
  },
  {
    "TITULO": "San Antonio Nanahuatípam",
    "UBICACION_GEOGRAFICA": "20109"
  },
  {
    "TITULO": "San Antonio Sinicahua",
    "UBICACION_GEOGRAFICA": "20110"
  },
  {
    "TITULO": "San Antonio Tepetlapa",
    "UBICACION_GEOGRAFICA": "20111"
  },
  {
    "TITULO": "San Baltazar Chichicápam",
    "UBICACION_GEOGRAFICA": "20112"
  },
  {
    "TITULO": "San Baltazar Loxicha",
    "UBICACION_GEOGRAFICA": "20113"
  },
  {
    "TITULO": "San Baltazar Yatzachi el Bajo",
    "UBICACION_GEOGRAFICA": "20114"
  },
  {
    "TITULO": "San Bartolo Coyotepec",
    "UBICACION_GEOGRAFICA": "20115"
  },
  {
    "TITULO": "San Bartolomé Ayautla",
    "UBICACION_GEOGRAFICA": "20116"
  },
  {
    "TITULO": "San Bartolomé Loxicha",
    "UBICACION_GEOGRAFICA": "20117"
  },
  {
    "TITULO": "San Bartolomé Quialana",
    "UBICACION_GEOGRAFICA": "20118"
  },
  {
    "TITULO": "San Bartolomé Yucuañe",
    "UBICACION_GEOGRAFICA": "20119"
  },
  {
    "TITULO": "San Bartolomé Zoogocho",
    "UBICACION_GEOGRAFICA": "20120"
  },
  {
    "TITULO": "San Bartolo Soyaltepec",
    "UBICACION_GEOGRAFICA": "20121"
  },
  {
    "TITULO": "San Bartolo Yautepec",
    "UBICACION_GEOGRAFICA": "20122"
  },
  {
    "TITULO": "San Bernardo Mixtepec",
    "UBICACION_GEOGRAFICA": "20123"
  },
  {
    "TITULO": "San Blas Atempa",
    "UBICACION_GEOGRAFICA": "20124"
  },
  {
    "TITULO": "San Carlos Yautepec",
    "UBICACION_GEOGRAFICA": "20125"
  },
  {
    "TITULO": "San Cristóbal Amatlán",
    "UBICACION_GEOGRAFICA": "20126"
  },
  {
    "TITULO": "San Cristóbal Amoltepec",
    "UBICACION_GEOGRAFICA": "20127"
  },
  {
    "TITULO": "San Cristóbal Lachirioag",
    "UBICACION_GEOGRAFICA": "20128"
  },
  {
    "TITULO": "San Cristóbal Suchixtlahuaca",
    "UBICACION_GEOGRAFICA": "20129"
  },
  {
    "TITULO": "San Dionisio del Mar",
    "UBICACION_GEOGRAFICA": "20130"
  },
  {
    "TITULO": "San Dionisio Ocotepec",
    "UBICACION_GEOGRAFICA": "20131"
  },
  {
    "TITULO": "San Dionisio Ocotlán",
    "UBICACION_GEOGRAFICA": "20132"
  },
  {
    "TITULO": "San Esteban Atatlahuca",
    "UBICACION_GEOGRAFICA": "20133"
  },
  {
    "TITULO": "San Felipe Jalapa de Díaz",
    "UBICACION_GEOGRAFICA": "20134"
  },
  {
    "TITULO": "San Felipe Tejalápam",
    "UBICACION_GEOGRAFICA": "20135"
  },
  {
    "TITULO": "San Felipe Usila",
    "UBICACION_GEOGRAFICA": "20136"
  },
  {
    "TITULO": "San Francisco Cahuacuá",
    "UBICACION_GEOGRAFICA": "20137"
  },
  {
    "TITULO": "San Francisco Cajonos",
    "UBICACION_GEOGRAFICA": "20138"
  },
  {
    "TITULO": "San Francisco Chapulapa",
    "UBICACION_GEOGRAFICA": "20139"
  },
  {
    "TITULO": "San Francisco Chindúa",
    "UBICACION_GEOGRAFICA": "20140"
  },
  {
    "TITULO": "San Francisco del Mar",
    "UBICACION_GEOGRAFICA": "20141"
  },
  {
    "TITULO": "San Francisco Huehuetlán",
    "UBICACION_GEOGRAFICA": "20142"
  },
  {
    "TITULO": "San Francisco Ixhuatán",
    "UBICACION_GEOGRAFICA": "20143"
  },
  {
    "TITULO": "San Francisco Jaltepetongo",
    "UBICACION_GEOGRAFICA": "20144"
  },
  {
    "TITULO": "San Francisco Lachigoló",
    "UBICACION_GEOGRAFICA": "20145"
  },
  {
    "TITULO": "San Francisco Logueche",
    "UBICACION_GEOGRAFICA": "20146"
  },
  {
    "TITULO": "San Francisco Nuxaño",
    "UBICACION_GEOGRAFICA": "20147"
  },
  {
    "TITULO": "San Francisco Ozolotepec",
    "UBICACION_GEOGRAFICA": "20148"
  },
  {
    "TITULO": "San Francisco Sola",
    "UBICACION_GEOGRAFICA": "20149"
  },
  {
    "TITULO": "San Francisco Telixtlahuaca",
    "UBICACION_GEOGRAFICA": "20150"
  },
  {
    "TITULO": "San Francisco Teopan",
    "UBICACION_GEOGRAFICA": "20151"
  },
  {
    "TITULO": "San Francisco Tlapancingo",
    "UBICACION_GEOGRAFICA": "20152"
  },
  {
    "TITULO": "San Gabriel Mixtepec",
    "UBICACION_GEOGRAFICA": "20153"
  },
  {
    "TITULO": "San Ildefonso Amatlán",
    "UBICACION_GEOGRAFICA": "20154"
  },
  {
    "TITULO": "San Ildefonso Sola",
    "UBICACION_GEOGRAFICA": "20155"
  },
  {
    "TITULO": "San Ildefonso Villa Alta",
    "UBICACION_GEOGRAFICA": "20156"
  },
  {
    "TITULO": "San Jacinto Amilpas",
    "UBICACION_GEOGRAFICA": "20157"
  },
  {
    "TITULO": "San Jacinto Tlacotepec",
    "UBICACION_GEOGRAFICA": "20158"
  },
  {
    "TITULO": "San Jerónimo Coatlán",
    "UBICACION_GEOGRAFICA": "20159"
  },
  {
    "TITULO": "San Jerónimo Silacayoapilla",
    "UBICACION_GEOGRAFICA": "20160"
  },
  {
    "TITULO": "San Jerónimo Sosola",
    "UBICACION_GEOGRAFICA": "20161"
  },
  {
    "TITULO": "San Jerónimo Taviche",
    "UBICACION_GEOGRAFICA": "20162"
  },
  {
    "TITULO": "San Jerónimo Tecóatl",
    "UBICACION_GEOGRAFICA": "20163"
  },
  {
    "TITULO": "San Jorge Nuchita",
    "UBICACION_GEOGRAFICA": "20164"
  },
  {
    "TITULO": "San José Ayuquila",
    "UBICACION_GEOGRAFICA": "20165"
  },
  {
    "TITULO": "San José Chiltepec",
    "UBICACION_GEOGRAFICA": "20166"
  },
  {
    "TITULO": "San José del Peñasco",
    "UBICACION_GEOGRAFICA": "20167"
  },
  {
    "TITULO": "San José Estancia Grande",
    "UBICACION_GEOGRAFICA": "20168"
  },
  {
    "TITULO": "San José Independencia",
    "UBICACION_GEOGRAFICA": "20169"
  },
  {
    "TITULO": "San José Lachiguiri",
    "UBICACION_GEOGRAFICA": "20170"
  },
  {
    "TITULO": "San José Tenango",
    "UBICACION_GEOGRAFICA": "20171"
  },
  {
    "TITULO": "San Juan Achiutla",
    "UBICACION_GEOGRAFICA": "20172"
  },
  {
    "TITULO": "San Juan Atepec",
    "UBICACION_GEOGRAFICA": "20173"
  },
  {
    "TITULO": "Ánimas Trujano",
    "UBICACION_GEOGRAFICA": "20174"
  },
  {
    "TITULO": "San Juan Bautista Atatlahuca",
    "UBICACION_GEOGRAFICA": "20175"
  },
  {
    "TITULO": "San Juan Bautista Coixtlahuaca",
    "UBICACION_GEOGRAFICA": "20176"
  },
  {
    "TITULO": "San Juan Bautista Cuicatlán",
    "UBICACION_GEOGRAFICA": "20177"
  },
  {
    "TITULO": "San Juan Bautista Guelache",
    "UBICACION_GEOGRAFICA": "20178"
  },
  {
    "TITULO": "San Juan Bautista Jayacatlán",
    "UBICACION_GEOGRAFICA": "20179"
  },
  {
    "TITULO": "San Juan Bautista Lo de Soto",
    "UBICACION_GEOGRAFICA": "20180"
  },
  {
    "TITULO": "San Juan Bautista Suchitepec",
    "UBICACION_GEOGRAFICA": "20181"
  },
  {
    "TITULO": "San Juan Bautista Tlacoatzintepec",
    "UBICACION_GEOGRAFICA": "20182"
  },
  {
    "TITULO": "San Juan Bautista Tlachichilco",
    "UBICACION_GEOGRAFICA": "20183"
  },
  {
    "TITULO": "San Juan Bautista Tuxtepec",
    "UBICACION_GEOGRAFICA": "20184"
  },
  {
    "TITULO": "San Juan Cacahuatepec",
    "UBICACION_GEOGRAFICA": "20185"
  },
  {
    "TITULO": "San Juan Cieneguilla",
    "UBICACION_GEOGRAFICA": "20186"
  },
  {
    "TITULO": "San Juan Coatzóspam",
    "UBICACION_GEOGRAFICA": "20187"
  },
  {
    "TITULO": "San Juan Colorado",
    "UBICACION_GEOGRAFICA": "20188"
  },
  {
    "TITULO": "San Juan Comaltepec",
    "UBICACION_GEOGRAFICA": "20189"
  },
  {
    "TITULO": "San Juan Cotzocón",
    "UBICACION_GEOGRAFICA": "20190"
  },
  {
    "TITULO": "San Juan Chicomezúchil",
    "UBICACION_GEOGRAFICA": "20191"
  },
  {
    "TITULO": "San Juan Chilateca",
    "UBICACION_GEOGRAFICA": "20192"
  },
  {
    "TITULO": "San Juan del Estado",
    "UBICACION_GEOGRAFICA": "20193"
  },
  {
    "TITULO": "San Juan del Río",
    "UBICACION_GEOGRAFICA": "20194"
  },
  {
    "TITULO": "San Juan Diuxi",
    "UBICACION_GEOGRAFICA": "20195"
  },
  {
    "TITULO": "San Juan Evangelista Analco",
    "UBICACION_GEOGRAFICA": "20196"
  },
  {
    "TITULO": "San Juan Guelavía",
    "UBICACION_GEOGRAFICA": "20197"
  },
  {
    "TITULO": "San Juan Guichicovi",
    "UBICACION_GEOGRAFICA": "20198"
  },
  {
    "TITULO": "San Juan Ihualtepec",
    "UBICACION_GEOGRAFICA": "20199"
  },
  {
    "TITULO": "San Juan Juquila Mixes",
    "UBICACION_GEOGRAFICA": "20200"
  },
  {
    "TITULO": "San Juan Juquila Vijanos",
    "UBICACION_GEOGRAFICA": "20201"
  },
  {
    "TITULO": "San Juan Lachao",
    "UBICACION_GEOGRAFICA": "20202"
  },
  {
    "TITULO": "San Juan Lachigalla",
    "UBICACION_GEOGRAFICA": "20203"
  },
  {
    "TITULO": "San Juan Lajarcia",
    "UBICACION_GEOGRAFICA": "20204"
  },
  {
    "TITULO": "San Juan Lalana",
    "UBICACION_GEOGRAFICA": "20205"
  },
  {
    "TITULO": "San Juan de los Cués",
    "UBICACION_GEOGRAFICA": "20206"
  },
  {
    "TITULO": "San Juan Mazatlán",
    "UBICACION_GEOGRAFICA": "20207"
  },
  {
    "TITULO": "San Juan Mixtepec -Dto. 08 -",
    "UBICACION_GEOGRAFICA": "20208"
  },
  {
    "TITULO": "San Juan Mixtepec -Dto. 26 -",
    "UBICACION_GEOGRAFICA": "20209"
  },
  {
    "TITULO": "San Juan Ñumí",
    "UBICACION_GEOGRAFICA": "20210"
  },
  {
    "TITULO": "San Juan Ozolotepec",
    "UBICACION_GEOGRAFICA": "20211"
  },
  {
    "TITULO": "San Juan Petlapa",
    "UBICACION_GEOGRAFICA": "20212"
  },
  {
    "TITULO": "San Juan Quiahije",
    "UBICACION_GEOGRAFICA": "20213"
  },
  {
    "TITULO": "San Juan Quiotepec",
    "UBICACION_GEOGRAFICA": "20214"
  },
  {
    "TITULO": "San Juan Sayultepec",
    "UBICACION_GEOGRAFICA": "20215"
  },
  {
    "TITULO": "San Juan Tabaá",
    "UBICACION_GEOGRAFICA": "20216"
  },
  {
    "TITULO": "San Juan Tamazola",
    "UBICACION_GEOGRAFICA": "20217"
  },
  {
    "TITULO": "San Juan Teita",
    "UBICACION_GEOGRAFICA": "20218"
  },
  {
    "TITULO": "San Juan Teitipac",
    "UBICACION_GEOGRAFICA": "20219"
  },
  {
    "TITULO": "San Juan Tepeuxila",
    "UBICACION_GEOGRAFICA": "20220"
  },
  {
    "TITULO": "San Juan Teposcolula",
    "UBICACION_GEOGRAFICA": "20221"
  },
  {
    "TITULO": "San Juan Yaeé",
    "UBICACION_GEOGRAFICA": "20222"
  },
  {
    "TITULO": "San Juan Yatzona",
    "UBICACION_GEOGRAFICA": "20223"
  },
  {
    "TITULO": "San Juan Yucuita",
    "UBICACION_GEOGRAFICA": "20224"
  },
  {
    "TITULO": "San Lorenzo",
    "UBICACION_GEOGRAFICA": "20225"
  },
  {
    "TITULO": "San Lorenzo Albarradas",
    "UBICACION_GEOGRAFICA": "20226"
  },
  {
    "TITULO": "San Lorenzo Cacaotepec",
    "UBICACION_GEOGRAFICA": "20227"
  },
  {
    "TITULO": "San Lorenzo Cuaunecuiltitla",
    "UBICACION_GEOGRAFICA": "20228"
  },
  {
    "TITULO": "San Lorenzo Texmelúcan",
    "UBICACION_GEOGRAFICA": "20229"
  },
  {
    "TITULO": "San Lorenzo Victoria",
    "UBICACION_GEOGRAFICA": "20230"
  },
  {
    "TITULO": "San Lucas Camotlán",
    "UBICACION_GEOGRAFICA": "20231"
  },
  {
    "TITULO": "San Lucas Ojitlán",
    "UBICACION_GEOGRAFICA": "20232"
  },
  {
    "TITULO": "San Lucas Quiaviní",
    "UBICACION_GEOGRAFICA": "20233"
  },
  {
    "TITULO": "San Lucas Zoquiápam",
    "UBICACION_GEOGRAFICA": "20234"
  },
  {
    "TITULO": "San Luis Amatlán",
    "UBICACION_GEOGRAFICA": "20235"
  },
  {
    "TITULO": "San Marcial Ozolotepec",
    "UBICACION_GEOGRAFICA": "20236"
  },
  {
    "TITULO": "San Marcos Arteaga",
    "UBICACION_GEOGRAFICA": "20237"
  },
  {
    "TITULO": "San Martín de los Cansecos",
    "UBICACION_GEOGRAFICA": "20238"
  },
  {
    "TITULO": "San Martín Huamelúlpam",
    "UBICACION_GEOGRAFICA": "20239"
  },
  {
    "TITULO": "San Martín Itunyoso",
    "UBICACION_GEOGRAFICA": "20240"
  },
  {
    "TITULO": "San Martín Lachilá",
    "UBICACION_GEOGRAFICA": "20241"
  },
  {
    "TITULO": "San Martín Peras",
    "UBICACION_GEOGRAFICA": "20242"
  },
  {
    "TITULO": "San Martín Tilcajete",
    "UBICACION_GEOGRAFICA": "20243"
  },
  {
    "TITULO": "San Martín Toxpalan",
    "UBICACION_GEOGRAFICA": "20244"
  },
  {
    "TITULO": "San Martín Zacatepec",
    "UBICACION_GEOGRAFICA": "20245"
  },
  {
    "TITULO": "San Mateo Cajonos",
    "UBICACION_GEOGRAFICA": "20246"
  },
  {
    "TITULO": "Capulálpam de Méndez",
    "UBICACION_GEOGRAFICA": "20247"
  },
  {
    "TITULO": "San Mateo del Mar",
    "UBICACION_GEOGRAFICA": "20248"
  },
  {
    "TITULO": "San Mateo Yoloxochitlán",
    "UBICACION_GEOGRAFICA": "20249"
  },
  {
    "TITULO": "San Mateo Etlatongo",
    "UBICACION_GEOGRAFICA": "20250"
  },
  {
    "TITULO": "San Mateo Nejápam",
    "UBICACION_GEOGRAFICA": "20251"
  },
  {
    "TITULO": "San Mateo Peñasco",
    "UBICACION_GEOGRAFICA": "20252"
  },
  {
    "TITULO": "San Mateo Piñas",
    "UBICACION_GEOGRAFICA": "20253"
  },
  {
    "TITULO": "San Mateo Río Hondo",
    "UBICACION_GEOGRAFICA": "20254"
  },
  {
    "TITULO": "San Mateo Sindihui",
    "UBICACION_GEOGRAFICA": "20255"
  },
  {
    "TITULO": "San Mateo Tlapiltepec",
    "UBICACION_GEOGRAFICA": "20256"
  },
  {
    "TITULO": "San Melchor Betaza",
    "UBICACION_GEOGRAFICA": "20257"
  },
  {
    "TITULO": "San Miguel Achiutla",
    "UBICACION_GEOGRAFICA": "20258"
  },
  {
    "TITULO": "San Miguel Ahuehuetitlán",
    "UBICACION_GEOGRAFICA": "20259"
  },
  {
    "TITULO": "San Miguel Aloápam",
    "UBICACION_GEOGRAFICA": "20260"
  },
  {
    "TITULO": "San Miguel Amatitlán",
    "UBICACION_GEOGRAFICA": "20261"
  },
  {
    "TITULO": "San Miguel Amatlán",
    "UBICACION_GEOGRAFICA": "20262"
  },
  {
    "TITULO": "San Miguel Coatlán",
    "UBICACION_GEOGRAFICA": "20263"
  },
  {
    "TITULO": "San Miguel Chicahua",
    "UBICACION_GEOGRAFICA": "20264"
  },
  {
    "TITULO": "San Miguel Chimalapa",
    "UBICACION_GEOGRAFICA": "20265"
  },
  {
    "TITULO": "San Miguel del Puerto",
    "UBICACION_GEOGRAFICA": "20266"
  },
  {
    "TITULO": "San Miguel del Río",
    "UBICACION_GEOGRAFICA": "20267"
  },
  {
    "TITULO": "San Miguel Ejutla",
    "UBICACION_GEOGRAFICA": "20268"
  },
  {
    "TITULO": "San Miguel el Grande",
    "UBICACION_GEOGRAFICA": "20269"
  },
  {
    "TITULO": "San Miguel Huautla",
    "UBICACION_GEOGRAFICA": "20270"
  },
  {
    "TITULO": "San Miguel Mixtepec",
    "UBICACION_GEOGRAFICA": "20271"
  },
  {
    "TITULO": "San Miguel Panixtlahuaca",
    "UBICACION_GEOGRAFICA": "20272"
  },
  {
    "TITULO": "San Miguel Peras",
    "UBICACION_GEOGRAFICA": "20273"
  },
  {
    "TITULO": "San Miguel Piedras",
    "UBICACION_GEOGRAFICA": "20274"
  },
  {
    "TITULO": "San Miguel Quetzaltepec",
    "UBICACION_GEOGRAFICA": "20275"
  },
  {
    "TITULO": "San Miguel Santa Flor",
    "UBICACION_GEOGRAFICA": "20276"
  },
  {
    "TITULO": "Villa Sola de Vega",
    "UBICACION_GEOGRAFICA": "20277"
  },
  {
    "TITULO": "San Miguel Soyaltepec",
    "UBICACION_GEOGRAFICA": "20278"
  },
  {
    "TITULO": "San Miguel Suchixtepec",
    "UBICACION_GEOGRAFICA": "20279"
  },
  {
    "TITULO": "Villa Talea de Castro",
    "UBICACION_GEOGRAFICA": "20280"
  },
  {
    "TITULO": "San Miguel Tecomatlán",
    "UBICACION_GEOGRAFICA": "20281"
  },
  {
    "TITULO": "San Miguel Tenango",
    "UBICACION_GEOGRAFICA": "20282"
  },
  {
    "TITULO": "San Miguel Tequixtepec",
    "UBICACION_GEOGRAFICA": "20283"
  },
  {
    "TITULO": "San Miguel Tilquiápam",
    "UBICACION_GEOGRAFICA": "20284"
  },
  {
    "TITULO": "San Miguel Tlacamama",
    "UBICACION_GEOGRAFICA": "20285"
  },
  {
    "TITULO": "San Miguel Tlacotepec",
    "UBICACION_GEOGRAFICA": "20286"
  },
  {
    "TITULO": "San Miguel Tulancingo",
    "UBICACION_GEOGRAFICA": "20287"
  },
  {
    "TITULO": "San Miguel Yotao",
    "UBICACION_GEOGRAFICA": "20288"
  },
  {
    "TITULO": "San Nicolás",
    "UBICACION_GEOGRAFICA": "20289"
  },
  {
    "TITULO": "San Nicolás Hidalgo",
    "UBICACION_GEOGRAFICA": "20290"
  },
  {
    "TITULO": "San Pablo Coatlán",
    "UBICACION_GEOGRAFICA": "20291"
  },
  {
    "TITULO": "San Pablo Cuatro Venados",
    "UBICACION_GEOGRAFICA": "20292"
  },
  {
    "TITULO": "San Pablo Etla",
    "UBICACION_GEOGRAFICA": "20293"
  },
  {
    "TITULO": "San Pablo Huitzo",
    "UBICACION_GEOGRAFICA": "20294"
  },
  {
    "TITULO": "San Pablo Huixtepec",
    "UBICACION_GEOGRAFICA": "20295"
  },
  {
    "TITULO": "San Pablo Macuiltianguis",
    "UBICACION_GEOGRAFICA": "20296"
  },
  {
    "TITULO": "San Pablo Tijaltepec",
    "UBICACION_GEOGRAFICA": "20297"
  },
  {
    "TITULO": "San Pablo Villa de Mitla",
    "UBICACION_GEOGRAFICA": "20298"
  },
  {
    "TITULO": "San Pablo Yaganiza",
    "UBICACION_GEOGRAFICA": "20299"
  },
  {
    "TITULO": "San Pedro Amuzgos",
    "UBICACION_GEOGRAFICA": "20300"
  },
  {
    "TITULO": "San Pedro Apóstol",
    "UBICACION_GEOGRAFICA": "20301"
  },
  {
    "TITULO": "San Pedro Atoyac",
    "UBICACION_GEOGRAFICA": "20302"
  },
  {
    "TITULO": "San Pedro Cajonos",
    "UBICACION_GEOGRAFICA": "20303"
  },
  {
    "TITULO": "San Pedro Coxcaltepec Cántaros",
    "UBICACION_GEOGRAFICA": "20304"
  },
  {
    "TITULO": "San Pedro Comitancillo",
    "UBICACION_GEOGRAFICA": "20305"
  },
  {
    "TITULO": "San Pedro el Alto",
    "UBICACION_GEOGRAFICA": "20306"
  },
  {
    "TITULO": "San Pedro Huamelula",
    "UBICACION_GEOGRAFICA": "20307"
  },
  {
    "TITULO": "San Pedro Huilotepec",
    "UBICACION_GEOGRAFICA": "20308"
  },
  {
    "TITULO": "San Pedro Ixcatlán",
    "UBICACION_GEOGRAFICA": "20309"
  },
  {
    "TITULO": "San Pedro Ixtlahuaca",
    "UBICACION_GEOGRAFICA": "20310"
  },
  {
    "TITULO": "San Pedro Jaltepetongo",
    "UBICACION_GEOGRAFICA": "20311"
  },
  {
    "TITULO": "San Pedro Jicayán",
    "UBICACION_GEOGRAFICA": "20312"
  },
  {
    "TITULO": "San Pedro Jocotipac",
    "UBICACION_GEOGRAFICA": "20313"
  },
  {
    "TITULO": "San Pedro Juchatengo",
    "UBICACION_GEOGRAFICA": "20314"
  },
  {
    "TITULO": "San Pedro Mártir",
    "UBICACION_GEOGRAFICA": "20315"
  },
  {
    "TITULO": "San Pedro Mártir Quiechapa",
    "UBICACION_GEOGRAFICA": "20316"
  },
  {
    "TITULO": "San Pedro Mártir Yucuxaco",
    "UBICACION_GEOGRAFICA": "20317"
  },
  {
    "TITULO": "San Pedro Mixtepec -Dto. 22 -",
    "UBICACION_GEOGRAFICA": "20318"
  },
  {
    "TITULO": "San Pedro Mixtepec -Dto. 26 -",
    "UBICACION_GEOGRAFICA": "20319"
  },
  {
    "TITULO": "San Pedro Molinos",
    "UBICACION_GEOGRAFICA": "20320"
  },
  {
    "TITULO": "San Pedro Nopala",
    "UBICACION_GEOGRAFICA": "20321"
  },
  {
    "TITULO": "San Pedro Ocopetatillo",
    "UBICACION_GEOGRAFICA": "20322"
  },
  {
    "TITULO": "San Pedro Ocotepec",
    "UBICACION_GEOGRAFICA": "20323"
  },
  {
    "TITULO": "San Pedro Pochutla",
    "UBICACION_GEOGRAFICA": "20324"
  },
  {
    "TITULO": "San Pedro Quiatoni",
    "UBICACION_GEOGRAFICA": "20325"
  },
  {
    "TITULO": "San Pedro Sochiápam",
    "UBICACION_GEOGRAFICA": "20326"
  },
  {
    "TITULO": "San Pedro Tapanatepec",
    "UBICACION_GEOGRAFICA": "20327"
  },
  {
    "TITULO": "San Pedro Taviche",
    "UBICACION_GEOGRAFICA": "20328"
  },
  {
    "TITULO": "San Pedro Teozacoalco",
    "UBICACION_GEOGRAFICA": "20329"
  },
  {
    "TITULO": "San Pedro Teutila",
    "UBICACION_GEOGRAFICA": "20330"
  },
  {
    "TITULO": "San Pedro Tidaá",
    "UBICACION_GEOGRAFICA": "20331"
  },
  {
    "TITULO": "San Pedro Topiltepec",
    "UBICACION_GEOGRAFICA": "20332"
  },
  {
    "TITULO": "San Pedro Totolápam",
    "UBICACION_GEOGRAFICA": "20333"
  },
  {
    "TITULO": "Villa de Tututepec de Melchor Ocampo",
    "UBICACION_GEOGRAFICA": "20334"
  },
  {
    "TITULO": "San Pedro Yaneri",
    "UBICACION_GEOGRAFICA": "20335"
  },
  {
    "TITULO": "San Pedro Yólox",
    "UBICACION_GEOGRAFICA": "20336"
  },
  {
    "TITULO": "San Pedro y San Pablo Ayutla",
    "UBICACION_GEOGRAFICA": "20337"
  },
  {
    "TITULO": "Villa de Etla",
    "UBICACION_GEOGRAFICA": "20338"
  },
  {
    "TITULO": "San Pedro y San Pablo Teposcolula",
    "UBICACION_GEOGRAFICA": "20339"
  },
  {
    "TITULO": "San Pedro y San Pablo Tequixtepec",
    "UBICACION_GEOGRAFICA": "20340"
  },
  {
    "TITULO": "San Pedro Yucunama",
    "UBICACION_GEOGRAFICA": "20341"
  },
  {
    "TITULO": "San Raymundo Jalpan",
    "UBICACION_GEOGRAFICA": "20342"
  },
  {
    "TITULO": "San Sebastián Abasolo",
    "UBICACION_GEOGRAFICA": "20343"
  },
  {
    "TITULO": "San Sebastián Coatlán",
    "UBICACION_GEOGRAFICA": "20344"
  },
  {
    "TITULO": "San Sebastián Ixcapa",
    "UBICACION_GEOGRAFICA": "20345"
  },
  {
    "TITULO": "San Sebastián Nicananduta",
    "UBICACION_GEOGRAFICA": "20346"
  },
  {
    "TITULO": "San Sebastián Río Hondo",
    "UBICACION_GEOGRAFICA": "20347"
  },
  {
    "TITULO": "San Sebastián Tecomaxtlahuaca",
    "UBICACION_GEOGRAFICA": "20348"
  },
  {
    "TITULO": "San Sebastián Teitipac",
    "UBICACION_GEOGRAFICA": "20349"
  },
  {
    "TITULO": "San Sebastián Tutla",
    "UBICACION_GEOGRAFICA": "20350"
  },
  {
    "TITULO": "San Simón Almolongas",
    "UBICACION_GEOGRAFICA": "20351"
  },
  {
    "TITULO": "San Simón Zahuatlán",
    "UBICACION_GEOGRAFICA": "20352"
  },
  {
    "TITULO": "Santa Ana",
    "UBICACION_GEOGRAFICA": "20353"
  },
  {
    "TITULO": "Santa Ana Ateixtlahuaca",
    "UBICACION_GEOGRAFICA": "20354"
  },
  {
    "TITULO": "Santa Ana Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "20355"
  },
  {
    "TITULO": "Santa Ana del Valle",
    "UBICACION_GEOGRAFICA": "20356"
  },
  {
    "TITULO": "Santa Ana Tavela",
    "UBICACION_GEOGRAFICA": "20357"
  },
  {
    "TITULO": "Santa Ana Tlapacoyan",
    "UBICACION_GEOGRAFICA": "20358"
  },
  {
    "TITULO": "Santa Ana Yareni",
    "UBICACION_GEOGRAFICA": "20359"
  },
  {
    "TITULO": "Santa Ana Zegache",
    "UBICACION_GEOGRAFICA": "20360"
  },
  {
    "TITULO": "Santa Catalina Quierí",
    "UBICACION_GEOGRAFICA": "20361"
  },
  {
    "TITULO": "Santa Catarina Cuixtla",
    "UBICACION_GEOGRAFICA": "20362"
  },
  {
    "TITULO": "Santa Catarina Ixtepeji",
    "UBICACION_GEOGRAFICA": "20363"
  },
  {
    "TITULO": "Santa Catarina Juquila",
    "UBICACION_GEOGRAFICA": "20364"
  },
  {
    "TITULO": "Santa Catarina Lachatao",
    "UBICACION_GEOGRAFICA": "20365"
  },
  {
    "TITULO": "Santa Catarina Loxicha",
    "UBICACION_GEOGRAFICA": "20366"
  },
  {
    "TITULO": "Santa Catarina Mechoacán",
    "UBICACION_GEOGRAFICA": "20367"
  },
  {
    "TITULO": "Santa Catarina Minas",
    "UBICACION_GEOGRAFICA": "20368"
  },
  {
    "TITULO": "Santa Catarina Quiané",
    "UBICACION_GEOGRAFICA": "20369"
  },
  {
    "TITULO": "Santa Catarina Tayata",
    "UBICACION_GEOGRAFICA": "20370"
  },
  {
    "TITULO": "Santa Catarina Ticuá",
    "UBICACION_GEOGRAFICA": "20371"
  },
  {
    "TITULO": "Santa Catarina Yosonotú",
    "UBICACION_GEOGRAFICA": "20372"
  },
  {
    "TITULO": "Santa Catarina Zapoquila",
    "UBICACION_GEOGRAFICA": "20373"
  },
  {
    "TITULO": "Santa Cruz Acatepec",
    "UBICACION_GEOGRAFICA": "20374"
  },
  {
    "TITULO": "Santa Cruz Amilpas",
    "UBICACION_GEOGRAFICA": "20375"
  },
  {
    "TITULO": "Santa Cruz de Bravo",
    "UBICACION_GEOGRAFICA": "20376"
  },
  {
    "TITULO": "Santa Cruz Itundujia",
    "UBICACION_GEOGRAFICA": "20377"
  },
  {
    "TITULO": "Santa Cruz Mixtepec",
    "UBICACION_GEOGRAFICA": "20378"
  },
  {
    "TITULO": "Santa Cruz Nundaco",
    "UBICACION_GEOGRAFICA": "20379"
  },
  {
    "TITULO": "Santa Cruz Papalutla",
    "UBICACION_GEOGRAFICA": "20380"
  },
  {
    "TITULO": "Santa Cruz Tacache de Mina",
    "UBICACION_GEOGRAFICA": "20381"
  },
  {
    "TITULO": "Santa Cruz Tacahua",
    "UBICACION_GEOGRAFICA": "20382"
  },
  {
    "TITULO": "Santa Cruz Tayata",
    "UBICACION_GEOGRAFICA": "20383"
  },
  {
    "TITULO": "Santa Cruz Xitla",
    "UBICACION_GEOGRAFICA": "20384"
  },
  {
    "TITULO": "Santa Cruz Xoxocotlán",
    "UBICACION_GEOGRAFICA": "20385"
  },
  {
    "TITULO": "Santa Cruz Zenzontepec",
    "UBICACION_GEOGRAFICA": "20386"
  },
  {
    "TITULO": "Santa Gertrudis",
    "UBICACION_GEOGRAFICA": "20387"
  },
  {
    "TITULO": "Santa Inés del Monte",
    "UBICACION_GEOGRAFICA": "20388"
  },
  {
    "TITULO": "Santa Inés Yatzeche",
    "UBICACION_GEOGRAFICA": "20389"
  },
  {
    "TITULO": "Santa Lucía del Camino",
    "UBICACION_GEOGRAFICA": "20390"
  },
  {
    "TITULO": "Santa Lucía Miahuatlán",
    "UBICACION_GEOGRAFICA": "20391"
  },
  {
    "TITULO": "Santa Lucía Monteverde",
    "UBICACION_GEOGRAFICA": "20392"
  },
  {
    "TITULO": "Santa Lucía Ocotlán",
    "UBICACION_GEOGRAFICA": "20393"
  },
  {
    "TITULO": "Santa María Alotepec",
    "UBICACION_GEOGRAFICA": "20394"
  },
  {
    "TITULO": "Santa María Apazco",
    "UBICACION_GEOGRAFICA": "20395"
  },
  {
    "TITULO": "Santa María la Asunción",
    "UBICACION_GEOGRAFICA": "20396"
  },
  {
    "TITULO": "Heroica Ciudad de Tlaxiaco",
    "UBICACION_GEOGRAFICA": "20397"
  },
  {
    "TITULO": "Ayoquezco de Aldama",
    "UBICACION_GEOGRAFICA": "20398"
  },
  {
    "TITULO": "Santa María Atzompa",
    "UBICACION_GEOGRAFICA": "20399"
  },
  {
    "TITULO": "Santa María Camotlán",
    "UBICACION_GEOGRAFICA": "20400"
  },
  {
    "TITULO": "Santa María Colotepec",
    "UBICACION_GEOGRAFICA": "20401"
  },
  {
    "TITULO": "Santa María Cortijo",
    "UBICACION_GEOGRAFICA": "20402"
  },
  {
    "TITULO": "Santa María Coyotepec",
    "UBICACION_GEOGRAFICA": "20403"
  },
  {
    "TITULO": "Santa María Chachoápam",
    "UBICACION_GEOGRAFICA": "20404"
  },
  {
    "TITULO": "Villa de Chilapa de Díaz",
    "UBICACION_GEOGRAFICA": "20405"
  },
  {
    "TITULO": "Santa María Chilchotla",
    "UBICACION_GEOGRAFICA": "20406"
  },
  {
    "TITULO": "Santa María Chimalapa",
    "UBICACION_GEOGRAFICA": "20407"
  },
  {
    "TITULO": "Santa María del Rosario",
    "UBICACION_GEOGRAFICA": "20408"
  },
  {
    "TITULO": "Santa María del Tule",
    "UBICACION_GEOGRAFICA": "20409"
  },
  {
    "TITULO": "Santa María Ecatepec",
    "UBICACION_GEOGRAFICA": "20410"
  },
  {
    "TITULO": "Santa María Guelacé",
    "UBICACION_GEOGRAFICA": "20411"
  },
  {
    "TITULO": "Santa María Guienagati",
    "UBICACION_GEOGRAFICA": "20412"
  },
  {
    "TITULO": "Santa María Huatulco",
    "UBICACION_GEOGRAFICA": "20413"
  },
  {
    "TITULO": "Santa María Huazolotitlán",
    "UBICACION_GEOGRAFICA": "20414"
  },
  {
    "TITULO": "Santa María Ipalapa",
    "UBICACION_GEOGRAFICA": "20415"
  },
  {
    "TITULO": "Santa María Ixcatlán",
    "UBICACION_GEOGRAFICA": "20416"
  },
  {
    "TITULO": "Santa María Jacatepec",
    "UBICACION_GEOGRAFICA": "20417"
  },
  {
    "TITULO": "Santa María Jalapa del Marqués",
    "UBICACION_GEOGRAFICA": "20418"
  },
  {
    "TITULO": "Santa María Jaltianguis",
    "UBICACION_GEOGRAFICA": "20419"
  },
  {
    "TITULO": "Santa María Lachixío",
    "UBICACION_GEOGRAFICA": "20420"
  },
  {
    "TITULO": "Santa María Mixtequilla",
    "UBICACION_GEOGRAFICA": "20421"
  },
  {
    "TITULO": "Santa María Nativitas",
    "UBICACION_GEOGRAFICA": "20422"
  },
  {
    "TITULO": "Santa María Nduayaco",
    "UBICACION_GEOGRAFICA": "20423"
  },
  {
    "TITULO": "Santa María Ozolotepec",
    "UBICACION_GEOGRAFICA": "20424"
  },
  {
    "TITULO": "Santa María Pápalo",
    "UBICACION_GEOGRAFICA": "20425"
  },
  {
    "TITULO": "Santa María Peñoles",
    "UBICACION_GEOGRAFICA": "20426"
  },
  {
    "TITULO": "Santa María Petapa",
    "UBICACION_GEOGRAFICA": "20427"
  },
  {
    "TITULO": "Santa María Quiegolani",
    "UBICACION_GEOGRAFICA": "20428"
  },
  {
    "TITULO": "Santa María Sola",
    "UBICACION_GEOGRAFICA": "20429"
  },
  {
    "TITULO": "Santa María Tataltepec",
    "UBICACION_GEOGRAFICA": "20430"
  },
  {
    "TITULO": "Santa María Tecomavaca",
    "UBICACION_GEOGRAFICA": "20431"
  },
  {
    "TITULO": "Santa María Temaxcalapa",
    "UBICACION_GEOGRAFICA": "20432"
  },
  {
    "TITULO": "Santa María Temaxcaltepec",
    "UBICACION_GEOGRAFICA": "20433"
  },
  {
    "TITULO": "Santa María Teopoxco",
    "UBICACION_GEOGRAFICA": "20434"
  },
  {
    "TITULO": "Santa María Tepantlali",
    "UBICACION_GEOGRAFICA": "20435"
  },
  {
    "TITULO": "Santa María Texcatitlán",
    "UBICACION_GEOGRAFICA": "20436"
  },
  {
    "TITULO": "Santa María Tlahuitoltepec",
    "UBICACION_GEOGRAFICA": "20437"
  },
  {
    "TITULO": "Santa María Tlalixtac",
    "UBICACION_GEOGRAFICA": "20438"
  },
  {
    "TITULO": "Santa María Tonameca",
    "UBICACION_GEOGRAFICA": "20439"
  },
  {
    "TITULO": "Santa María Totolapilla",
    "UBICACION_GEOGRAFICA": "20440"
  },
  {
    "TITULO": "Santa María Xadani",
    "UBICACION_GEOGRAFICA": "20441"
  },
  {
    "TITULO": "Santa María Yalina",
    "UBICACION_GEOGRAFICA": "20442"
  },
  {
    "TITULO": "Santa María Yavesía",
    "UBICACION_GEOGRAFICA": "20443"
  },
  {
    "TITULO": "Santa María Yolotepec",
    "UBICACION_GEOGRAFICA": "20444"
  },
  {
    "TITULO": "Santa María Yosoyúa",
    "UBICACION_GEOGRAFICA": "20445"
  },
  {
    "TITULO": "Santa María Yucuhiti",
    "UBICACION_GEOGRAFICA": "20446"
  },
  {
    "TITULO": "Santa María Zacatepec",
    "UBICACION_GEOGRAFICA": "20447"
  },
  {
    "TITULO": "Santa María Zaniza",
    "UBICACION_GEOGRAFICA": "20448"
  },
  {
    "TITULO": "Santa María Zoquitlán",
    "UBICACION_GEOGRAFICA": "20449"
  },
  {
    "TITULO": "Santiago Amoltepec",
    "UBICACION_GEOGRAFICA": "20450"
  },
  {
    "TITULO": "Santiago Apoala",
    "UBICACION_GEOGRAFICA": "20451"
  },
  {
    "TITULO": "Santiago Apóstol",
    "UBICACION_GEOGRAFICA": "20452"
  },
  {
    "TITULO": "Santiago Astata",
    "UBICACION_GEOGRAFICA": "20453"
  },
  {
    "TITULO": "Santiago Atitlán",
    "UBICACION_GEOGRAFICA": "20454"
  },
  {
    "TITULO": "Santiago Ayuquililla",
    "UBICACION_GEOGRAFICA": "20455"
  },
  {
    "TITULO": "Santiago Cacaloxtepec",
    "UBICACION_GEOGRAFICA": "20456"
  },
  {
    "TITULO": "Santiago Camotlán",
    "UBICACION_GEOGRAFICA": "20457"
  },
  {
    "TITULO": "Santiago Comaltepec",
    "UBICACION_GEOGRAFICA": "20458"
  },
  {
    "TITULO": "Santiago Chazumba",
    "UBICACION_GEOGRAFICA": "20459"
  },
  {
    "TITULO": "Santiago Choápam",
    "UBICACION_GEOGRAFICA": "20460"
  },
  {
    "TITULO": "Santiago del Río",
    "UBICACION_GEOGRAFICA": "20461"
  },
  {
    "TITULO": "Santiago Huajolotitlán",
    "UBICACION_GEOGRAFICA": "20462"
  },
  {
    "TITULO": "Santiago Huauclilla",
    "UBICACION_GEOGRAFICA": "20463"
  },
  {
    "TITULO": "Santiago Ihuitlán Plumas",
    "UBICACION_GEOGRAFICA": "20464"
  },
  {
    "TITULO": "Santiago Ixcuintepec",
    "UBICACION_GEOGRAFICA": "20465"
  },
  {
    "TITULO": "Santiago Ixtayutla",
    "UBICACION_GEOGRAFICA": "20466"
  },
  {
    "TITULO": "Santiago Jamiltepec",
    "UBICACION_GEOGRAFICA": "20467"
  },
  {
    "TITULO": "Santiago Jocotepec",
    "UBICACION_GEOGRAFICA": "20468"
  },
  {
    "TITULO": "Santiago Juxtlahuaca",
    "UBICACION_GEOGRAFICA": "20469"
  },
  {
    "TITULO": "Santiago Lachiguiri",
    "UBICACION_GEOGRAFICA": "20470"
  },
  {
    "TITULO": "Santiago Lalopa",
    "UBICACION_GEOGRAFICA": "20471"
  },
  {
    "TITULO": "Santiago Laollaga",
    "UBICACION_GEOGRAFICA": "20472"
  },
  {
    "TITULO": "Santiago Laxopa",
    "UBICACION_GEOGRAFICA": "20473"
  },
  {
    "TITULO": "Santiago Llano Grande",
    "UBICACION_GEOGRAFICA": "20474"
  },
  {
    "TITULO": "Santiago Matatlán",
    "UBICACION_GEOGRAFICA": "20475"
  },
  {
    "TITULO": "Santiago Miltepec",
    "UBICACION_GEOGRAFICA": "20476"
  },
  {
    "TITULO": "Santiago Minas",
    "UBICACION_GEOGRAFICA": "20477"
  },
  {
    "TITULO": "Santiago Nacaltepec",
    "UBICACION_GEOGRAFICA": "20478"
  },
  {
    "TITULO": "Santiago Nejapilla",
    "UBICACION_GEOGRAFICA": "20479"
  },
  {
    "TITULO": "Santiago Nundiche",
    "UBICACION_GEOGRAFICA": "20480"
  },
  {
    "TITULO": "Santiago Nuyoó",
    "UBICACION_GEOGRAFICA": "20481"
  },
  {
    "TITULO": "Santiago Pinotepa Nacional",
    "UBICACION_GEOGRAFICA": "20482"
  },
  {
    "TITULO": "Santiago Suchilquitongo",
    "UBICACION_GEOGRAFICA": "20483"
  },
  {
    "TITULO": "Santiago Tamazola",
    "UBICACION_GEOGRAFICA": "20484"
  },
  {
    "TITULO": "Santiago Tapextla",
    "UBICACION_GEOGRAFICA": "20485"
  },
  {
    "TITULO": "Villa Tejúpam de la Unión",
    "UBICACION_GEOGRAFICA": "20486"
  },
  {
    "TITULO": "Santiago Tenango",
    "UBICACION_GEOGRAFICA": "20487"
  },
  {
    "TITULO": "Santiago Tepetlapa",
    "UBICACION_GEOGRAFICA": "20488"
  },
  {
    "TITULO": "Santiago Tetepec",
    "UBICACION_GEOGRAFICA": "20489"
  },
  {
    "TITULO": "Santiago Texcalcingo",
    "UBICACION_GEOGRAFICA": "20490"
  },
  {
    "TITULO": "Santiago Textitlán",
    "UBICACION_GEOGRAFICA": "20491"
  },
  {
    "TITULO": "Santiago Tilantongo",
    "UBICACION_GEOGRAFICA": "20492"
  },
  {
    "TITULO": "Santiago Tillo",
    "UBICACION_GEOGRAFICA": "20493"
  },
  {
    "TITULO": "Santiago Tlazoyaltepec",
    "UBICACION_GEOGRAFICA": "20494"
  },
  {
    "TITULO": "Santiago Xanica",
    "UBICACION_GEOGRAFICA": "20495"
  },
  {
    "TITULO": "Santiago Xiacuí",
    "UBICACION_GEOGRAFICA": "20496"
  },
  {
    "TITULO": "Santiago Yaitepec",
    "UBICACION_GEOGRAFICA": "20497"
  },
  {
    "TITULO": "Santiago Yaveo",
    "UBICACION_GEOGRAFICA": "20498"
  },
  {
    "TITULO": "Santiago Yolomécatl",
    "UBICACION_GEOGRAFICA": "20499"
  },
  {
    "TITULO": "Santiago Yosondúa",
    "UBICACION_GEOGRAFICA": "20500"
  },
  {
    "TITULO": "Santiago Yucuyachi",
    "UBICACION_GEOGRAFICA": "20501"
  },
  {
    "TITULO": "Santiago Zacatepec",
    "UBICACION_GEOGRAFICA": "20502"
  },
  {
    "TITULO": "Santiago Zoochila",
    "UBICACION_GEOGRAFICA": "20503"
  },
  {
    "TITULO": "Nuevo Zoquiápam",
    "UBICACION_GEOGRAFICA": "20504"
  },
  {
    "TITULO": "Santo Domingo Ingenio",
    "UBICACION_GEOGRAFICA": "20505"
  },
  {
    "TITULO": "Santo Domingo Albarradas",
    "UBICACION_GEOGRAFICA": "20506"
  },
  {
    "TITULO": "Santo Domingo Armenta",
    "UBICACION_GEOGRAFICA": "20507"
  },
  {
    "TITULO": "Santo Domingo Chihuitán",
    "UBICACION_GEOGRAFICA": "20508"
  },
  {
    "TITULO": "Santo Domingo de Morelos",
    "UBICACION_GEOGRAFICA": "20509"
  },
  {
    "TITULO": "Santo Domingo Ixcatlán",
    "UBICACION_GEOGRAFICA": "20510"
  },
  {
    "TITULO": "Santo Domingo Nuxaá",
    "UBICACION_GEOGRAFICA": "20511"
  },
  {
    "TITULO": "Santo Domingo Ozolotepec",
    "UBICACION_GEOGRAFICA": "20512"
  },
  {
    "TITULO": "Santo Domingo Petapa",
    "UBICACION_GEOGRAFICA": "20513"
  },
  {
    "TITULO": "Santo Domingo Roayaga",
    "UBICACION_GEOGRAFICA": "20514"
  },
  {
    "TITULO": "Santo Domingo Tehuantepec",
    "UBICACION_GEOGRAFICA": "20515"
  },
  {
    "TITULO": "Santo Domingo Teojomulco",
    "UBICACION_GEOGRAFICA": "20516"
  },
  {
    "TITULO": "Santo Domingo Tepuxtepec",
    "UBICACION_GEOGRAFICA": "20517"
  },
  {
    "TITULO": "Santo Domingo Tlatayápam",
    "UBICACION_GEOGRAFICA": "20518"
  },
  {
    "TITULO": "Santo Domingo Tomaltepec",
    "UBICACION_GEOGRAFICA": "20519"
  },
  {
    "TITULO": "Santo Domingo Tonalá",
    "UBICACION_GEOGRAFICA": "20520"
  },
  {
    "TITULO": "Santo Domingo Tonaltepec",
    "UBICACION_GEOGRAFICA": "20521"
  },
  {
    "TITULO": "Santo Domingo Xagacía",
    "UBICACION_GEOGRAFICA": "20522"
  },
  {
    "TITULO": "Santo Domingo Yanhuitlán",
    "UBICACION_GEOGRAFICA": "20523"
  },
  {
    "TITULO": "Santo Domingo Yodohino",
    "UBICACION_GEOGRAFICA": "20524"
  },
  {
    "TITULO": "Santo Domingo Zanatepec",
    "UBICACION_GEOGRAFICA": "20525"
  },
  {
    "TITULO": "Santos Reyes Nopala",
    "UBICACION_GEOGRAFICA": "20526"
  },
  {
    "TITULO": "Santos Reyes Pápalo",
    "UBICACION_GEOGRAFICA": "20527"
  },
  {
    "TITULO": "Santos Reyes Tepejillo",
    "UBICACION_GEOGRAFICA": "20528"
  },
  {
    "TITULO": "Santos Reyes Yucuná",
    "UBICACION_GEOGRAFICA": "20529"
  },
  {
    "TITULO": "Santo Tomás Jalieza",
    "UBICACION_GEOGRAFICA": "20530"
  },
  {
    "TITULO": "Santo Tomás Mazaltepec",
    "UBICACION_GEOGRAFICA": "20531"
  },
  {
    "TITULO": "Santo Tomás Ocotepec",
    "UBICACION_GEOGRAFICA": "20532"
  },
  {
    "TITULO": "Santo Tomás Tamazulapan",
    "UBICACION_GEOGRAFICA": "20533"
  },
  {
    "TITULO": "San Vicente Coatlán",
    "UBICACION_GEOGRAFICA": "20534"
  },
  {
    "TITULO": "San Vicente Lachixío",
    "UBICACION_GEOGRAFICA": "20535"
  },
  {
    "TITULO": "San Vicente Nuñú",
    "UBICACION_GEOGRAFICA": "20536"
  },
  {
    "TITULO": "Silacayoápam",
    "UBICACION_GEOGRAFICA": "20537"
  },
  {
    "TITULO": "Sitio de Xitlapehua",
    "UBICACION_GEOGRAFICA": "20538"
  },
  {
    "TITULO": "Soledad Etla",
    "UBICACION_GEOGRAFICA": "20539"
  },
  {
    "TITULO": "Villa de Tamazulápam del Progreso",
    "UBICACION_GEOGRAFICA": "20540"
  },
  {
    "TITULO": "Tanetze de Zaragoza",
    "UBICACION_GEOGRAFICA": "20541"
  },
  {
    "TITULO": "Taniche",
    "UBICACION_GEOGRAFICA": "20542"
  },
  {
    "TITULO": "Tataltepec de Valdés",
    "UBICACION_GEOGRAFICA": "20543"
  },
  {
    "TITULO": "Teococuilco de Marcos Pérez",
    "UBICACION_GEOGRAFICA": "20544"
  },
  {
    "TITULO": "Teotitlán de Flores Magón",
    "UBICACION_GEOGRAFICA": "20545"
  },
  {
    "TITULO": "Teotitlán del Valle",
    "UBICACION_GEOGRAFICA": "20546"
  },
  {
    "TITULO": "Teotongo",
    "UBICACION_GEOGRAFICA": "20547"
  },
  {
    "TITULO": "Tepelmeme Villa de Morelos",
    "UBICACION_GEOGRAFICA": "20548"
  },
  {
    "TITULO": "Tezoatlán de Segura y Luna",
    "UBICACION_GEOGRAFICA": "20549"
  },
  {
    "TITULO": "San Jerónimo Tlacochahuaya",
    "UBICACION_GEOGRAFICA": "20550"
  },
  {
    "TITULO": "Tlacolula de Matamoros",
    "UBICACION_GEOGRAFICA": "20551"
  },
  {
    "TITULO": "Tlacotepec Plumas",
    "UBICACION_GEOGRAFICA": "20552"
  },
  {
    "TITULO": "Tlalixtac de Cabrera",
    "UBICACION_GEOGRAFICA": "20553"
  },
  {
    "TITULO": "Totontepec Villa de Morelos",
    "UBICACION_GEOGRAFICA": "20554"
  },
  {
    "TITULO": "Trinidad Zaachila",
    "UBICACION_GEOGRAFICA": "20555"
  },
  {
    "TITULO": "La Trinidad Vista Hermosa",
    "UBICACION_GEOGRAFICA": "20556"
  },
  {
    "TITULO": "Unión Hidalgo",
    "UBICACION_GEOGRAFICA": "20557"
  },
  {
    "TITULO": "Valerio Trujano",
    "UBICACION_GEOGRAFICA": "20558"
  },
  {
    "TITULO": "San Juan Bautista Valle Nacional",
    "UBICACION_GEOGRAFICA": "20559"
  },
  {
    "TITULO": "Villa Díaz Ordaz",
    "UBICACION_GEOGRAFICA": "20560"
  },
  {
    "TITULO": "Yaxe",
    "UBICACION_GEOGRAFICA": "20561"
  },
  {
    "TITULO": "Magdalena Yodocono de Porfirio Díaz",
    "UBICACION_GEOGRAFICA": "20562"
  },
  {
    "TITULO": "Yogana",
    "UBICACION_GEOGRAFICA": "20563"
  },
  {
    "TITULO": "Yutanduchi de Guerrero",
    "UBICACION_GEOGRAFICA": "20564"
  },
  {
    "TITULO": "Villa de Zaachila",
    "UBICACION_GEOGRAFICA": "20565"
  },
  {
    "TITULO": "San Mateo Yucutindó",
    "UBICACION_GEOGRAFICA": "20566"
  },
  {
    "TITULO": "Zapotitlán Lagunas",
    "UBICACION_GEOGRAFICA": "20567"
  },
  {
    "TITULO": "Zapotitlán Palmas",
    "UBICACION_GEOGRAFICA": "20568"
  },
  {
    "TITULO": "Santa Inés de Zaragoza",
    "UBICACION_GEOGRAFICA": "20569"
  },
  {
    "TITULO": "Zimatlán de Álvarez",
    "UBICACION_GEOGRAFICA": "20570"
  },
  {
    "TITULO": "Puebla",
    "UBICACION_GEOGRAFICA": "21"
  },
  {
    "TITULO": "Acajete",
    "UBICACION_GEOGRAFICA": "21001"
  },
  {
    "TITULO": "Acateno",
    "UBICACION_GEOGRAFICA": "21002"
  },
  {
    "TITULO": "Acatlán",
    "UBICACION_GEOGRAFICA": "21003"
  },
  {
    "TITULO": "Acatzingo",
    "UBICACION_GEOGRAFICA": "21004"
  },
  {
    "TITULO": "Acteopan",
    "UBICACION_GEOGRAFICA": "21005"
  },
  {
    "TITULO": "Ahuacatlán",
    "UBICACION_GEOGRAFICA": "21006"
  },
  {
    "TITULO": "Ahuatlán",
    "UBICACION_GEOGRAFICA": "21007"
  },
  {
    "TITULO": "Ahuazotepec",
    "UBICACION_GEOGRAFICA": "21008"
  },
  {
    "TITULO": "Ahuehuetitla",
    "UBICACION_GEOGRAFICA": "21009"
  },
  {
    "TITULO": "Ajalpan",
    "UBICACION_GEOGRAFICA": "21010"
  },
  {
    "TITULO": "Albino Zertuche",
    "UBICACION_GEOGRAFICA": "21011"
  },
  {
    "TITULO": "Aljojuca",
    "UBICACION_GEOGRAFICA": "21012"
  },
  {
    "TITULO": "Altepexi",
    "UBICACION_GEOGRAFICA": "21013"
  },
  {
    "TITULO": "Amixtlán",
    "UBICACION_GEOGRAFICA": "21014"
  },
  {
    "TITULO": "Amozoc",
    "UBICACION_GEOGRAFICA": "21015"
  },
  {
    "TITULO": "Aquixtla",
    "UBICACION_GEOGRAFICA": "21016"
  },
  {
    "TITULO": "Atempan",
    "UBICACION_GEOGRAFICA": "21017"
  },
  {
    "TITULO": "Atexcal",
    "UBICACION_GEOGRAFICA": "21018"
  },
  {
    "TITULO": "Atlixco",
    "UBICACION_GEOGRAFICA": "21019"
  },
  {
    "TITULO": "Atoyatempan",
    "UBICACION_GEOGRAFICA": "21020"
  },
  {
    "TITULO": "Atzala",
    "UBICACION_GEOGRAFICA": "21021"
  },
  {
    "TITULO": "Atzitzihuacán",
    "UBICACION_GEOGRAFICA": "21022"
  },
  {
    "TITULO": "Atzitzintla",
    "UBICACION_GEOGRAFICA": "21023"
  },
  {
    "TITULO": "Axutla",
    "UBICACION_GEOGRAFICA": "21024"
  },
  {
    "TITULO": "Ayotoxco de Guerrero",
    "UBICACION_GEOGRAFICA": "21025"
  },
  {
    "TITULO": "Calpan",
    "UBICACION_GEOGRAFICA": "21026"
  },
  {
    "TITULO": "Caltepec",
    "UBICACION_GEOGRAFICA": "21027"
  },
  {
    "TITULO": "Camocuautla",
    "UBICACION_GEOGRAFICA": "21028"
  },
  {
    "TITULO": "Caxhuacan",
    "UBICACION_GEOGRAFICA": "21029"
  },
  {
    "TITULO": "Coatepec",
    "UBICACION_GEOGRAFICA": "21030"
  },
  {
    "TITULO": "Coatzingo",
    "UBICACION_GEOGRAFICA": "21031"
  },
  {
    "TITULO": "Cohetzala",
    "UBICACION_GEOGRAFICA": "21032"
  },
  {
    "TITULO": "Cohuecan",
    "UBICACION_GEOGRAFICA": "21033"
  },
  {
    "TITULO": "Coronango",
    "UBICACION_GEOGRAFICA": "21034"
  },
  {
    "TITULO": "Coxcatlán",
    "UBICACION_GEOGRAFICA": "21035"
  },
  {
    "TITULO": "Coyomeapan",
    "UBICACION_GEOGRAFICA": "21036"
  },
  {
    "TITULO": "Coyotepec",
    "UBICACION_GEOGRAFICA": "21037"
  },
  {
    "TITULO": "Cuapiaxtla de Madero",
    "UBICACION_GEOGRAFICA": "21038"
  },
  {
    "TITULO": "Cuautempan",
    "UBICACION_GEOGRAFICA": "21039"
  },
  {
    "TITULO": "Cuautinchán",
    "UBICACION_GEOGRAFICA": "21040"
  },
  {
    "TITULO": "Cuautlancingo",
    "UBICACION_GEOGRAFICA": "21041"
  },
  {
    "TITULO": "Cuayuca de Andrade",
    "UBICACION_GEOGRAFICA": "21042"
  },
  {
    "TITULO": "Cuetzalan del Progreso",
    "UBICACION_GEOGRAFICA": "21043"
  },
  {
    "TITULO": "Cuyoaco",
    "UBICACION_GEOGRAFICA": "21044"
  },
  {
    "TITULO": "Chalchicomula de Sesma",
    "UBICACION_GEOGRAFICA": "21045"
  },
  {
    "TITULO": "Chapulco",
    "UBICACION_GEOGRAFICA": "21046"
  },
  {
    "TITULO": "Chiautla",
    "UBICACION_GEOGRAFICA": "21047"
  },
  {
    "TITULO": "Chiautzingo",
    "UBICACION_GEOGRAFICA": "21048"
  },
  {
    "TITULO": "Chiconcuautla",
    "UBICACION_GEOGRAFICA": "21049"
  },
  {
    "TITULO": "Chichiquila",
    "UBICACION_GEOGRAFICA": "21050"
  },
  {
    "TITULO": "Chietla",
    "UBICACION_GEOGRAFICA": "21051"
  },
  {
    "TITULO": "Chigmecatitlán",
    "UBICACION_GEOGRAFICA": "21052"
  },
  {
    "TITULO": "Chignahuapan",
    "UBICACION_GEOGRAFICA": "21053"
  },
  {
    "TITULO": "Chignautla",
    "UBICACION_GEOGRAFICA": "21054"
  },
  {
    "TITULO": "Chila",
    "UBICACION_GEOGRAFICA": "21055"
  },
  {
    "TITULO": "Chila de la Sal",
    "UBICACION_GEOGRAFICA": "21056"
  },
  {
    "TITULO": "Honey",
    "UBICACION_GEOGRAFICA": "21057"
  },
  {
    "TITULO": "Chilchotla",
    "UBICACION_GEOGRAFICA": "21058"
  },
  {
    "TITULO": "Chinantla",
    "UBICACION_GEOGRAFICA": "21059"
  },
  {
    "TITULO": "Domingo Arenas",
    "UBICACION_GEOGRAFICA": "21060"
  },
  {
    "TITULO": "Eloxochitlán",
    "UBICACION_GEOGRAFICA": "21061"
  },
  {
    "TITULO": "Epatlán",
    "UBICACION_GEOGRAFICA": "21062"
  },
  {
    "TITULO": "Esperanza",
    "UBICACION_GEOGRAFICA": "21063"
  },
  {
    "TITULO": "Francisco Z. Mena",
    "UBICACION_GEOGRAFICA": "21064"
  },
  {
    "TITULO": "General Felipe Ángeles",
    "UBICACION_GEOGRAFICA": "21065"
  },
  {
    "TITULO": "Guadalupe",
    "UBICACION_GEOGRAFICA": "21066"
  },
  {
    "TITULO": "Guadalupe Victoria",
    "UBICACION_GEOGRAFICA": "21067"
  },
  {
    "TITULO": "Hermenegildo Galeana",
    "UBICACION_GEOGRAFICA": "21068"
  },
  {
    "TITULO": "Huaquechula",
    "UBICACION_GEOGRAFICA": "21069"
  },
  {
    "TITULO": "Huatlatlauca",
    "UBICACION_GEOGRAFICA": "21070"
  },
  {
    "TITULO": "Huauchinango",
    "UBICACION_GEOGRAFICA": "21071"
  },
  {
    "TITULO": "Huehuetla",
    "UBICACION_GEOGRAFICA": "21072"
  },
  {
    "TITULO": "Huehuetlán el Chico",
    "UBICACION_GEOGRAFICA": "21073"
  },
  {
    "TITULO": "Huejotzingo",
    "UBICACION_GEOGRAFICA": "21074"
  },
  {
    "TITULO": "Hueyapan",
    "UBICACION_GEOGRAFICA": "21075"
  },
  {
    "TITULO": "Hueytamalco",
    "UBICACION_GEOGRAFICA": "21076"
  },
  {
    "TITULO": "Hueytlalpan",
    "UBICACION_GEOGRAFICA": "21077"
  },
  {
    "TITULO": "Huitzilan de Serdán",
    "UBICACION_GEOGRAFICA": "21078"
  },
  {
    "TITULO": "Huitziltepec",
    "UBICACION_GEOGRAFICA": "21079"
  },
  {
    "TITULO": "Atlequizayan",
    "UBICACION_GEOGRAFICA": "21080"
  },
  {
    "TITULO": "Ixcamilpa de Guerrero",
    "UBICACION_GEOGRAFICA": "21081"
  },
  {
    "TITULO": "Ixcaquixtla",
    "UBICACION_GEOGRAFICA": "21082"
  },
  {
    "TITULO": "Ixtacamaxtitlán",
    "UBICACION_GEOGRAFICA": "21083"
  },
  {
    "TITULO": "Ixtepec",
    "UBICACION_GEOGRAFICA": "21084"
  },
  {
    "TITULO": "Izúcar de Matamoros",
    "UBICACION_GEOGRAFICA": "21085"
  },
  {
    "TITULO": "Jalpan",
    "UBICACION_GEOGRAFICA": "21086"
  },
  {
    "TITULO": "Jolalpan",
    "UBICACION_GEOGRAFICA": "21087"
  },
  {
    "TITULO": "Jonotla",
    "UBICACION_GEOGRAFICA": "21088"
  },
  {
    "TITULO": "Jopala",
    "UBICACION_GEOGRAFICA": "21089"
  },
  {
    "TITULO": "Juan C. Bonilla",
    "UBICACION_GEOGRAFICA": "21090"
  },
  {
    "TITULO": "Juan Galindo",
    "UBICACION_GEOGRAFICA": "21091"
  },
  {
    "TITULO": "Juan N. Méndez",
    "UBICACION_GEOGRAFICA": "21092"
  },
  {
    "TITULO": "Lafragua",
    "UBICACION_GEOGRAFICA": "21093"
  },
  {
    "TITULO": "Libres",
    "UBICACION_GEOGRAFICA": "21094"
  },
  {
    "TITULO": "La Magdalena Tlatlauquitepec",
    "UBICACION_GEOGRAFICA": "21095"
  },
  {
    "TITULO": "Mazapiltepec de Juárez",
    "UBICACION_GEOGRAFICA": "21096"
  },
  {
    "TITULO": "Mixtla",
    "UBICACION_GEOGRAFICA": "21097"
  },
  {
    "TITULO": "Molcaxac",
    "UBICACION_GEOGRAFICA": "21098"
  },
  {
    "TITULO": "Cañada Morelos",
    "UBICACION_GEOGRAFICA": "21099"
  },
  {
    "TITULO": "Naupan",
    "UBICACION_GEOGRAFICA": "21100"
  },
  {
    "TITULO": "Nauzontla",
    "UBICACION_GEOGRAFICA": "21101"
  },
  {
    "TITULO": "Nealtican",
    "UBICACION_GEOGRAFICA": "21102"
  },
  {
    "TITULO": "Nicolás Bravo",
    "UBICACION_GEOGRAFICA": "21103"
  },
  {
    "TITULO": "Nopalucan",
    "UBICACION_GEOGRAFICA": "21104"
  },
  {
    "TITULO": "Ocotepec",
    "UBICACION_GEOGRAFICA": "21105"
  },
  {
    "TITULO": "Ocoyucan",
    "UBICACION_GEOGRAFICA": "21106"
  },
  {
    "TITULO": "Olintla",
    "UBICACION_GEOGRAFICA": "21107"
  },
  {
    "TITULO": "Oriental",
    "UBICACION_GEOGRAFICA": "21108"
  },
  {
    "TITULO": "Pahuatlán",
    "UBICACION_GEOGRAFICA": "21109"
  },
  {
    "TITULO": "Palmar de Bravo",
    "UBICACION_GEOGRAFICA": "21110"
  },
  {
    "TITULO": "Pantepec",
    "UBICACION_GEOGRAFICA": "21111"
  },
  {
    "TITULO": "Petlalcingo",
    "UBICACION_GEOGRAFICA": "21112"
  },
  {
    "TITULO": "Piaxtla",
    "UBICACION_GEOGRAFICA": "21113"
  },
  {
    "TITULO": "Puebla, Puebla",
    "UBICACION_GEOGRAFICA": "21114"
  },
  {
    "TITULO": "Quecholac",
    "UBICACION_GEOGRAFICA": "21115"
  },
  {
    "TITULO": "Quimixtlán",
    "UBICACION_GEOGRAFICA": "21116"
  },
  {
    "TITULO": "Rafael Lara Grajales",
    "UBICACION_GEOGRAFICA": "21117"
  },
  {
    "TITULO": "Los Reyes de Juárez",
    "UBICACION_GEOGRAFICA": "21118"
  },
  {
    "TITULO": "San Andrés Cholula",
    "UBICACION_GEOGRAFICA": "21119"
  },
  {
    "TITULO": "San Antonio Cañada",
    "UBICACION_GEOGRAFICA": "21120"
  },
  {
    "TITULO": "San Diego la Mesa Tochimiltzingo",
    "UBICACION_GEOGRAFICA": "21121"
  },
  {
    "TITULO": "San Felipe Teotlalcingo",
    "UBICACION_GEOGRAFICA": "21122"
  },
  {
    "TITULO": "San Felipe Tepatlán",
    "UBICACION_GEOGRAFICA": "21123"
  },
  {
    "TITULO": "San Gabriel Chilac",
    "UBICACION_GEOGRAFICA": "21124"
  },
  {
    "TITULO": "San Gregorio Atzompa",
    "UBICACION_GEOGRAFICA": "21125"
  },
  {
    "TITULO": "San Jerónimo Tecuanipan",
    "UBICACION_GEOGRAFICA": "21126"
  },
  {
    "TITULO": "San Jerónimo Xayacatlán",
    "UBICACION_GEOGRAFICA": "21127"
  },
  {
    "TITULO": "San José Chiapa",
    "UBICACION_GEOGRAFICA": "21128"
  },
  {
    "TITULO": "San José Miahuatlán",
    "UBICACION_GEOGRAFICA": "21129"
  },
  {
    "TITULO": "San Juan Atenco",
    "UBICACION_GEOGRAFICA": "21130"
  },
  {
    "TITULO": "San Juan Atzompa",
    "UBICACION_GEOGRAFICA": "21131"
  },
  {
    "TITULO": "San Martín Texmelucan",
    "UBICACION_GEOGRAFICA": "21132"
  },
  {
    "TITULO": "San Martín Totoltepec",
    "UBICACION_GEOGRAFICA": "21133"
  },
  {
    "TITULO": "San Matías Tlalancaleca",
    "UBICACION_GEOGRAFICA": "21134"
  },
  {
    "TITULO": "San Miguel Ixitlán",
    "UBICACION_GEOGRAFICA": "21135"
  },
  {
    "TITULO": "San Miguel Xoxtla",
    "UBICACION_GEOGRAFICA": "21136"
  },
  {
    "TITULO": "San Nicolás Buenos Aires",
    "UBICACION_GEOGRAFICA": "21137"
  },
  {
    "TITULO": "San Nicolás de los Ranchos",
    "UBICACION_GEOGRAFICA": "21138"
  },
  {
    "TITULO": "San Pablo Anicano",
    "UBICACION_GEOGRAFICA": "21139"
  },
  {
    "TITULO": "San Pedro Cholula",
    "UBICACION_GEOGRAFICA": "21140"
  },
  {
    "TITULO": "San Pedro Yeloixtlahuaca",
    "UBICACION_GEOGRAFICA": "21141"
  },
  {
    "TITULO": "San Salvador el Seco",
    "UBICACION_GEOGRAFICA": "21142"
  },
  {
    "TITULO": "San Salvador el Verde",
    "UBICACION_GEOGRAFICA": "21143"
  },
  {
    "TITULO": "San Salvador Huixcolotla",
    "UBICACION_GEOGRAFICA": "21144"
  },
  {
    "TITULO": "San Sebastián Tlacotepec",
    "UBICACION_GEOGRAFICA": "21145"
  },
  {
    "TITULO": "Santa Catarina Tlaltempan",
    "UBICACION_GEOGRAFICA": "21146"
  },
  {
    "TITULO": "Santa Inés Ahuatempan",
    "UBICACION_GEOGRAFICA": "21147"
  },
  {
    "TITULO": "Santa Isabel Cholula",
    "UBICACION_GEOGRAFICA": "21148"
  },
  {
    "TITULO": "Santiago Miahuatlán",
    "UBICACION_GEOGRAFICA": "21149"
  },
  {
    "TITULO": "Huehuetlán el Grande",
    "UBICACION_GEOGRAFICA": "21150"
  },
  {
    "TITULO": "Santo Tomás Hueyotlipan",
    "UBICACION_GEOGRAFICA": "21151"
  },
  {
    "TITULO": "Soltepec",
    "UBICACION_GEOGRAFICA": "21152"
  },
  {
    "TITULO": "Tecali de Herrera",
    "UBICACION_GEOGRAFICA": "21153"
  },
  {
    "TITULO": "Tecamachalco",
    "UBICACION_GEOGRAFICA": "21154"
  },
  {
    "TITULO": "Tecomatlán",
    "UBICACION_GEOGRAFICA": "21155"
  },
  {
    "TITULO": "Tehuacán",
    "UBICACION_GEOGRAFICA": "21156"
  },
  {
    "TITULO": "Tehuitzingo",
    "UBICACION_GEOGRAFICA": "21157"
  },
  {
    "TITULO": "Tenampulco",
    "UBICACION_GEOGRAFICA": "21158"
  },
  {
    "TITULO": "Teopantlán",
    "UBICACION_GEOGRAFICA": "21159"
  },
  {
    "TITULO": "Teotlalco",
    "UBICACION_GEOGRAFICA": "21160"
  },
  {
    "TITULO": "Tepanco de López",
    "UBICACION_GEOGRAFICA": "21161"
  },
  {
    "TITULO": "Tepango de Rodríguez",
    "UBICACION_GEOGRAFICA": "21162"
  },
  {
    "TITULO": "Tepatlaxco de Hidalgo",
    "UBICACION_GEOGRAFICA": "21163"
  },
  {
    "TITULO": "Tepeaca",
    "UBICACION_GEOGRAFICA": "21164"
  },
  {
    "TITULO": "Tepemaxalco",
    "UBICACION_GEOGRAFICA": "21165"
  },
  {
    "TITULO": "Tepeojuma",
    "UBICACION_GEOGRAFICA": "21166"
  },
  {
    "TITULO": "Tepetzintla",
    "UBICACION_GEOGRAFICA": "21167"
  },
  {
    "TITULO": "Tepexco",
    "UBICACION_GEOGRAFICA": "21168"
  },
  {
    "TITULO": "Tepexi de Rodríguez",
    "UBICACION_GEOGRAFICA": "21169"
  },
  {
    "TITULO": "Tepeyahualco",
    "UBICACION_GEOGRAFICA": "21170"
  },
  {
    "TITULO": "Tepeyahualco de Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "21171"
  },
  {
    "TITULO": "Tetela de Ocampo",
    "UBICACION_GEOGRAFICA": "21172"
  },
  {
    "TITULO": "Teteles de Avila Castillo",
    "UBICACION_GEOGRAFICA": "21173"
  },
  {
    "TITULO": "Teziutlán",
    "UBICACION_GEOGRAFICA": "21174"
  },
  {
    "TITULO": "Tianguismanalco",
    "UBICACION_GEOGRAFICA": "21175"
  },
  {
    "TITULO": "Tilapa",
    "UBICACION_GEOGRAFICA": "21176"
  },
  {
    "TITULO": "Tlacotepec de Benito Juárez",
    "UBICACION_GEOGRAFICA": "21177"
  },
  {
    "TITULO": "Tlacuilotepec",
    "UBICACION_GEOGRAFICA": "21178"
  },
  {
    "TITULO": "Tlachichuca",
    "UBICACION_GEOGRAFICA": "21179"
  },
  {
    "TITULO": "Tlahuapan",
    "UBICACION_GEOGRAFICA": "21180"
  },
  {
    "TITULO": "Tlaltenango",
    "UBICACION_GEOGRAFICA": "21181"
  },
  {
    "TITULO": "Tlanepantla",
    "UBICACION_GEOGRAFICA": "21182"
  },
  {
    "TITULO": "Tlaola",
    "UBICACION_GEOGRAFICA": "21183"
  },
  {
    "TITULO": "Tlapacoya",
    "UBICACION_GEOGRAFICA": "21184"
  },
  {
    "TITULO": "Tlapanalá",
    "UBICACION_GEOGRAFICA": "21185"
  },
  {
    "TITULO": "Tlatlauquitepec",
    "UBICACION_GEOGRAFICA": "21186"
  },
  {
    "TITULO": "Tlaxco",
    "UBICACION_GEOGRAFICA": "21187"
  },
  {
    "TITULO": "Tochimilco",
    "UBICACION_GEOGRAFICA": "21188"
  },
  {
    "TITULO": "Tochtepec",
    "UBICACION_GEOGRAFICA": "21189"
  },
  {
    "TITULO": "Totoltepec de Guerrero",
    "UBICACION_GEOGRAFICA": "21190"
  },
  {
    "TITULO": "Tulcingo",
    "UBICACION_GEOGRAFICA": "21191"
  },
  {
    "TITULO": "Tuzamapan de Galeana",
    "UBICACION_GEOGRAFICA": "21192"
  },
  {
    "TITULO": "Tzicatlacoyan",
    "UBICACION_GEOGRAFICA": "21193"
  },
  {
    "TITULO": "Venustiano Carranza",
    "UBICACION_GEOGRAFICA": "21194"
  },
  {
    "TITULO": "Vicente Guerrero",
    "UBICACION_GEOGRAFICA": "21195"
  },
  {
    "TITULO": "Xayacatlán de Bravo",
    "UBICACION_GEOGRAFICA": "21196"
  },
  {
    "TITULO": "Xicotepec",
    "UBICACION_GEOGRAFICA": "21197"
  },
  {
    "TITULO": "Xicotlán",
    "UBICACION_GEOGRAFICA": "21198"
  },
  {
    "TITULO": "Xiutetelco",
    "UBICACION_GEOGRAFICA": "21199"
  },
  {
    "TITULO": "Xochiapulco",
    "UBICACION_GEOGRAFICA": "21200"
  },
  {
    "TITULO": "Xochiltepec",
    "UBICACION_GEOGRAFICA": "21201"
  },
  {
    "TITULO": "Xochitlán de Vicente Suárez",
    "UBICACION_GEOGRAFICA": "21202"
  },
  {
    "TITULO": "Xochitlán Todos Santos",
    "UBICACION_GEOGRAFICA": "21203"
  },
  {
    "TITULO": "Yaonáhuac",
    "UBICACION_GEOGRAFICA": "21204"
  },
  {
    "TITULO": "Yehualtepec",
    "UBICACION_GEOGRAFICA": "21205"
  },
  {
    "TITULO": "Zacapala",
    "UBICACION_GEOGRAFICA": "21206"
  },
  {
    "TITULO": "Zacapoaxtla",
    "UBICACION_GEOGRAFICA": "21207"
  },
  {
    "TITULO": "Zacatlán",
    "UBICACION_GEOGRAFICA": "21208"
  },
  {
    "TITULO": "Zapotitlán",
    "UBICACION_GEOGRAFICA": "21209"
  },
  {
    "TITULO": "Zapotitlán de Méndez",
    "UBICACION_GEOGRAFICA": "21210"
  },
  {
    "TITULO": "Zaragoza",
    "UBICACION_GEOGRAFICA": "21211"
  },
  {
    "TITULO": "Zautla",
    "UBICACION_GEOGRAFICA": "21212"
  },
  {
    "TITULO": "Zihuateutla",
    "UBICACION_GEOGRAFICA": "21213"
  },
  {
    "TITULO": "Zinacatepec",
    "UBICACION_GEOGRAFICA": "21214"
  },
  {
    "TITULO": "Zongozotla",
    "UBICACION_GEOGRAFICA": "21215"
  },
  {
    "TITULO": "Zoquiapan",
    "UBICACION_GEOGRAFICA": "21216"
  },
  {
    "TITULO": "Zoquitlán",
    "UBICACION_GEOGRAFICA": "21217"
  },
  {
    "TITULO": "Querétaro",
    "UBICACION_GEOGRAFICA": "22"
  },
  {
    "TITULO": "Amealco de Bonfil",
    "UBICACION_GEOGRAFICA": "22001"
  },
  {
    "TITULO": "Pinal de Amoles",
    "UBICACION_GEOGRAFICA": "22002"
  },
  {
    "TITULO": "Arroyo Seco",
    "UBICACION_GEOGRAFICA": "22003"
  },
  {
    "TITULO": "Cadereyta de Montes",
    "UBICACION_GEOGRAFICA": "22004"
  },
  {
    "TITULO": "Colón",
    "UBICACION_GEOGRAFICA": "22005"
  },
  {
    "TITULO": "Corregidora",
    "UBICACION_GEOGRAFICA": "22006"
  },
  {
    "TITULO": "Ezequiel Montes",
    "UBICACION_GEOGRAFICA": "22007"
  },
  {
    "TITULO": "Huimilpan",
    "UBICACION_GEOGRAFICA": "22008"
  },
  {
    "TITULO": "Jalpan de Serra",
    "UBICACION_GEOGRAFICA": "22009"
  },
  {
    "TITULO": "Landa de Matamoros",
    "UBICACION_GEOGRAFICA": "22010"
  },
  {
    "TITULO": "El Marqués",
    "UBICACION_GEOGRAFICA": "22011"
  },
  {
    "TITULO": "Pedro Escobedo",
    "UBICACION_GEOGRAFICA": "22012"
  },
  {
    "TITULO": "Peñamiller",
    "UBICACION_GEOGRAFICA": "22013"
  },
  {
    "TITULO": "Querétaro, Querétaro",
    "UBICACION_GEOGRAFICA": "22014"
  },
  {
    "TITULO": "San Joaquín",
    "UBICACION_GEOGRAFICA": "22015"
  },
  {
    "TITULO": "San Juan del Río",
    "UBICACION_GEOGRAFICA": "22016"
  },
  {
    "TITULO": "Tequisquiapan",
    "UBICACION_GEOGRAFICA": "22017"
  },
  {
    "TITULO": "Tolimán",
    "UBICACION_GEOGRAFICA": "22018"
  },
  {
    "TITULO": "Quintana Roo",
    "UBICACION_GEOGRAFICA": "23"
  },
  {
    "TITULO": "Cozumel",
    "UBICACION_GEOGRAFICA": "23001"
  },
  {
    "TITULO": "Felipe Carrillo Puerto",
    "UBICACION_GEOGRAFICA": "23002"
  },
  {
    "TITULO": "Isla Mujeres",
    "UBICACION_GEOGRAFICA": "23003"
  },
  {
    "TITULO": "Othón P. Blanco",
    "UBICACION_GEOGRAFICA": "23004"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "23005"
  },
  {
    "TITULO": "José María Morelos",
    "UBICACION_GEOGRAFICA": "23006"
  },
  {
    "TITULO": "Lázaro Cárdenas",
    "UBICACION_GEOGRAFICA": "23007"
  },
  {
    "TITULO": "Solidaridad",
    "UBICACION_GEOGRAFICA": "23008"
  },
  {
    "TITULO": "Tulum",
    "UBICACION_GEOGRAFICA": "23009"
  },
  {
    "TITULO": "Bacalar",
    "UBICACION_GEOGRAFICA": "23010"
  },
  {
    "TITULO": "Puerto Morelos",
    "UBICACION_GEOGRAFICA": "23011"
  },
  {
    "TITULO": "San Luis Potosí",
    "UBICACION_GEOGRAFICA": "24"
  },
  {
    "TITULO": "Ahualulco",
    "UBICACION_GEOGRAFICA": "24001"
  },
  {
    "TITULO": "Alaquines",
    "UBICACION_GEOGRAFICA": "24002"
  },
  {
    "TITULO": "Aquismón",
    "UBICACION_GEOGRAFICA": "24003"
  },
  {
    "TITULO": "Armadillo de los Infante",
    "UBICACION_GEOGRAFICA": "24004"
  },
  {
    "TITULO": "Cárdenas",
    "UBICACION_GEOGRAFICA": "24005"
  },
  {
    "TITULO": "Catorce",
    "UBICACION_GEOGRAFICA": "24006"
  },
  {
    "TITULO": "Cedral",
    "UBICACION_GEOGRAFICA": "24007"
  },
  {
    "TITULO": "Cerritos",
    "UBICACION_GEOGRAFICA": "24008"
  },
  {
    "TITULO": "Cerro de San Pedro",
    "UBICACION_GEOGRAFICA": "24009"
  },
  {
    "TITULO": "Ciudad del Maíz",
    "UBICACION_GEOGRAFICA": "24010"
  },
  {
    "TITULO": "Ciudad Fernández",
    "UBICACION_GEOGRAFICA": "24011"
  },
  {
    "TITULO": "Tancanhuitz",
    "UBICACION_GEOGRAFICA": "24012"
  },
  {
    "TITULO": "Ciudad Valles",
    "UBICACION_GEOGRAFICA": "24013"
  },
  {
    "TITULO": "Coxcatlán",
    "UBICACION_GEOGRAFICA": "24014"
  },
  {
    "TITULO": "Charcas",
    "UBICACION_GEOGRAFICA": "24015"
  },
  {
    "TITULO": "Ebano",
    "UBICACION_GEOGRAFICA": "24016"
  },
  {
    "TITULO": "Guadalcázar",
    "UBICACION_GEOGRAFICA": "24017"
  },
  {
    "TITULO": "Huehuetlán",
    "UBICACION_GEOGRAFICA": "24018"
  },
  {
    "TITULO": "Lagunillas",
    "UBICACION_GEOGRAFICA": "24019"
  },
  {
    "TITULO": "Matehuala",
    "UBICACION_GEOGRAFICA": "24020"
  },
  {
    "TITULO": "Mexquitic de Carmona",
    "UBICACION_GEOGRAFICA": "24021"
  },
  {
    "TITULO": "Moctezuma",
    "UBICACION_GEOGRAFICA": "24022"
  },
  {
    "TITULO": "Rayón",
    "UBICACION_GEOGRAFICA": "24023"
  },
  {
    "TITULO": "Rioverde",
    "UBICACION_GEOGRAFICA": "24024"
  },
  {
    "TITULO": "Salinas",
    "UBICACION_GEOGRAFICA": "24025"
  },
  {
    "TITULO": "San Antonio",
    "UBICACION_GEOGRAFICA": "24026"
  },
  {
    "TITULO": "San Ciro de Acosta",
    "UBICACION_GEOGRAFICA": "24027"
  },
  {
    "TITULO": "San Luis Potosí, San Luis Potosí",
    "UBICACION_GEOGRAFICA": "24028"
  },
  {
    "TITULO": "San Martín Chalchicuautla",
    "UBICACION_GEOGRAFICA": "24029"
  },
  {
    "TITULO": "San Nicolás Tolentino",
    "UBICACION_GEOGRAFICA": "24030"
  },
  {
    "TITULO": "Santa Catarina",
    "UBICACION_GEOGRAFICA": "24031"
  },
  {
    "TITULO": "Santa María del Río",
    "UBICACION_GEOGRAFICA": "24032"
  },
  {
    "TITULO": "Santo Domingo",
    "UBICACION_GEOGRAFICA": "24033"
  },
  {
    "TITULO": "San Vicente Tancuayalab",
    "UBICACION_GEOGRAFICA": "24034"
  },
  {
    "TITULO": "Soledad de Graciano Sánchez",
    "UBICACION_GEOGRAFICA": "24035"
  },
  {
    "TITULO": "Tamasopo",
    "UBICACION_GEOGRAFICA": "24036"
  },
  {
    "TITULO": "Tamazunchale",
    "UBICACION_GEOGRAFICA": "24037"
  },
  {
    "TITULO": "Tampacán",
    "UBICACION_GEOGRAFICA": "24038"
  },
  {
    "TITULO": "Tampamolón Corona",
    "UBICACION_GEOGRAFICA": "24039"
  },
  {
    "TITULO": "Tamuín",
    "UBICACION_GEOGRAFICA": "24040"
  },
  {
    "TITULO": "Tanlajás",
    "UBICACION_GEOGRAFICA": "24041"
  },
  {
    "TITULO": "Tanquián de Escobedo",
    "UBICACION_GEOGRAFICA": "24042"
  },
  {
    "TITULO": "Tierra Nueva",
    "UBICACION_GEOGRAFICA": "24043"
  },
  {
    "TITULO": "Vanegas",
    "UBICACION_GEOGRAFICA": "24044"
  },
  {
    "TITULO": "Venado",
    "UBICACION_GEOGRAFICA": "24045"
  },
  {
    "TITULO": "Villa de Arriaga",
    "UBICACION_GEOGRAFICA": "24046"
  },
  {
    "TITULO": "Villa de Guadalupe",
    "UBICACION_GEOGRAFICA": "24047"
  },
  {
    "TITULO": "Villa de la Paz",
    "UBICACION_GEOGRAFICA": "24048"
  },
  {
    "TITULO": "Villa de Ramos",
    "UBICACION_GEOGRAFICA": "24049"
  },
  {
    "TITULO": "Villa de Reyes",
    "UBICACION_GEOGRAFICA": "24050"
  },
  {
    "TITULO": "Villa Hidalgo",
    "UBICACION_GEOGRAFICA": "24051"
  },
  {
    "TITULO": "Villa Juárez",
    "UBICACION_GEOGRAFICA": "24052"
  },
  {
    "TITULO": "Axtla de Terrazas",
    "UBICACION_GEOGRAFICA": "24053"
  },
  {
    "TITULO": "Xilitla",
    "UBICACION_GEOGRAFICA": "24054"
  },
  {
    "TITULO": "Zaragoza",
    "UBICACION_GEOGRAFICA": "24055"
  },
  {
    "TITULO": "Villa de Arista",
    "UBICACION_GEOGRAFICA": "24056"
  },
  {
    "TITULO": "Matlapa",
    "UBICACION_GEOGRAFICA": "24057"
  },
  {
    "TITULO": "El Naranjo",
    "UBICACION_GEOGRAFICA": "24058"
  },
  {
    "TITULO": "Sinaloa",
    "UBICACION_GEOGRAFICA": "25"
  },
  {
    "TITULO": "Ahome",
    "UBICACION_GEOGRAFICA": "25001"
  },
  {
    "TITULO": "Angostura",
    "UBICACION_GEOGRAFICA": "25002"
  },
  {
    "TITULO": "Badiraguato",
    "UBICACION_GEOGRAFICA": "25003"
  },
  {
    "TITULO": "Concordia",
    "UBICACION_GEOGRAFICA": "25004"
  },
  {
    "TITULO": "Cosalá",
    "UBICACION_GEOGRAFICA": "25005"
  },
  {
    "TITULO": "Culiacán",
    "UBICACION_GEOGRAFICA": "25006"
  },
  {
    "TITULO": "Choix",
    "UBICACION_GEOGRAFICA": "25007"
  },
  {
    "TITULO": "Elota",
    "UBICACION_GEOGRAFICA": "25008"
  },
  {
    "TITULO": "Escuinapa",
    "UBICACION_GEOGRAFICA": "25009"
  },
  {
    "TITULO": "El Fuerte",
    "UBICACION_GEOGRAFICA": "25010"
  },
  {
    "TITULO": "Guasave",
    "UBICACION_GEOGRAFICA": "25011"
  },
  {
    "TITULO": "Mazatlán",
    "UBICACION_GEOGRAFICA": "25012"
  },
  {
    "TITULO": "Mocorito",
    "UBICACION_GEOGRAFICA": "25013"
  },
  {
    "TITULO": "Rosario",
    "UBICACION_GEOGRAFICA": "25014"
  },
  {
    "TITULO": "Salvador Alvarado",
    "UBICACION_GEOGRAFICA": "25015"
  },
  {
    "TITULO": "San Ignacio",
    "UBICACION_GEOGRAFICA": "25016"
  },
  {
    "TITULO": "Sinaloa, Sinaloa ",
    "UBICACION_GEOGRAFICA": "25017"
  },
  {
    "TITULO": "Navolato",
    "UBICACION_GEOGRAFICA": "25018"
  },
  {
    "TITULO": "Sonora",
    "UBICACION_GEOGRAFICA": "26"
  },
  {
    "TITULO": "Aconchi",
    "UBICACION_GEOGRAFICA": "26001"
  },
  {
    "TITULO": "Agua Prieta",
    "UBICACION_GEOGRAFICA": "26002"
  },
  {
    "TITULO": "Alamos",
    "UBICACION_GEOGRAFICA": "26003"
  },
  {
    "TITULO": "Altar",
    "UBICACION_GEOGRAFICA": "26004"
  },
  {
    "TITULO": "Arivechi",
    "UBICACION_GEOGRAFICA": "26005"
  },
  {
    "TITULO": "Arizpe",
    "UBICACION_GEOGRAFICA": "26006"
  },
  {
    "TITULO": "Atil",
    "UBICACION_GEOGRAFICA": "26007"
  },
  {
    "TITULO": "Bacadéhuachi",
    "UBICACION_GEOGRAFICA": "26008"
  },
  {
    "TITULO": "Bacanora",
    "UBICACION_GEOGRAFICA": "26009"
  },
  {
    "TITULO": "Bacerac",
    "UBICACION_GEOGRAFICA": "26010"
  },
  {
    "TITULO": "Bacoachi",
    "UBICACION_GEOGRAFICA": "26011"
  },
  {
    "TITULO": "Bácum",
    "UBICACION_GEOGRAFICA": "26012"
  },
  {
    "TITULO": "Banámichi",
    "UBICACION_GEOGRAFICA": "26013"
  },
  {
    "TITULO": "Baviácora",
    "UBICACION_GEOGRAFICA": "26014"
  },
  {
    "TITULO": "Bavispe",
    "UBICACION_GEOGRAFICA": "26015"
  },
  {
    "TITULO": "Benjamín Hill",
    "UBICACION_GEOGRAFICA": "26016"
  },
  {
    "TITULO": "Caborca",
    "UBICACION_GEOGRAFICA": "26017"
  },
  {
    "TITULO": "Cajeme",
    "UBICACION_GEOGRAFICA": "26018"
  },
  {
    "TITULO": "Cananea",
    "UBICACION_GEOGRAFICA": "26019"
  },
  {
    "TITULO": "Carbó",
    "UBICACION_GEOGRAFICA": "26020"
  },
  {
    "TITULO": "La Colorada",
    "UBICACION_GEOGRAFICA": "26021"
  },
  {
    "TITULO": "Cucurpe",
    "UBICACION_GEOGRAFICA": "26022"
  },
  {
    "TITULO": "Cumpas",
    "UBICACION_GEOGRAFICA": "26023"
  },
  {
    "TITULO": "Divisaderos",
    "UBICACION_GEOGRAFICA": "26024"
  },
  {
    "TITULO": "Empalme",
    "UBICACION_GEOGRAFICA": "26025"
  },
  {
    "TITULO": "Etchojoa",
    "UBICACION_GEOGRAFICA": "26026"
  },
  {
    "TITULO": "Fronteras",
    "UBICACION_GEOGRAFICA": "26027"
  },
  {
    "TITULO": "Granados",
    "UBICACION_GEOGRAFICA": "26028"
  },
  {
    "TITULO": "Guaymas",
    "UBICACION_GEOGRAFICA": "26029"
  },
  {
    "TITULO": "Hermosillo",
    "UBICACION_GEOGRAFICA": "26030"
  },
  {
    "TITULO": "Huachinera",
    "UBICACION_GEOGRAFICA": "26031"
  },
  {
    "TITULO": "Huásabas",
    "UBICACION_GEOGRAFICA": "26032"
  },
  {
    "TITULO": "Huatabampo",
    "UBICACION_GEOGRAFICA": "26033"
  },
  {
    "TITULO": "Huépac",
    "UBICACION_GEOGRAFICA": "26034"
  },
  {
    "TITULO": "Imuris",
    "UBICACION_GEOGRAFICA": "26035"
  },
  {
    "TITULO": "Magdalena",
    "UBICACION_GEOGRAFICA": "26036"
  },
  {
    "TITULO": "Mazatán",
    "UBICACION_GEOGRAFICA": "26037"
  },
  {
    "TITULO": "Moctezuma",
    "UBICACION_GEOGRAFICA": "26038"
  },
  {
    "TITULO": "Naco",
    "UBICACION_GEOGRAFICA": "26039"
  },
  {
    "TITULO": "Nácori Chico",
    "UBICACION_GEOGRAFICA": "26040"
  },
  {
    "TITULO": "Nacozari de García",
    "UBICACION_GEOGRAFICA": "26041"
  },
  {
    "TITULO": "Navojoa",
    "UBICACION_GEOGRAFICA": "26042"
  },
  {
    "TITULO": "Nogales",
    "UBICACION_GEOGRAFICA": "26043"
  },
  {
    "TITULO": "Onavas",
    "UBICACION_GEOGRAFICA": "26044"
  },
  {
    "TITULO": "Opodepe",
    "UBICACION_GEOGRAFICA": "26045"
  },
  {
    "TITULO": "Oquitoa",
    "UBICACION_GEOGRAFICA": "26046"
  },
  {
    "TITULO": "Pitiquito",
    "UBICACION_GEOGRAFICA": "26047"
  },
  {
    "TITULO": "Puerto Peñasco",
    "UBICACION_GEOGRAFICA": "26048"
  },
  {
    "TITULO": "Quiriego",
    "UBICACION_GEOGRAFICA": "26049"
  },
  {
    "TITULO": "Rayón",
    "UBICACION_GEOGRAFICA": "26050"
  },
  {
    "TITULO": "Rosario",
    "UBICACION_GEOGRAFICA": "26051"
  },
  {
    "TITULO": "Sahuaripa",
    "UBICACION_GEOGRAFICA": "26052"
  },
  {
    "TITULO": "San Felipe de Jesús",
    "UBICACION_GEOGRAFICA": "26053"
  },
  {
    "TITULO": "San Javier",
    "UBICACION_GEOGRAFICA": "26054"
  },
  {
    "TITULO": "San Luis Río Colorado",
    "UBICACION_GEOGRAFICA": "26055"
  },
  {
    "TITULO": "San Miguel de Horcasitas",
    "UBICACION_GEOGRAFICA": "26056"
  },
  {
    "TITULO": "San Pedro de la Cueva",
    "UBICACION_GEOGRAFICA": "26057"
  },
  {
    "TITULO": "Santa Ana",
    "UBICACION_GEOGRAFICA": "26058"
  },
  {
    "TITULO": "Santa Cruz",
    "UBICACION_GEOGRAFICA": "26059"
  },
  {
    "TITULO": "Sáric",
    "UBICACION_GEOGRAFICA": "26060"
  },
  {
    "TITULO": "Soyopa",
    "UBICACION_GEOGRAFICA": "26061"
  },
  {
    "TITULO": "Suaqui Grande",
    "UBICACION_GEOGRAFICA": "26062"
  },
  {
    "TITULO": "Tepache",
    "UBICACION_GEOGRAFICA": "26063"
  },
  {
    "TITULO": "Trincheras",
    "UBICACION_GEOGRAFICA": "26064"
  },
  {
    "TITULO": "Tubutama",
    "UBICACION_GEOGRAFICA": "26065"
  },
  {
    "TITULO": "Ures",
    "UBICACION_GEOGRAFICA": "26066"
  },
  {
    "TITULO": "Villa Hidalgo",
    "UBICACION_GEOGRAFICA": "26067"
  },
  {
    "TITULO": "Villa Pesqueira",
    "UBICACION_GEOGRAFICA": "26068"
  },
  {
    "TITULO": "Yécora",
    "UBICACION_GEOGRAFICA": "26069"
  },
  {
    "TITULO": "General Plutarco Elías Calles",
    "UBICACION_GEOGRAFICA": "26070"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "26071"
  },
  {
    "TITULO": "San Ignacio Río Muerto",
    "UBICACION_GEOGRAFICA": "26072"
  },
  {
    "TITULO": "Tabasco",
    "UBICACION_GEOGRAFICA": "27"
  },
  {
    "TITULO": "Balancán",
    "UBICACION_GEOGRAFICA": "27001"
  },
  {
    "TITULO": "Cárdenas",
    "UBICACION_GEOGRAFICA": "27002"
  },
  {
    "TITULO": "Centla",
    "UBICACION_GEOGRAFICA": "27003"
  },
  {
    "TITULO": "Centro",
    "UBICACION_GEOGRAFICA": "27004"
  },
  {
    "TITULO": "Comalcalco",
    "UBICACION_GEOGRAFICA": "27005"
  },
  {
    "TITULO": "Cunduacán",
    "UBICACION_GEOGRAFICA": "27006"
  },
  {
    "TITULO": "Emiliano Zapata",
    "UBICACION_GEOGRAFICA": "27007"
  },
  {
    "TITULO": "Huimanguillo",
    "UBICACION_GEOGRAFICA": "27008"
  },
  {
    "TITULO": "Jalapa",
    "UBICACION_GEOGRAFICA": "27009"
  },
  {
    "TITULO": "Jalpa de Méndez",
    "UBICACION_GEOGRAFICA": "27010"
  },
  {
    "TITULO": "Jonuta",
    "UBICACION_GEOGRAFICA": "27011"
  },
  {
    "TITULO": "Macuspana",
    "UBICACION_GEOGRAFICA": "27012"
  },
  {
    "TITULO": "Nacajuca",
    "UBICACION_GEOGRAFICA": "27013"
  },
  {
    "TITULO": "Paraíso",
    "UBICACION_GEOGRAFICA": "27014"
  },
  {
    "TITULO": "Tacotalpa",
    "UBICACION_GEOGRAFICA": "27015"
  },
  {
    "TITULO": "Teapa",
    "UBICACION_GEOGRAFICA": "27016"
  },
  {
    "TITULO": "Tenosique",
    "UBICACION_GEOGRAFICA": "27017"
  },
  {
    "TITULO": "Tamaulipas",
    "UBICACION_GEOGRAFICA": "28"
  },
  {
    "TITULO": "Abasolo",
    "UBICACION_GEOGRAFICA": "28001"
  },
  {
    "TITULO": "Aldama",
    "UBICACION_GEOGRAFICA": "28002"
  },
  {
    "TITULO": "Altamira",
    "UBICACION_GEOGRAFICA": "28003"
  },
  {
    "TITULO": "Antiguo Morelos",
    "UBICACION_GEOGRAFICA": "28004"
  },
  {
    "TITULO": "Burgos",
    "UBICACION_GEOGRAFICA": "28005"
  },
  {
    "TITULO": "Bustamante",
    "UBICACION_GEOGRAFICA": "28006"
  },
  {
    "TITULO": "Camargo",
    "UBICACION_GEOGRAFICA": "28007"
  },
  {
    "TITULO": "Casas, Tamaulipas",
    "UBICACION_GEOGRAFICA": "28008"
  },
  {
    "TITULO": "Ciudad Madero",
    "UBICACION_GEOGRAFICA": "28009"
  },
  {
    "TITULO": "Cruillas",
    "UBICACION_GEOGRAFICA": "28010"
  },
  {
    "TITULO": "Gómez Farías",
    "UBICACION_GEOGRAFICA": "28011"
  },
  {
    "TITULO": "González",
    "UBICACION_GEOGRAFICA": "28012"
  },
  {
    "TITULO": "Güémez",
    "UBICACION_GEOGRAFICA": "28013"
  },
  {
    "TITULO": "Guerrero",
    "UBICACION_GEOGRAFICA": "28014"
  },
  {
    "TITULO": "Gustavo Díaz Ordaz",
    "UBICACION_GEOGRAFICA": "28015"
  },
  {
    "TITULO": "Hidalgo, Tamaulipas",
    "UBICACION_GEOGRAFICA": "28016"
  },
  {
    "TITULO": "Jaumave",
    "UBICACION_GEOGRAFICA": "28017"
  },
  {
    "TITULO": "Jiménez",
    "UBICACION_GEOGRAFICA": "28018"
  },
  {
    "TITULO": "Llera",
    "UBICACION_GEOGRAFICA": "28019"
  },
  {
    "TITULO": "Mainero",
    "UBICACION_GEOGRAFICA": "28020"
  },
  {
    "TITULO": "El Mante",
    "UBICACION_GEOGRAFICA": "28021"
  },
  {
    "TITULO": "Matamoros",
    "UBICACION_GEOGRAFICA": "28022"
  },
  {
    "TITULO": "Méndez",
    "UBICACION_GEOGRAFICA": "28023"
  },
  {
    "TITULO": "Mier",
    "UBICACION_GEOGRAFICA": "28024"
  },
  {
    "TITULO": "Miguel Alemán",
    "UBICACION_GEOGRAFICA": "28025"
  },
  {
    "TITULO": "Miquihuana",
    "UBICACION_GEOGRAFICA": "28026"
  },
  {
    "TITULO": "Nuevo Laredo",
    "UBICACION_GEOGRAFICA": "28027"
  },
  {
    "TITULO": "Nuevo Morelos",
    "UBICACION_GEOGRAFICA": "28028"
  },
  {
    "TITULO": "Ocampo",
    "UBICACION_GEOGRAFICA": "28029"
  },
  {
    "TITULO": "Padilla",
    "UBICACION_GEOGRAFICA": "28030"
  },
  {
    "TITULO": "Palmillas",
    "UBICACION_GEOGRAFICA": "28031"
  },
  {
    "TITULO": "Reynosa",
    "UBICACION_GEOGRAFICA": "28032"
  },
  {
    "TITULO": "Río Bravo",
    "UBICACION_GEOGRAFICA": "28033"
  },
  {
    "TITULO": "San Carlos",
    "UBICACION_GEOGRAFICA": "28034"
  },
  {
    "TITULO": "San Fernando",
    "UBICACION_GEOGRAFICA": "28035"
  },
  {
    "TITULO": "San Nicolás",
    "UBICACION_GEOGRAFICA": "28036"
  },
  {
    "TITULO": "Soto la Marina",
    "UBICACION_GEOGRAFICA": "28037"
  },
  {
    "TITULO": "Tampico",
    "UBICACION_GEOGRAFICA": "28038"
  },
  {
    "TITULO": "Tula",
    "UBICACION_GEOGRAFICA": "28039"
  },
  {
    "TITULO": "Valle Hermoso",
    "UBICACION_GEOGRAFICA": "28040"
  },
  {
    "TITULO": "Victoria",
    "UBICACION_GEOGRAFICA": "28041"
  },
  {
    "TITULO": "Villagrán",
    "UBICACION_GEOGRAFICA": "28042"
  },
  {
    "TITULO": "Xicoténcatl",
    "UBICACION_GEOGRAFICA": "28043"
  },
  {
    "TITULO": "Tlaxcala",
    "UBICACION_GEOGRAFICA": "29"
  },
  {
    "TITULO": "Amaxac de Guerrero",
    "UBICACION_GEOGRAFICA": "29001"
  },
  {
    "TITULO": "Apetatitlán de Antonio Carvajal",
    "UBICACION_GEOGRAFICA": "29002"
  },
  {
    "TITULO": "Atlangatepec",
    "UBICACION_GEOGRAFICA": "29003"
  },
  {
    "TITULO": "Atltzayanca",
    "UBICACION_GEOGRAFICA": "29004"
  },
  {
    "TITULO": "Apizaco",
    "UBICACION_GEOGRAFICA": "29005"
  },
  {
    "TITULO": "Calpulalpan",
    "UBICACION_GEOGRAFICA": "29006"
  },
  {
    "TITULO": "El Carmen Tequexquitla",
    "UBICACION_GEOGRAFICA": "29007"
  },
  {
    "TITULO": "Cuapiaxtla",
    "UBICACION_GEOGRAFICA": "29008"
  },
  {
    "TITULO": "Cuaxomulco",
    "UBICACION_GEOGRAFICA": "29009"
  },
  {
    "TITULO": "Chiautempan",
    "UBICACION_GEOGRAFICA": "29010"
  },
  {
    "TITULO": "Muñoz de Domingo Arenas",
    "UBICACION_GEOGRAFICA": "29011"
  },
  {
    "TITULO": "Españita",
    "UBICACION_GEOGRAFICA": "29012"
  },
  {
    "TITULO": "Huamantla",
    "UBICACION_GEOGRAFICA": "29013"
  },
  {
    "TITULO": "Hueyotlipan",
    "UBICACION_GEOGRAFICA": "29014"
  },
  {
    "TITULO": "Ixtacuixtla de Mariano Matamoros",
    "UBICACION_GEOGRAFICA": "29015"
  },
  {
    "TITULO": "Ixtenco",
    "UBICACION_GEOGRAFICA": "29016"
  },
  {
    "TITULO": "Mazatecochco de José María Morelos",
    "UBICACION_GEOGRAFICA": "29017"
  },
  {
    "TITULO": "Contla de Juan Cuamatzi",
    "UBICACION_GEOGRAFICA": "29018"
  },
  {
    "TITULO": "Tepetitla de Lardizábal",
    "UBICACION_GEOGRAFICA": "29019"
  },
  {
    "TITULO": "Sanctórum de Lázaro Cárdenas",
    "UBICACION_GEOGRAFICA": "29020"
  },
  {
    "TITULO": "Nanacamilpa de Mariano Arista",
    "UBICACION_GEOGRAFICA": "29021"
  },
  {
    "TITULO": "Acuamanala de Miguel Hidalgo",
    "UBICACION_GEOGRAFICA": "29022"
  },
  {
    "TITULO": "Natívitas",
    "UBICACION_GEOGRAFICA": "29023"
  },
  {
    "TITULO": "Panotla",
    "UBICACION_GEOGRAFICA": "29024"
  },
  {
    "TITULO": "San Pablo del Monte",
    "UBICACION_GEOGRAFICA": "29025"
  },
  {
    "TITULO": "Santa Cruz Tlaxcala",
    "UBICACION_GEOGRAFICA": "29026"
  },
  {
    "TITULO": "Tenancingo",
    "UBICACION_GEOGRAFICA": "29027"
  },
  {
    "TITULO": "Teolocholco",
    "UBICACION_GEOGRAFICA": "29028"
  },
  {
    "TITULO": "Tepeyanco",
    "UBICACION_GEOGRAFICA": "29029"
  },
  {
    "TITULO": "Terrenate",
    "UBICACION_GEOGRAFICA": "29030"
  },
  {
    "TITULO": "Tetla de la Solidaridad",
    "UBICACION_GEOGRAFICA": "29031"
  },
  {
    "TITULO": "Tetlatlahuca",
    "UBICACION_GEOGRAFICA": "29032"
  },
  {
    "TITULO": "Tlaxcala, Tlaxcala",
    "UBICACION_GEOGRAFICA": "29033"
  },
  {
    "TITULO": "Tlaxco",
    "UBICACION_GEOGRAFICA": "29034"
  },
  {
    "TITULO": "Tocatlán",
    "UBICACION_GEOGRAFICA": "29035"
  },
  {
    "TITULO": "Totolac",
    "UBICACION_GEOGRAFICA": "29036"
  },
  {
    "TITULO": "Ziltlaltépec de Trinidad Sánchez Santos",
    "UBICACION_GEOGRAFICA": "29037"
  },
  {
    "TITULO": "Tzompantepec",
    "UBICACION_GEOGRAFICA": "29038"
  },
  {
    "TITULO": "Xaloztoc",
    "UBICACION_GEOGRAFICA": "29039"
  },
  {
    "TITULO": "Xaltocan",
    "UBICACION_GEOGRAFICA": "29040"
  },
  {
    "TITULO": "Papalotla de Xicohténcatl",
    "UBICACION_GEOGRAFICA": "29041"
  },
  {
    "TITULO": "Xicohtzinco",
    "UBICACION_GEOGRAFICA": "29042"
  },
  {
    "TITULO": "Yauhquemehcan",
    "UBICACION_GEOGRAFICA": "29043"
  },
  {
    "TITULO": "Zacatelco",
    "UBICACION_GEOGRAFICA": "29044"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "29045"
  },
  {
    "TITULO": "Emiliano Zapata",
    "UBICACION_GEOGRAFICA": "29046"
  },
  {
    "TITULO": "Lázaro Cárdenas",
    "UBICACION_GEOGRAFICA": "29047"
  },
  {
    "TITULO": "La Magdalena Tlaltelulco",
    "UBICACION_GEOGRAFICA": "29048"
  },
  {
    "TITULO": "San Damián Texóloc",
    "UBICACION_GEOGRAFICA": "29049"
  },
  {
    "TITULO": "San Francisco Tetlanohcan",
    "UBICACION_GEOGRAFICA": "29050"
  },
  {
    "TITULO": "San Jerónimo Zacualpan",
    "UBICACION_GEOGRAFICA": "29051"
  },
  {
    "TITULO": "San José Teacalco",
    "UBICACION_GEOGRAFICA": "29052"
  },
  {
    "TITULO": "San Juan Huactzinco",
    "UBICACION_GEOGRAFICA": "29053"
  },
  {
    "TITULO": "San Lorenzo Axocomanitla",
    "UBICACION_GEOGRAFICA": "29054"
  },
  {
    "TITULO": "San Lucas Tecopilco",
    "UBICACION_GEOGRAFICA": "29055"
  },
  {
    "TITULO": "Santa Ana Nopalucan",
    "UBICACION_GEOGRAFICA": "29056"
  },
  {
    "TITULO": "Santa Apolonia Teacalco",
    "UBICACION_GEOGRAFICA": "29057"
  },
  {
    "TITULO": "Santa Catarina Ayometla",
    "UBICACION_GEOGRAFICA": "29058"
  },
  {
    "TITULO": "Santa Cruz Quilehtla",
    "UBICACION_GEOGRAFICA": "29059"
  },
  {
    "TITULO": "Santa Isabel Xiloxoxtla",
    "UBICACION_GEOGRAFICA": "29060"
  },
  {
    "TITULO": "Veracruz de Ignacio de la Llave",
    "UBICACION_GEOGRAFICA": "30"
  },
  {
    "TITULO": "Veracruz",
    "UBICACION_GEOGRAFICA": "30"
  },
  {
    "TITULO": "Acajete",
    "UBICACION_GEOGRAFICA": "30001"
  },
  {
    "TITULO": "Acatlán",
    "UBICACION_GEOGRAFICA": "30002"
  },
  {
    "TITULO": "Acayucan",
    "UBICACION_GEOGRAFICA": "30003"
  },
  {
    "TITULO": "Actopan",
    "UBICACION_GEOGRAFICA": "30004"
  },
  {
    "TITULO": "Acula",
    "UBICACION_GEOGRAFICA": "30005"
  },
  {
    "TITULO": "Acultzingo",
    "UBICACION_GEOGRAFICA": "30006"
  },
  {
    "TITULO": "Camarón de Tejeda",
    "UBICACION_GEOGRAFICA": "30007"
  },
  {
    "TITULO": "Alpatláhuac",
    "UBICACION_GEOGRAFICA": "30008"
  },
  {
    "TITULO": "Alto Lucero de Gutiérrez Barrios",
    "UBICACION_GEOGRAFICA": "30009"
  },
  {
    "TITULO": "Altotonga",
    "UBICACION_GEOGRAFICA": "30010"
  },
  {
    "TITULO": "Alvarado",
    "UBICACION_GEOGRAFICA": "30011"
  },
  {
    "TITULO": "Amatitlán",
    "UBICACION_GEOGRAFICA": "30012"
  },
  {
    "TITULO": "Naranjos Amatlán",
    "UBICACION_GEOGRAFICA": "30013"
  },
  {
    "TITULO": "Amatlán de los Reyes",
    "UBICACION_GEOGRAFICA": "30014"
  },
  {
    "TITULO": "Angel R. Cabada",
    "UBICACION_GEOGRAFICA": "30015"
  },
  {
    "TITULO": "La Antigua",
    "UBICACION_GEOGRAFICA": "30016"
  },
  {
    "TITULO": "Apazapan",
    "UBICACION_GEOGRAFICA": "30017"
  },
  {
    "TITULO": "Aquila",
    "UBICACION_GEOGRAFICA": "30018"
  },
  {
    "TITULO": "Astacinga",
    "UBICACION_GEOGRAFICA": "30019"
  },
  {
    "TITULO": "Atlahuilco",
    "UBICACION_GEOGRAFICA": "30020"
  },
  {
    "TITULO": "Atoyac",
    "UBICACION_GEOGRAFICA": "30021"
  },
  {
    "TITULO": "Atzacan",
    "UBICACION_GEOGRAFICA": "30022"
  },
  {
    "TITULO": "Atzalan",
    "UBICACION_GEOGRAFICA": "30023"
  },
  {
    "TITULO": "Tlaltetela",
    "UBICACION_GEOGRAFICA": "30024"
  },
  {
    "TITULO": "Ayahualulco",
    "UBICACION_GEOGRAFICA": "30025"
  },
  {
    "TITULO": "Banderilla",
    "UBICACION_GEOGRAFICA": "30026"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "30027"
  },
  {
    "TITULO": "Boca del Río",
    "UBICACION_GEOGRAFICA": "30028"
  },
  {
    "TITULO": "Calcahualco",
    "UBICACION_GEOGRAFICA": "30029"
  },
  {
    "TITULO": "Camerino Z. Mendoza",
    "UBICACION_GEOGRAFICA": "30030"
  },
  {
    "TITULO": "Carrillo Puerto",
    "UBICACION_GEOGRAFICA": "30031"
  },
  {
    "TITULO": "Catemaco",
    "UBICACION_GEOGRAFICA": "30032"
  },
  {
    "TITULO": "Cazones de Herrera",
    "UBICACION_GEOGRAFICA": "30033"
  },
  {
    "TITULO": "Cerro Azul",
    "UBICACION_GEOGRAFICA": "30034"
  },
  {
    "TITULO": "Citlaltépetl",
    "UBICACION_GEOGRAFICA": "30035"
  },
  {
    "TITULO": "Coacoatzintla",
    "UBICACION_GEOGRAFICA": "30036"
  },
  {
    "TITULO": "Coahuitlán",
    "UBICACION_GEOGRAFICA": "30037"
  },
  {
    "TITULO": "Coatepec",
    "UBICACION_GEOGRAFICA": "30038"
  },
  {
    "TITULO": "Coatzacoalcos",
    "UBICACION_GEOGRAFICA": "30039"
  },
  {
    "TITULO": "Coatzintla",
    "UBICACION_GEOGRAFICA": "30040"
  },
  {
    "TITULO": "Coetzala",
    "UBICACION_GEOGRAFICA": "30041"
  },
  {
    "TITULO": "Colipa",
    "UBICACION_GEOGRAFICA": "30042"
  },
  {
    "TITULO": "Comapa",
    "UBICACION_GEOGRAFICA": "30043"
  },
  {
    "TITULO": "Córdoba",
    "UBICACION_GEOGRAFICA": "30044"
  },
  {
    "TITULO": "Cosamaloapan de Carpio",
    "UBICACION_GEOGRAFICA": "30045"
  },
  {
    "TITULO": "Cosautlán de Carvajal",
    "UBICACION_GEOGRAFICA": "30046"
  },
  {
    "TITULO": "Coscomatepec",
    "UBICACION_GEOGRAFICA": "30047"
  },
  {
    "TITULO": "Cosoleacaque",
    "UBICACION_GEOGRAFICA": "30048"
  },
  {
    "TITULO": "Cotaxtla",
    "UBICACION_GEOGRAFICA": "30049"
  },
  {
    "TITULO": "Coxquihui",
    "UBICACION_GEOGRAFICA": "30050"
  },
  {
    "TITULO": "Coyutla",
    "UBICACION_GEOGRAFICA": "30051"
  },
  {
    "TITULO": "Cuichapa",
    "UBICACION_GEOGRAFICA": "30052"
  },
  {
    "TITULO": "Cuitláhuac",
    "UBICACION_GEOGRAFICA": "30053"
  },
  {
    "TITULO": "Chacaltianguis",
    "UBICACION_GEOGRAFICA": "30054"
  },
  {
    "TITULO": "Chalma",
    "UBICACION_GEOGRAFICA": "30055"
  },
  {
    "TITULO": "Chiconamel",
    "UBICACION_GEOGRAFICA": "30056"
  },
  {
    "TITULO": "Chiconquiaco",
    "UBICACION_GEOGRAFICA": "30057"
  },
  {
    "TITULO": "Chicontepec",
    "UBICACION_GEOGRAFICA": "30058"
  },
  {
    "TITULO": "Chinameca",
    "UBICACION_GEOGRAFICA": "30059"
  },
  {
    "TITULO": "Chinampa de Gorostiza",
    "UBICACION_GEOGRAFICA": "30060"
  },
  {
    "TITULO": "Las Choapas",
    "UBICACION_GEOGRAFICA": "30061"
  },
  {
    "TITULO": "Chocamán",
    "UBICACION_GEOGRAFICA": "30062"
  },
  {
    "TITULO": "Chontla",
    "UBICACION_GEOGRAFICA": "30063"
  },
  {
    "TITULO": "Chumatlán",
    "UBICACION_GEOGRAFICA": "30064"
  },
  {
    "TITULO": "Emiliano Zapata",
    "UBICACION_GEOGRAFICA": "30065"
  },
  {
    "TITULO": "Espinal",
    "UBICACION_GEOGRAFICA": "30066"
  },
  {
    "TITULO": "Filomeno Mata",
    "UBICACION_GEOGRAFICA": "30067"
  },
  {
    "TITULO": "Fortín",
    "UBICACION_GEOGRAFICA": "30068"
  },
  {
    "TITULO": "Gutiérrez Zamora",
    "UBICACION_GEOGRAFICA": "30069"
  },
  {
    "TITULO": "Hidalgotitlán",
    "UBICACION_GEOGRAFICA": "30070"
  },
  {
    "TITULO": "Huatusco",
    "UBICACION_GEOGRAFICA": "30071"
  },
  {
    "TITULO": "Huayacocotla",
    "UBICACION_GEOGRAFICA": "30072"
  },
  {
    "TITULO": "Hueyapan de Ocampo",
    "UBICACION_GEOGRAFICA": "30073"
  },
  {
    "TITULO": "Huiloapan de Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "30074"
  },
  {
    "TITULO": "Ignacio de la Llave",
    "UBICACION_GEOGRAFICA": "30075"
  },
  {
    "TITULO": "Ilamatlán",
    "UBICACION_GEOGRAFICA": "30076"
  },
  {
    "TITULO": "Isla",
    "UBICACION_GEOGRAFICA": "30077"
  },
  {
    "TITULO": "Ixcatepec",
    "UBICACION_GEOGRAFICA": "30078"
  },
  {
    "TITULO": "Ixhuacán de los Reyes",
    "UBICACION_GEOGRAFICA": "30079"
  },
  {
    "TITULO": "Ixhuatlán del Café",
    "UBICACION_GEOGRAFICA": "30080"
  },
  {
    "TITULO": "Ixhuatlancillo",
    "UBICACION_GEOGRAFICA": "30081"
  },
  {
    "TITULO": "Ixhuatlán del Sureste",
    "UBICACION_GEOGRAFICA": "30082"
  },
  {
    "TITULO": "Ixhuatlán de Madero",
    "UBICACION_GEOGRAFICA": "30083"
  },
  {
    "TITULO": "Ixmatlahuacan",
    "UBICACION_GEOGRAFICA": "30084"
  },
  {
    "TITULO": "Ixtaczoquitlán",
    "UBICACION_GEOGRAFICA": "30085"
  },
  {
    "TITULO": "Jalacingo",
    "UBICACION_GEOGRAFICA": "30086"
  },
  {
    "TITULO": "Xalapa",
    "UBICACION_GEOGRAFICA": "30087"
  },
  {
    "TITULO": "Jalcomulco",
    "UBICACION_GEOGRAFICA": "30088"
  },
  {
    "TITULO": "Jáltipan",
    "UBICACION_GEOGRAFICA": "30089"
  },
  {
    "TITULO": "Jamapa",
    "UBICACION_GEOGRAFICA": "30090"
  },
  {
    "TITULO": "Jesús Carranza",
    "UBICACION_GEOGRAFICA": "30091"
  },
  {
    "TITULO": "Xico",
    "UBICACION_GEOGRAFICA": "30092"
  },
  {
    "TITULO": "Jilotepec",
    "UBICACION_GEOGRAFICA": "30093"
  },
  {
    "TITULO": "Juan Rodríguez Clara",
    "UBICACION_GEOGRAFICA": "30094"
  },
  {
    "TITULO": "Juchique de Ferrer",
    "UBICACION_GEOGRAFICA": "30095"
  },
  {
    "TITULO": "Landero y Coss",
    "UBICACION_GEOGRAFICA": "30096"
  },
  {
    "TITULO": "Lerdo de Tejada",
    "UBICACION_GEOGRAFICA": "30097"
  },
  {
    "TITULO": "Magdalena",
    "UBICACION_GEOGRAFICA": "30098"
  },
  {
    "TITULO": "Maltrata",
    "UBICACION_GEOGRAFICA": "30099"
  },
  {
    "TITULO": "Manlio Fabio Altamirano",
    "UBICACION_GEOGRAFICA": "30100"
  },
  {
    "TITULO": "Mariano Escobedo",
    "UBICACION_GEOGRAFICA": "30101"
  },
  {
    "TITULO": "Martínez de la Torre",
    "UBICACION_GEOGRAFICA": "30102"
  },
  {
    "TITULO": "Mecatlán",
    "UBICACION_GEOGRAFICA": "30103"
  },
  {
    "TITULO": "Mecayapan",
    "UBICACION_GEOGRAFICA": "30104"
  },
  {
    "TITULO": "Medellín",
    "UBICACION_GEOGRAFICA": "30105"
  },
  {
    "TITULO": "Miahuatlán",
    "UBICACION_GEOGRAFICA": "30106"
  },
  {
    "TITULO": "Las Minas",
    "UBICACION_GEOGRAFICA": "30107"
  },
  {
    "TITULO": "Minatitlán",
    "UBICACION_GEOGRAFICA": "30108"
  },
  {
    "TITULO": "Misantla",
    "UBICACION_GEOGRAFICA": "30109"
  },
  {
    "TITULO": "Mixtla de Altamirano",
    "UBICACION_GEOGRAFICA": "30110"
  },
  {
    "TITULO": "Moloacán",
    "UBICACION_GEOGRAFICA": "30111"
  },
  {
    "TITULO": "Naolinco",
    "UBICACION_GEOGRAFICA": "30112"
  },
  {
    "TITULO": "Naranjal",
    "UBICACION_GEOGRAFICA": "30113"
  },
  {
    "TITULO": "Nautla",
    "UBICACION_GEOGRAFICA": "30114"
  },
  {
    "TITULO": "Nogales",
    "UBICACION_GEOGRAFICA": "30115"
  },
  {
    "TITULO": "Oluta",
    "UBICACION_GEOGRAFICA": "30116"
  },
  {
    "TITULO": "Omealca",
    "UBICACION_GEOGRAFICA": "30117"
  },
  {
    "TITULO": "Orizaba",
    "UBICACION_GEOGRAFICA": "30118"
  },
  {
    "TITULO": "Otatitlán",
    "UBICACION_GEOGRAFICA": "30119"
  },
  {
    "TITULO": "Oteapan",
    "UBICACION_GEOGRAFICA": "30120"
  },
  {
    "TITULO": "Ozuluama de Mascareñas",
    "UBICACION_GEOGRAFICA": "30121"
  },
  {
    "TITULO": "Pajapan",
    "UBICACION_GEOGRAFICA": "30122"
  },
  {
    "TITULO": "Pánuco",
    "UBICACION_GEOGRAFICA": "30123"
  },
  {
    "TITULO": "Papantla",
    "UBICACION_GEOGRAFICA": "30124"
  },
  {
    "TITULO": "Paso del Macho",
    "UBICACION_GEOGRAFICA": "30125"
  },
  {
    "TITULO": "Paso de Ovejas",
    "UBICACION_GEOGRAFICA": "30126"
  },
  {
    "TITULO": "La Perla",
    "UBICACION_GEOGRAFICA": "30127"
  },
  {
    "TITULO": "Perote",
    "UBICACION_GEOGRAFICA": "30128"
  },
  {
    "TITULO": "Platón Sánchez",
    "UBICACION_GEOGRAFICA": "30129"
  },
  {
    "TITULO": "Playa Vicente",
    "UBICACION_GEOGRAFICA": "30130"
  },
  {
    "TITULO": "Poza Rica de Hidalgo",
    "UBICACION_GEOGRAFICA": "30131"
  },
  {
    "TITULO": "Las Vigas de Ramírez",
    "UBICACION_GEOGRAFICA": "30132"
  },
  {
    "TITULO": "Pueblo Viejo",
    "UBICACION_GEOGRAFICA": "30133"
  },
  {
    "TITULO": "Puente Nacional",
    "UBICACION_GEOGRAFICA": "30134"
  },
  {
    "TITULO": "Rafael Delgado",
    "UBICACION_GEOGRAFICA": "30135"
  },
  {
    "TITULO": "Rafael Lucio",
    "UBICACION_GEOGRAFICA": "30136"
  },
  {
    "TITULO": "Los Reyes",
    "UBICACION_GEOGRAFICA": "30137"
  },
  {
    "TITULO": "Río Blanco",
    "UBICACION_GEOGRAFICA": "30138"
  },
  {
    "TITULO": "Saltabarranca",
    "UBICACION_GEOGRAFICA": "30139"
  },
  {
    "TITULO": "San Andrés Tenejapan",
    "UBICACION_GEOGRAFICA": "30140"
  },
  {
    "TITULO": "San Andrés Tuxtla",
    "UBICACION_GEOGRAFICA": "30141"
  },
  {
    "TITULO": "San Juan Evangelista",
    "UBICACION_GEOGRAFICA": "30142"
  },
  {
    "TITULO": "Santiago Tuxtla",
    "UBICACION_GEOGRAFICA": "30143"
  },
  {
    "TITULO": "Sayula de Alemán",
    "UBICACION_GEOGRAFICA": "30144"
  },
  {
    "TITULO": "Soconusco",
    "UBICACION_GEOGRAFICA": "30145"
  },
  {
    "TITULO": "Sochiapa",
    "UBICACION_GEOGRAFICA": "30146"
  },
  {
    "TITULO": "Soledad Atzompa",
    "UBICACION_GEOGRAFICA": "30147"
  },
  {
    "TITULO": "Soledad de Doblado",
    "UBICACION_GEOGRAFICA": "30148"
  },
  {
    "TITULO": "Soteapan",
    "UBICACION_GEOGRAFICA": "30149"
  },
  {
    "TITULO": "Tamalín",
    "UBICACION_GEOGRAFICA": "30150"
  },
  {
    "TITULO": "Tamiahua",
    "UBICACION_GEOGRAFICA": "30151"
  },
  {
    "TITULO": "Tampico Alto",
    "UBICACION_GEOGRAFICA": "30152"
  },
  {
    "TITULO": "Tancoco",
    "UBICACION_GEOGRAFICA": "30153"
  },
  {
    "TITULO": "Tantima",
    "UBICACION_GEOGRAFICA": "30154"
  },
  {
    "TITULO": "Tantoyuca",
    "UBICACION_GEOGRAFICA": "30155"
  },
  {
    "TITULO": "Tatatila",
    "UBICACION_GEOGRAFICA": "30156"
  },
  {
    "TITULO": "Castillo de Teayo",
    "UBICACION_GEOGRAFICA": "30157"
  },
  {
    "TITULO": "Tecolutla",
    "UBICACION_GEOGRAFICA": "30158"
  },
  {
    "TITULO": "Tehuipango",
    "UBICACION_GEOGRAFICA": "30159"
  },
  {
    "TITULO": "Álamo Temapache",
    "UBICACION_GEOGRAFICA": "30160"
  },
  {
    "TITULO": "Tempoal",
    "UBICACION_GEOGRAFICA": "30161"
  },
  {
    "TITULO": "Tenampa",
    "UBICACION_GEOGRAFICA": "30162"
  },
  {
    "TITULO": "Tenochtitlán",
    "UBICACION_GEOGRAFICA": "30163"
  },
  {
    "TITULO": "Teocelo",
    "UBICACION_GEOGRAFICA": "30164"
  },
  {
    "TITULO": "Tepatlaxco",
    "UBICACION_GEOGRAFICA": "30165"
  },
  {
    "TITULO": "Tepetlán",
    "UBICACION_GEOGRAFICA": "30166"
  },
  {
    "TITULO": "Tepetzintla",
    "UBICACION_GEOGRAFICA": "30167"
  },
  {
    "TITULO": "Tequila",
    "UBICACION_GEOGRAFICA": "30168"
  },
  {
    "TITULO": "José Azueta",
    "UBICACION_GEOGRAFICA": "30169"
  },
  {
    "TITULO": "Texcatepec",
    "UBICACION_GEOGRAFICA": "30170"
  },
  {
    "TITULO": "Texhuacán",
    "UBICACION_GEOGRAFICA": "30171"
  },
  {
    "TITULO": "Texistepec",
    "UBICACION_GEOGRAFICA": "30172"
  },
  {
    "TITULO": "Tezonapa",
    "UBICACION_GEOGRAFICA": "30173"
  },
  {
    "TITULO": "Tierra Blanca",
    "UBICACION_GEOGRAFICA": "30174"
  },
  {
    "TITULO": "Tihuatlán",
    "UBICACION_GEOGRAFICA": "30175"
  },
  {
    "TITULO": "Tlacojalpan",
    "UBICACION_GEOGRAFICA": "30176"
  },
  {
    "TITULO": "Tlacolulan",
    "UBICACION_GEOGRAFICA": "30177"
  },
  {
    "TITULO": "Tlacotalpan",
    "UBICACION_GEOGRAFICA": "30178"
  },
  {
    "TITULO": "Tlacotepec de Mejía",
    "UBICACION_GEOGRAFICA": "30179"
  },
  {
    "TITULO": "Tlachichilco",
    "UBICACION_GEOGRAFICA": "30180"
  },
  {
    "TITULO": "Tlalixcoyan",
    "UBICACION_GEOGRAFICA": "30181"
  },
  {
    "TITULO": "Tlalnelhuayocan",
    "UBICACION_GEOGRAFICA": "30182"
  },
  {
    "TITULO": "Tlapacoyan",
    "UBICACION_GEOGRAFICA": "30183"
  },
  {
    "TITULO": "Tlaquilpa",
    "UBICACION_GEOGRAFICA": "30184"
  },
  {
    "TITULO": "Tlilapan",
    "UBICACION_GEOGRAFICA": "30185"
  },
  {
    "TITULO": "Tomatlán",
    "UBICACION_GEOGRAFICA": "30186"
  },
  {
    "TITULO": "Tonayán",
    "UBICACION_GEOGRAFICA": "30187"
  },
  {
    "TITULO": "Totutla",
    "UBICACION_GEOGRAFICA": "30188"
  },
  {
    "TITULO": "Tuxpan",
    "UBICACION_GEOGRAFICA": "30189"
  },
  {
    "TITULO": "Tuxtilla",
    "UBICACION_GEOGRAFICA": "30190"
  },
  {
    "TITULO": "Ursulo Galván",
    "UBICACION_GEOGRAFICA": "30191"
  },
  {
    "TITULO": "Vega de Alatorre",
    "UBICACION_GEOGRAFICA": "30192"
  },
  {
    "TITULO": "Veracruz, Veracruz",
    "UBICACION_GEOGRAFICA": "30193"
  },
  {
    "TITULO": "Villa Aldama",
    "UBICACION_GEOGRAFICA": "30194"
  },
  {
    "TITULO": "Xoxocotla",
    "UBICACION_GEOGRAFICA": "30195"
  },
  {
    "TITULO": "Yanga",
    "UBICACION_GEOGRAFICA": "30196"
  },
  {
    "TITULO": "Yecuatla",
    "UBICACION_GEOGRAFICA": "30197"
  },
  {
    "TITULO": "Zacualpan",
    "UBICACION_GEOGRAFICA": "30198"
  },
  {
    "TITULO": "Zaragoza",
    "UBICACION_GEOGRAFICA": "30199"
  },
  {
    "TITULO": "Zentla",
    "UBICACION_GEOGRAFICA": "30200"
  },
  {
    "TITULO": "Zongolica",
    "UBICACION_GEOGRAFICA": "30201"
  },
  {
    "TITULO": "Zontecomatlán de López y Fuentes",
    "UBICACION_GEOGRAFICA": "30202"
  },
  {
    "TITULO": "Zozocolco de Hidalgo",
    "UBICACION_GEOGRAFICA": "30203"
  },
  {
    "TITULO": "Agua Dulce",
    "UBICACION_GEOGRAFICA": "30204"
  },
  {
    "TITULO": "El Higo",
    "UBICACION_GEOGRAFICA": "30205"
  },
  {
    "TITULO": "Nanchital de Lázaro Cárdenas del Río",
    "UBICACION_GEOGRAFICA": "30206"
  },
  {
    "TITULO": "Tres Valles",
    "UBICACION_GEOGRAFICA": "30207"
  },
  {
    "TITULO": "Carlos A. Carrillo",
    "UBICACION_GEOGRAFICA": "30208"
  },
  {
    "TITULO": "Tatahuicapan de Juárez",
    "UBICACION_GEOGRAFICA": "30209"
  },
  {
    "TITULO": "Uxpanapa",
    "UBICACION_GEOGRAFICA": "30210"
  },
  {
    "TITULO": "San Rafael",
    "UBICACION_GEOGRAFICA": "30211"
  },
  {
    "TITULO": "Santiago Sochiapan",
    "UBICACION_GEOGRAFICA": "30212"
  },
  {
    "TITULO": "Yucatán",
    "UBICACION_GEOGRAFICA": "31"
  },
  {
    "TITULO": "Abalá",
    "UBICACION_GEOGRAFICA": "31001"
  },
  {
    "TITULO": "Acanceh",
    "UBICACION_GEOGRAFICA": "31002"
  },
  {
    "TITULO": "Akil",
    "UBICACION_GEOGRAFICA": "31003"
  },
  {
    "TITULO": "Baca",
    "UBICACION_GEOGRAFICA": "31004"
  },
  {
    "TITULO": "Bokobá",
    "UBICACION_GEOGRAFICA": "31005"
  },
  {
    "TITULO": "Buctzotz",
    "UBICACION_GEOGRAFICA": "31006"
  },
  {
    "TITULO": "Cacalchén",
    "UBICACION_GEOGRAFICA": "31007"
  },
  {
    "TITULO": "Calotmul",
    "UBICACION_GEOGRAFICA": "31008"
  },
  {
    "TITULO": "Cansahcab",
    "UBICACION_GEOGRAFICA": "31009"
  },
  {
    "TITULO": "Cantamayec",
    "UBICACION_GEOGRAFICA": "31010"
  },
  {
    "TITULO": "Celestún",
    "UBICACION_GEOGRAFICA": "31011"
  },
  {
    "TITULO": "Cenotillo",
    "UBICACION_GEOGRAFICA": "31012"
  },
  {
    "TITULO": "Conkal",
    "UBICACION_GEOGRAFICA": "31013"
  },
  {
    "TITULO": "Cuncunul",
    "UBICACION_GEOGRAFICA": "31014"
  },
  {
    "TITULO": "Cuzamá",
    "UBICACION_GEOGRAFICA": "31015"
  },
  {
    "TITULO": "Chacsinkín",
    "UBICACION_GEOGRAFICA": "31016"
  },
  {
    "TITULO": "Chankom",
    "UBICACION_GEOGRAFICA": "31017"
  },
  {
    "TITULO": "Chapab",
    "UBICACION_GEOGRAFICA": "31018"
  },
  {
    "TITULO": "Chemax",
    "UBICACION_GEOGRAFICA": "31019"
  },
  {
    "TITULO": "Chicxulub Pueblo",
    "UBICACION_GEOGRAFICA": "31020"
  },
  {
    "TITULO": "Chichimilá",
    "UBICACION_GEOGRAFICA": "31021"
  },
  {
    "TITULO": "Chikindzonot",
    "UBICACION_GEOGRAFICA": "31022"
  },
  {
    "TITULO": "Chocholá",
    "UBICACION_GEOGRAFICA": "31023"
  },
  {
    "TITULO": "Chumayel",
    "UBICACION_GEOGRAFICA": "31024"
  },
  {
    "TITULO": "Dzán",
    "UBICACION_GEOGRAFICA": "31025"
  },
  {
    "TITULO": "Dzemul",
    "UBICACION_GEOGRAFICA": "31026"
  },
  {
    "TITULO": "Dzidzantún",
    "UBICACION_GEOGRAFICA": "31027"
  },
  {
    "TITULO": "Dzilam de Bravo",
    "UBICACION_GEOGRAFICA": "31028"
  },
  {
    "TITULO": "Dzilam González",
    "UBICACION_GEOGRAFICA": "31029"
  },
  {
    "TITULO": "Dzitás",
    "UBICACION_GEOGRAFICA": "31030"
  },
  {
    "TITULO": "Dzoncauich",
    "UBICACION_GEOGRAFICA": "31031"
  },
  {
    "TITULO": "Espita",
    "UBICACION_GEOGRAFICA": "31032"
  },
  {
    "TITULO": "Halachó",
    "UBICACION_GEOGRAFICA": "31033"
  },
  {
    "TITULO": "Hocabá",
    "UBICACION_GEOGRAFICA": "31034"
  },
  {
    "TITULO": "Hoctún",
    "UBICACION_GEOGRAFICA": "31035"
  },
  {
    "TITULO": "Homún",
    "UBICACION_GEOGRAFICA": "31036"
  },
  {
    "TITULO": "Huhí",
    "UBICACION_GEOGRAFICA": "31037"
  },
  {
    "TITULO": "Hunucmá",
    "UBICACION_GEOGRAFICA": "31038"
  },
  {
    "TITULO": "Ixil",
    "UBICACION_GEOGRAFICA": "31039"
  },
  {
    "TITULO": "Izamal",
    "UBICACION_GEOGRAFICA": "31040"
  },
  {
    "TITULO": "Kanasín",
    "UBICACION_GEOGRAFICA": "31041"
  },
  {
    "TITULO": "Kantunil",
    "UBICACION_GEOGRAFICA": "31042"
  },
  {
    "TITULO": "Kaua",
    "UBICACION_GEOGRAFICA": "31043"
  },
  {
    "TITULO": "Kinchil",
    "UBICACION_GEOGRAFICA": "31044"
  },
  {
    "TITULO": "Kopomá",
    "UBICACION_GEOGRAFICA": "31045"
  },
  {
    "TITULO": "Mama",
    "UBICACION_GEOGRAFICA": "31046"
  },
  {
    "TITULO": "Maní",
    "UBICACION_GEOGRAFICA": "31047"
  },
  {
    "TITULO": "Maxcanú",
    "UBICACION_GEOGRAFICA": "31048"
  },
  {
    "TITULO": "Mayapán",
    "UBICACION_GEOGRAFICA": "31049"
  },
  {
    "TITULO": "Mérida",
    "UBICACION_GEOGRAFICA": "31050"
  },
  {
    "TITULO": "Mocochá",
    "UBICACION_GEOGRAFICA": "31051"
  },
  {
    "TITULO": "Motul",
    "UBICACION_GEOGRAFICA": "31052"
  },
  {
    "TITULO": "Muna",
    "UBICACION_GEOGRAFICA": "31053"
  },
  {
    "TITULO": "Muxupip",
    "UBICACION_GEOGRAFICA": "31054"
  },
  {
    "TITULO": "Opichén",
    "UBICACION_GEOGRAFICA": "31055"
  },
  {
    "TITULO": "Oxkutzcab",
    "UBICACION_GEOGRAFICA": "31056"
  },
  {
    "TITULO": "Panabá",
    "UBICACION_GEOGRAFICA": "31057"
  },
  {
    "TITULO": "Peto",
    "UBICACION_GEOGRAFICA": "31058"
  },
  {
    "TITULO": "Progreso",
    "UBICACION_GEOGRAFICA": "31059"
  },
  {
    "TITULO": "Quintana Roo, yucatan",
    "UBICACION_GEOGRAFICA": "31060"
  },
  {
    "TITULO": "Río Lagartos",
    "UBICACION_GEOGRAFICA": "31061"
  },
  {
    "TITULO": "Sacalum",
    "UBICACION_GEOGRAFICA": "31062"
  },
  {
    "TITULO": "Samahil",
    "UBICACION_GEOGRAFICA": "31063"
  },
  {
    "TITULO": "Sanahcat",
    "UBICACION_GEOGRAFICA": "31064"
  },
  {
    "TITULO": "San Felipe",
    "UBICACION_GEOGRAFICA": "31065"
  },
  {
    "TITULO": "Santa Elena",
    "UBICACION_GEOGRAFICA": "31066"
  },
  {
    "TITULO": "Seyé",
    "UBICACION_GEOGRAFICA": "31067"
  },
  {
    "TITULO": "Sinanché",
    "UBICACION_GEOGRAFICA": "31068"
  },
  {
    "TITULO": "Sotuta",
    "UBICACION_GEOGRAFICA": "31069"
  },
  {
    "TITULO": "Sucilá",
    "UBICACION_GEOGRAFICA": "31070"
  },
  {
    "TITULO": "Sudzal",
    "UBICACION_GEOGRAFICA": "31071"
  },
  {
    "TITULO": "Suma",
    "UBICACION_GEOGRAFICA": "31072"
  },
  {
    "TITULO": "Tahdziú",
    "UBICACION_GEOGRAFICA": "31073"
  },
  {
    "TITULO": "Tahmek",
    "UBICACION_GEOGRAFICA": "31074"
  },
  {
    "TITULO": "Teabo",
    "UBICACION_GEOGRAFICA": "31075"
  },
  {
    "TITULO": "Tecoh",
    "UBICACION_GEOGRAFICA": "31076"
  },
  {
    "TITULO": "Tekal de Venegas",
    "UBICACION_GEOGRAFICA": "31077"
  },
  {
    "TITULO": "Tekantó",
    "UBICACION_GEOGRAFICA": "31078"
  },
  {
    "TITULO": "Tekax",
    "UBICACION_GEOGRAFICA": "31079"
  },
  {
    "TITULO": "Tekit",
    "UBICACION_GEOGRAFICA": "31080"
  },
  {
    "TITULO": "Tekom",
    "UBICACION_GEOGRAFICA": "31081"
  },
  {
    "TITULO": "Telchac Pueblo",
    "UBICACION_GEOGRAFICA": "31082"
  },
  {
    "TITULO": "Telchac Puerto",
    "UBICACION_GEOGRAFICA": "31083"
  },
  {
    "TITULO": "Temax",
    "UBICACION_GEOGRAFICA": "31084"
  },
  {
    "TITULO": "Temozón",
    "UBICACION_GEOGRAFICA": "31085"
  },
  {
    "TITULO": "Tepakán",
    "UBICACION_GEOGRAFICA": "31086"
  },
  {
    "TITULO": "Tetiz",
    "UBICACION_GEOGRAFICA": "31087"
  },
  {
    "TITULO": "Teya",
    "UBICACION_GEOGRAFICA": "31088"
  },
  {
    "TITULO": "Ticul",
    "UBICACION_GEOGRAFICA": "31089"
  },
  {
    "TITULO": "Timucuy",
    "UBICACION_GEOGRAFICA": "31090"
  },
  {
    "TITULO": "Tinum",
    "UBICACION_GEOGRAFICA": "31091"
  },
  {
    "TITULO": "Tixcacalcupul",
    "UBICACION_GEOGRAFICA": "31092"
  },
  {
    "TITULO": "Tixkokob",
    "UBICACION_GEOGRAFICA": "31093"
  },
  {
    "TITULO": "Tixmehuac",
    "UBICACION_GEOGRAFICA": "31094"
  },
  {
    "TITULO": "Tixpéhual",
    "UBICACION_GEOGRAFICA": "31095"
  },
  {
    "TITULO": "Tizimín",
    "UBICACION_GEOGRAFICA": "31096"
  },
  {
    "TITULO": "Tunkás",
    "UBICACION_GEOGRAFICA": "31097"
  },
  {
    "TITULO": "Tzucacab",
    "UBICACION_GEOGRAFICA": "31098"
  },
  {
    "TITULO": "Uayma",
    "UBICACION_GEOGRAFICA": "31099"
  },
  {
    "TITULO": "Ucú",
    "UBICACION_GEOGRAFICA": "31100"
  },
  {
    "TITULO": "Umán",
    "UBICACION_GEOGRAFICA": "31101"
  },
  {
    "TITULO": "Valladolid",
    "UBICACION_GEOGRAFICA": "31102"
  },
  {
    "TITULO": "Xocchel",
    "UBICACION_GEOGRAFICA": "31103"
  },
  {
    "TITULO": "Yaxcabá",
    "UBICACION_GEOGRAFICA": "31104"
  },
  {
    "TITULO": "Yaxkukul",
    "UBICACION_GEOGRAFICA": "31105"
  },
  {
    "TITULO": "Yobaín",
    "UBICACION_GEOGRAFICA": "31106"
  },
  {
    "TITULO": "Zacatecas",
    "UBICACION_GEOGRAFICA": "32"
  },
  {
    "TITULO": "Apozol",
    "UBICACION_GEOGRAFICA": "32001"
  },
  {
    "TITULO": "Apulco",
    "UBICACION_GEOGRAFICA": "32002"
  },
  {
    "TITULO": "Atolinga",
    "UBICACION_GEOGRAFICA": "32003"
  },
  {
    "TITULO": "Benito Juárez",
    "UBICACION_GEOGRAFICA": "32004"
  },
  {
    "TITULO": "Calera",
    "UBICACION_GEOGRAFICA": "32005"
  },
  {
    "TITULO": "Cañitas de Felipe Pescador",
    "UBICACION_GEOGRAFICA": "32006"
  },
  {
    "TITULO": "Concepción del Oro",
    "UBICACION_GEOGRAFICA": "32007"
  },
  {
    "TITULO": "Cuauhtémoc",
    "UBICACION_GEOGRAFICA": "32008"
  },
  {
    "TITULO": "Chalchihuites",
    "UBICACION_GEOGRAFICA": "32009"
  },
  {
    "TITULO": "Fresnillo",
    "UBICACION_GEOGRAFICA": "32010"
  },
  {
    "TITULO": "Trinidad García de la Cadena",
    "UBICACION_GEOGRAFICA": "32011"
  },
  {
    "TITULO": "Genaro Codina",
    "UBICACION_GEOGRAFICA": "32012"
  },
  {
    "TITULO": "General Enrique Estrada",
    "UBICACION_GEOGRAFICA": "32013"
  },
  {
    "TITULO": "General Francisco R. Murguía",
    "UBICACION_GEOGRAFICA": "32014"
  },
  {
    "TITULO": "El Plateado de Joaquín Amaro",
    "UBICACION_GEOGRAFICA": "32015"
  },
  {
    "TITULO": "General Pánfilo Natera",
    "UBICACION_GEOGRAFICA": "32016"
  },
  {
    "TITULO": "Guadalupe",
    "UBICACION_GEOGRAFICA": "32017"
  },
  {
    "TITULO": "Huanusco",
    "UBICACION_GEOGRAFICA": "32018"
  },
  {
    "TITULO": "Jalpa",
    "UBICACION_GEOGRAFICA": "32019"
  },
  {
    "TITULO": "Jerez",
    "UBICACION_GEOGRAFICA": "32020"
  },
  {
    "TITULO": "Jiménez del Teul",
    "UBICACION_GEOGRAFICA": "32021"
  },
  {
    "TITULO": "Juan Aldama",
    "UBICACION_GEOGRAFICA": "32022"
  },
  {
    "TITULO": "Juchipila",
    "UBICACION_GEOGRAFICA": "32023"
  },
  {
    "TITULO": "Loreto",
    "UBICACION_GEOGRAFICA": "32024"
  },
  {
    "TITULO": "Luis Moya",
    "UBICACION_GEOGRAFICA": "32025"
  },
  {
    "TITULO": "Mazapil",
    "UBICACION_GEOGRAFICA": "32026"
  },
  {
    "TITULO": "Melchor Ocampo",
    "UBICACION_GEOGRAFICA": "32027"
  },
  {
    "TITULO": "Mezquital del Oro",
    "UBICACION_GEOGRAFICA": "32028"
  },
  {
    "TITULO": "Miguel Auza",
    "UBICACION_GEOGRAFICA": "32029"
  },
  {
    "TITULO": "Momax",
    "UBICACION_GEOGRAFICA": "32030"
  },
  {
    "TITULO": "Monte Escobedo",
    "UBICACION_GEOGRAFICA": "32031"
  },
  {
    "TITULO": "Morelos",
    "UBICACION_GEOGRAFICA": "32032"
  },
  {
    "TITULO": "Moyahua de Estrada",
    "UBICACION_GEOGRAFICA": "32033"
  },
  {
    "TITULO": "Nochistlán de Mejía",
    "UBICACION_GEOGRAFICA": "32034"
  },
  {
    "TITULO": "Noria de Ángeles",
    "UBICACION_GEOGRAFICA": "32035"
  },
  {
    "TITULO": "Ojocaliente",
    "UBICACION_GEOGRAFICA": "32036"
  },
  {
    "TITULO": "Pánuco",
    "UBICACION_GEOGRAFICA": "32037"
  },
  {
    "TITULO": "Pinos",
    "UBICACION_GEOGRAFICA": "32038"
  },
  {
    "TITULO": "Río Grande",
    "UBICACION_GEOGRAFICA": "32039"
  },
  {
    "TITULO": "Sain Alto",
    "UBICACION_GEOGRAFICA": "32040"
  },
  {
    "TITULO": "El Salvador",
    "UBICACION_GEOGRAFICA": "32041"
  },
  {
    "TITULO": "Sombrerete",
    "UBICACION_GEOGRAFICA": "32042"
  },
  {
    "TITULO": "Susticacán",
    "UBICACION_GEOGRAFICA": "32043"
  },
  {
    "TITULO": "Tabasco, Zacatecas",
    "UBICACION_GEOGRAFICA": "32044"
  },
  {
    "TITULO": "Tepechitlán",
    "UBICACION_GEOGRAFICA": "32045"
  },
  {
    "TITULO": "Tepetongo",
    "UBICACION_GEOGRAFICA": "32046"
  },
  {
    "TITULO": "Teúl de González Ortega",
    "UBICACION_GEOGRAFICA": "32047"
  },
  {
    "TITULO": "Tlaltenango de Sánchez Román",
    "UBICACION_GEOGRAFICA": "32048"
  },
  {
    "TITULO": "Valparaíso",
    "UBICACION_GEOGRAFICA": "32049"
  },
  {
    "TITULO": "Vetagrande",
    "UBICACION_GEOGRAFICA": "32050"
  },
  {
    "TITULO": "Villa de Cos",
    "UBICACION_GEOGRAFICA": "32051"
  },
  {
    "TITULO": "Villa García",
    "UBICACION_GEOGRAFICA": "32052"
  },
  {
    "TITULO": "Villa González Ortega",
    "UBICACION_GEOGRAFICA": "32053"
  },
  {
    "TITULO": "Villa Hidalgo",
    "UBICACION_GEOGRAFICA": "32054"
  },
  {
    "TITULO": "Villanueva",
    "UBICACION_GEOGRAFICA": "32055"
  },
  {
    "TITULO": "Zacatecas, Zacatecas",
    "UBICACION_GEOGRAFICA": "32056"
  },
  {
    "TITULO": "Trancoso",
    "UBICACION_GEOGRAFICA": "32057"
  },
  {
    "TITULO": "Santa María de la Paz",
    "UBICACION_GEOGRAFICA": "32058"
  }
]